/**
 * EVO — ruscha lug'at (AVTOMATIK YIG'ILGAN).
 *
 * ╔══════════════════════════════════════════════════════════════════════════╗
 * ║ QO'LDA TAHRIRLASH MUMKIN                                                 ║
 * ║                                                                          ║
 * ║ Bu fayl bir marta yig'ilgan va shundan keyin ODDIY manba fayli. Bitta    ║
 * ║ noto'g'ri tarjimani tuzatish uchun shu yerda o'zgartirish kifoya.        ║
 * ╚══════════════════════════════════════════════════════════════════════════╝
 *
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │ QISMAN TO'LDIRILGAN — VA BU ATAYLAB                                      │
 * │                                                                          │
 * │ Tip `Partial`: bu yerda YO'Q kalit `uz` dan olinadi. Ya'ni yangi ekran   │
 * │ qo'shilganda tarjimasi kechiksa ham, ekran O'ZBEKCHA to'liq ishlaydi —   │
 * │ bo'sh joy yoki kalit nomi chiqmaydi.                                     │
 * │                                                                          │
 * │ `{param}` o'rin egallari MANBA bilan bir xilligi tekshirilgan: mos       │
 * │ kelmagan tarjima bu yerga UMUMAN tushmagan va o'zbekcha qolgan. Sababi   │
 * │ oddiy: `{count}` yo'qolgan matn to'g'ri o'qiladi, faqat raqamsiz — va    │
 * │ bunday xatoni hech kim ko'z bilan topolmaydi.                            │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️ Yangi kalit AVVAL `i18n.ts` dagi `uz` ga qo'shiladi — `TranslationKey`
 * o'sha yerdan hosil bo'ladi.
 */
import type { TranslationKey } from './i18n';

export const ru: Partial<Record<TranslationKey, string>> = {
  'month.1': 'Январь',
  'month.2': 'Февраль',
  'month.3': 'Март',
  'month.4': 'Апрель',
  'month.5': 'Май',
  'month.6': 'Июнь',
  'month.7': 'Июль',
  'month.8': 'Август',
  'month.9': 'Сентябрь',
  'month.10': 'Октябрь',
  'month.11': 'Ноябрь',
  'month.12': 'Декабрь',
  'norm.title': 'Норматив дисциплины',
  'norm.standard': 'Стандарт компании',
  'norm.overridden': 'изменено месяцев: {count}',
  'norm.month': 'Месяц',
  'norm.purchase': 'Закуп / остаток, %',
  'norm.payment': 'Оплата / закуп, %',
  'norm.collection': 'Оплата / (остаток+закуп), %',
  'norm.reset': 'Вернуть стандарт',
  'norm.invalid': 'Неверный формат процента: 0..5000, до двух знаков.',
  'norm.hint': 'ПУСТАЯ ячейка — применяется стандарт компании (показан серым), и он меняется вместе со стандартом в следующем году. Заполненная ячейка переопределяет только этот месяц — так записывается «у этого дилера декабрь другой». Норматив используется в отчёте «Отчёты → Дисциплина клиента».',
  'common.loading': 'Загрузка…',
  'common.save': 'Сохранить',
  'common.cancel': 'Отмена',
  'common.edit': 'Изменить',
  'common.close': 'Закрыть',
  'common.retry': 'Повторить',
  'common.search': 'Поиск',
  'common.prev': 'Назад',
  'common.next': 'Вперёд',
  'availability.title': 'Где есть в наличии?',
  'availability.hint': 'Остаток по всем филиалам и центральному складу. Товар, который закончился в вашем филиале, может быть на другом складе — это видно здесь.',
  'availability.search': 'Товар',
  'availability.searchPlaceholder': 'Код или название…',
  'availability.scarceOnly': 'Только заканчивающиеся',
  'availability.totalAvailable': 'Всего доступно',
  'availability.inTransit': 'В пути',
  'availability.transitShort': 'в пути',
  'availability.scarce': 'Заканчивается',
  'availability.empty': 'Товары не найдены',
  'availability.emptyHint': 'Проверьте код или название. Товары с нулевым остатком в список не попадают.',
  'availability.total': '{count} товаров',
  'common.noData': 'Нет данных',
  'common.error': 'Ошибка',
  'common.unknownError': 'Произошла неизвестная ошибка',
  'common.networkError': 'Не удалось подключиться к серверу. Проверьте интернет.',
  'common.today': 'Сегодня',
  'common.yes': 'Да',
  'common.no': 'Нет',
  'common.back': 'Назад',
  'common.create': 'Создать',
  'common.creating': 'Создание…',
  'common.saving': 'Сохранение…',
  'common.saved': 'Сохранено',
  'common.reload': 'Перезагрузить',
  'common.clear': 'Очистить',
  'common.notSet': 'Не задано',
  'common.reason': 'Причина',
  'common.optional': 'необязательно',
  'common.remove': 'Удалить',
  'common.apply': 'Применить',
  'common.refresh': 'Обновить',
  'common.of': '{done} / {total}',
  'search.hint': 'Клавиша «/» переводит курсор в поиск',
  'search.clear': 'Очистить поиск',
  'search.searching': 'Поиск…',
  'search.noResults': 'Ничего не найдено',
  'search.openResult': 'Открыть',
  'search.commandOpen': 'Глобальный поиск (Ctrl+K)',
  'search.commandTitle': 'Глобальный поиск',
  'search.commandPlaceholder': 'Номер документа, SKU, штрихкод, клиент, телефон… — например SO-2026-00042',
  'search.commandHint': 'Введите не менее 2 символов',
  'search.commandKeys': '↑ ↓ — выбор · Enter — открыть · Esc — закрыть',
  'search.commandFailed': 'Не удалось выполнить поиск. Попробуйте ещё раз.',
  'search.recentTitle': 'Недавно открытые',
  'search.sectionsTitle': 'Разделы',
  // --- Горячие клавиши ---
  'keys.title': 'Горячие клавиши',
  'keys.hint': 'Это окно открывается клавишей «?» в любом месте.',
  'keys.palette': 'Окно поиска и разделов',
  'keys.help': 'Открыть это окно',
  'keys.focusSearch': 'Перейти к поиску на экране',
  'keys.completeSale': 'ЗАВЕРШИТЬ продажу — движение денег',
  'keys.newSale': 'Начать новую продажу',
  'keys.openRow': 'Открыть строку',
  'keys.addRow': 'Добавить строку',
  'keys.close': 'Закрыть окно',
  'keys.move': 'Вверх/вниз по списку',
  'keys.where.anywhere': 'везде',
  'keys.where.outsideField': 'вне поля ввода',
  'keys.where.listScreens': 'на экранах списков',
  'keys.where.directSale': 'прямая продажа',
  'keys.where.tables': 'в таблицах',
  'keys.where.editTables': 'в редактируемой таблице',
  'keys.where.dialogs': 'в окнах',
  'keys.where.lists': 'в списках',
  'search.inactive': 'неактивен',
  'search.type.product': 'Товары',
  'search.type.customer': 'Клиенты',
  'search.type.supplier': 'Поставщики',
  'search.type.salesOrder': 'Заказы покупателей',
  'search.type.purchaseOrder': 'Заказы поставщикам',
  'search.type.shipment': 'Контейнеры',
  'search.type.invoice': 'Счета-фактуры',
  'search.type.payment': 'Платежи',
  'search.type.return': 'Возвраты',
  'search.type.installer': 'Мастера',
  'search.type.delivery': 'Доставки',
  'search.type.creditNote': 'Кредит-ноты',
  'search.type.expense': 'Расходы филиала',
  'search.type.goodsReceipt': 'Приход товара',
  'search.type.employee': 'Сотрудники',
  'form.required': 'Это поле обязательно для заполнения',
  'form.hasErrors': 'В форме есть ошибки — проверьте отмеченные поля',
  'product.title': 'Товары',
  'ref.categories': 'Категории',
  'ref.brands': 'Бренды',
  'ref.uoms': 'Единицы измерения',
  'ref.newTitle': 'Новая запись',
  'ref.editTitle': 'Изменить запись',
  'ref.code': 'Код',
  'ref.name': 'Наименование',
  'ref.parent': 'Родительская категория',
  'ref.parentRoot': '— корень (без родителя) —',
  'ref.status': 'Статус',
  'ref.active': 'Активна',
  'ref.archivedBadge': 'В архиве',
  'ref.archive': 'В архив',
  'ref.restore': 'Восстановить',
  'ref.showArchived': 'Показывать и архивные',
  'ref.total': 'Всего: {count}',
  'ref.empty': 'Записей пока нет — добавьте формой выше',
  'ref.created': 'Добавлено',
  'ref.updated': 'Сохранено',
  'ref.archived': 'Отправлено в архив',
  'ref.restored': 'Восстановлено',
  'ref.archiveHint':
    'Записи НЕ удаляются, а архивируются: привязанные к ним товары должны продолжать показывать свою категорию и бренд, иначе прошлогодний отчёт выглядел бы иначе. Архивная запись не появляется в новых выпадающих списках.',
  'product.new': 'Новый товар',
  'product.newTitle': 'Создание нового товара',
  'product.searchPlaceholder': 'Поиск по SKU, названию или старому коду 1С',
  'product.sku': 'SKU',
  'product.name': 'Название',
  'product.nameUz': 'Название (узбекское)',
  'product.nameRu': 'Название (русское)',
  'product.nameEn': 'Название (английское)',
  'product.category': 'Категория',
  'product.categoryAll': 'Все категории',
  'product.brandAll': 'Все бренды',
  'product.importFile': 'Загрузить из файла',
  'product.brand': 'Бренд',
  'product.uom': 'Единица измерения',
  'product.availableStock': 'Свободный остаток',
  'product.avgCost': 'Средняя себестоимость',
  'product.avgCostHint': 'Себестоимость рассчитывается по движениям склада и вручную не вводится.',
  'product.costBlock': 'Себестоимость',
  'product.description': 'Описание',
  'product.weightKg': 'Вес, кг',
  'product.volumeM3': 'Объём, м³',
  'product.minStock': 'Минимальный остаток',
  'product.maxStock': 'Максимальный остаток',
  'product.reorderPoint': 'Точка заказа',
  'product.vatRate': 'Ставка НДС, %',
  'product.vatRatePlaceholder': 'Стандартная (из настроек)',
  'product.vatRateHint': 'Цена указывается С НДС — налог не добавляется сверху, а выделяется из цены. При ставке 12% в товаре стоимостью 11 200 сум налог составляет 1 200 сум. Для экспорта и льготных товаров оставьте 0: 0 означает не «не заполнено», а «без налога».',
  'product.isSellable': 'Продаётся',
  'product.isPurchasable': 'Закупается',
  'product.attributes': 'Характеристики',
  'product.aliases': 'Альтернативные коды',
  'product.aliasesHint': 'Старый код 1С, код поставщика или код упаковки. Сотрудник ещё месяцами будет вводить именно его — если код не заполнен, поиск ничего не найдёт и появится дубликат.',
  'product.alias': 'Код',
  'product.aliasType': 'Тип',
  'product.aliasSource': 'Источник',
  'product.aliasAdd': 'Добавить код',
  'product.aliasRemove': 'Удалить код',
  'product.aliasType.legacy': 'Старая система',
  'product.aliasType.adines': 'Adines',
  'product.aliasType.1c': '1С',
  'product.aliasType.supplier': 'Поставщик',
  'product.aliasType.custom': 'Другое',
  'product.status': 'Статус',
  'product.active': 'Активен',
  'product.archived': 'В архиве',
  'product.version': 'Версия',
  'product.updatedAt': 'Последнее изменение',
  'product.empty': 'Товары не найдены',
  'product.emptyHint': 'Каталог пока пуст или фильтр слишком узкий.',
  'product.emptySearch': 'По запросу «{q}» товары не найдены',
  'product.emptySearchHint': 'Попробуйте также старый код — поиск одинаково воспринимает латиницу и кириллицу.',
  'product.loadError': 'Не удалось загрузить список товаров',
  'product.notFound': 'Товар не найден или недоступен вам',
  'product.selectCategory': 'Выберите категорию',
  'product.noBrand': 'Без бренда',
  'product.saved': 'Изменения сохранены',
  'product.created': 'Товар создан',
  'product.editTitle': 'Редактирование товара',
  'product.conflict.title': 'Запись изменена другим пользователем',
  'product.conflict.body': 'Пока вы держали карточку открытой, кто-то успел её сохранить. Ваши изменения НЕ ЗАПИСАНЫ — чтобы не затереть более свежие данные. Загрузите новое состояние и внесите правки заново.',
  'product.conflict.reload': 'Загрузить новое состояние',
  'product.duplicate.title': 'Похожий товар уже существует',
  'product.duplicate.body': 'Перечисленные позиции уже есть в каталоге. Сначала проверьте их: если один товар заведён под двумя SKU, остаток и себестоимость разделятся надвое.',
  'product.duplicate.force': 'Всё равно создать',
  'product.duplicate.cancel': 'Отменить и проверить',
  'product.skuExists': 'Такой SKU уже существует — выберите другой код',
  'customer.title': 'Клиенты',
  'customer.searchPlaceholder': 'Код, название или телефон',
  'customer.searchHint': 'Телефон можно вводить в любом виде: найдётся и +998 90 123-45-67, и 901234567.',
  'customer.newTitle': 'Новый клиент',
  'customer.newHint': 'Кредитного лимита, условий договора и норматива дисциплины здесь НЕТ — они задаются на карточке после создания, в своих разделах, и требуют другого права. После сохранения откроется карточка.',
  'customer.codeHint': 'Уникальный код. Позже изменить нельзя — на него ссылаются документы.',
  'customer.priceList': 'Прайс-лист',
  'customer.priceListDefault': '— стандартный прайс —',
  'customer.code': 'Код',
  'customer.name': 'Название',
  'customer.type': 'Тип',
  'customer.type.retail': 'Розница',
  'customer.type.wholesale': 'Опт',
  'customer.type.dealer': 'Дилер',
  'customer.type.key_account': 'Крупный клиент',
  'customer.phone': 'Телефон',
  'customer.email': 'Email',
  'customer.address': 'Адрес',
  'customer.taxId': 'ИНН',
  'customer.profile': 'Общие сведения',
  'customer.contacts': 'Контакты',
  'customer.contactsEmpty': 'Контакты не указаны',
  'customer.contactsOrg': 'Реквизиты организации',
  'customer.contactsPeople': 'Представители',
  'customer.contactsPeopleHint': 'Заказ размещает один человек, платит другой — здесь видно, кому звонить.',
  'customer.contactPrimary': 'Основной',
  'customer.contactsLoadError': 'Не удалось загрузить контакты',
  'customer.credit': 'Условия кредита',
  'customer.creditLimit': 'Кредитный лимит',
  'customer.creditLimitNone': 'Лимит не установлен',
  'customer.creditEdit': 'Изменить условия кредита',
  'customer.creditEditTitle': 'Условия кредита',
  'customer.creditEditHint': 'Лимит — это то, на какую сумму клиенту можно отгружать товар в долг. Прежде чем повышать его, проверьте ТЕКУЩИЙ долг клиента в отчёте «Дебиторская задолженность (AR)»: лимит и долг — разные величины.',
  'customer.creditLimitAmount': 'Сумма лимита',
  'customer.creditLimitCurrency': 'Валюта лимита',
  'customer.creditLimitZeroHint': '0 — это не «без лимита», а «в долг не отпускать».',
  'customer.creditTermDays': 'Срок оплаты (дней)',
  'customer.creditTermDaysHint': '0 — только предоплата. Максимум 365 дней.',
  'customer.creditAmountInvalid': 'Сумма должна быть неотрицательным числом',
  'customer.creditTermInvalid': 'Срок должен быть целым числом от 0 до 365',
  'customer.creditNoChanges': 'Ничего не изменено',
  'customer.creditSaved': 'Условия кредита сохранены',
  'customer.paymentTerms': 'Срок оплаты',
  'customer.paymentTermsDays': '{days} дней',
  'customer.paymentTermsPrepaid': 'Только предоплата',
  'customer.blocked': 'Заблокирован',
  'customer.notBlocked': 'Активен',
  'customer.archived': 'В архиве',
  'customer.blockReason': 'Причина блокировки',
  'customer.block': 'Заблокировать',
  'customer.unblock': 'Разблокировать',
  'customer.blockTitle': 'Блокировка клиента',
  'customer.unblockTitle': 'Разблокировка клиента',
  'customer.blockHint': 'Заблокированный клиент остаётся в списке, его задолженность продолжает учитываться, но оформить на него новый заказ нельзя.',
  'customer.blockReasonRequired': 'Причина должна содержать не менее 3 символов',
  'customer.blockReasonWhy': 'Вопрос «за что заблокирован?» обязательно возникнет через неделю — причина сохраняется в журнале аудита.',
  'customer.empty': 'Клиенты не найдены',
  'customer.emptyHint': 'Список пуст или клиенты вам не назначены.',
  'customer.emptySearch': 'По запросу «{q}» клиенты не найдены',
  'customer.loadError': 'Не удалось загрузить список клиентов',
  'customer.notFound': 'Клиент не найден или недоступен вам',
  'customer.fxPolicy': 'Кто несёт курсовую разницу',
  'customer.fxPolicy.payment_date.short': 'Курс на дату платежа',
  'customer.fxPolicy.sale_date.short': 'Курс на дату продажи',
  'customer.fxPolicy.payment_date.full': 'При оплате долларового долга в сумах применяется курс НА ДАТУ ПЛАТЕЖА — курсовую разницу покрывает КЛИЕНТ.',
  'customer.fxPolicy.sale_date.full': 'При оплате долларового долга в сумах фиксируется курс НА ДАТУ ПРОДАЖИ — курсовую разницу берёт на себя КОМПАНИЯ.',
  'auth.login.title': 'Вход в систему',
  'auth.login.subtitle': 'Введите email и пароль',
  'auth.email': 'Email',
  'auth.email.placeholder': 'name@company.uz',
  'auth.password': 'Пароль',
  'auth.password.placeholder': 'Ваш пароль',
  'auth.submit': 'Войти',
  'auth.submitting': 'Вход…',
  'auth.error.invalidCredentials': 'Неверный email или пароль',
  'auth.error.required': 'Email и пароль обязательны для заполнения',
  'auth.logout': 'Выйти',
  'auth.sessionExpired': 'Срок сессии истёк. Войдите заново.',
  'auth.restoring': 'Восстановление сессии…',
  'fx.title': 'Курс на день',
  'fx.rateLine': '1 USD = {rate}',
  'fx.missing': 'Курс на сегодня не введён',
  'fx.missingHint': 'Документы, введённые без курса, впоследствии не пересчитываются.',
  'fx.stale': 'Последний курс: {date}',
  'fx.edit': 'Ввести курс',
  'fx.editTitle': 'Ввод курса на сегодня',
  'fx.loading': 'Загрузка курса…',
  'fx.editHint': 'Документы, созданные после ввода, ФИКСИРУЮТ этот курс и впоследствии не пересчитываются. Если курс указан неверно, документ придётся отменить и провести заново.',
  'fx.uzsLabel': '1 USD = ? сум (продажи и касса)',
  'fx.cnyLabel': '1 USD = ? ¥ (закупки, заводы Китая)',
  'fx.saved': 'Курс сохранён: {currencies}',
  'fx.noChange': 'Значение не изменилось',
  'nav.skipToContent': 'Перейти к основному содержимому',
  'nav.menu': 'Меню',
  'nav.branch': 'Филиал',
  'nav.reportsHub': 'Центр отчётов',
  'reportsHub.lead': 'Каждый отчёт отвечает на один вопрос. Выберите вопрос — отчёт откроется сам.',
  'reportsHub.searchPlaceholder': 'Поиск по отчёту или вопросу',
  'reportsHub.empty': 'По этому запросу отчёты не найдены.',
  'reportsHub.themeSales': 'Продажи и клиенты',
  'reportsHub.themeStock': 'Склад и товары',
  'reportsHub.themeMoney': 'Деньги и долги',
  'reportsHub.themeImport': 'Импорт и снабжение',
  'reportsHub.themeAccounting': 'Бухгалтерия',
  'reportsHub.themeOther': 'Прочее',
  'reportsHub.hintSales': 'Сколько продали — по дням, месяцам, филиалам, менеджерам и товарам.',
  'reportsHub.hintAgentActivity': 'Какой торговый агент сколько отработал и кто вообще не проявлял активности.',
  'reportsHub.hintProfit': 'Сколько валовой прибыли осталось от продаж — после вычета себестоимости.',
  'reportsHub.hintRfm': 'Какой клиент покупает недавно, часто и много — кому нужно внимание.',
  'reportsHub.hintLtv': 'Сколько прибыли принёс один клиент за всё время работы.',
  'reportsHub.hintCustomerProfit': 'Какой клиент действительно прибылен, а какой из-за скидок работает в убыток.',
  'reportsHub.hintStock': 'Сколько товара и где сейчас есть — по всем филиалам и центральному складу.',
  'reportsHub.hintStockValue': 'Сколько денег заморожено на складе.',
  'reportsHub.hintDeadStock': 'Какой товар давно не двигается.',
  'reportsHub.hintStockAge': 'Сколько времени товар лежит на складе.',
  'reportsHub.hintAbc': 'Какие товары дают основную часть оборота — внимание им.',
  'reportsHub.hintXyz': 'Какой товар продаётся стабильно, а какой волнами — запас планируется по этому.',
  'reportsHub.hintReorder': 'Что нужно заказать прямо сейчас — чтобы не закончилось.',
  'reportsHub.hintArAging': 'Кто сколько должен и сколько дней долг уже висит.',
  'reportsHub.hintCashFlow': 'Откуда деньги пришли и куда ушли — по статьям ДДС.',
  'reportsHub.hintShipmentProfit': 'Какая отгрузка принесла прибыль, а какая убыток — вместе с себестоимостью.',
  'reportsHub.hintContainer': 'Насколько эффективно использовано место в контейнере.',
  'reportsHub.hintSupplierScore': 'Какой завод поставляет в срок, а какой задерживает.',
  'reportsHub.hintIncomeStatement': 'Прибыль или убыток по итогам периода — в разрезе доходов и расходов.',
  'reportsHub.hintBalanceSheet': 'Что есть у компании и кому мы должны — на дату.',
  'reportsHub.hintEquity': 'Как изменилась доля собственника.',
  'reportsHub.hintJournals': 'Каждая проводка — с указанием документа, из которого она пришла.',
  'reportsHub.hintPeriods': 'Какой месяц закрыт, а какой ещё открыт.',
  'nav.allBranches': 'Все филиалы',
  'nav.group.general': 'Общее',
  'nav.group.masterData': 'Справочники',
  'nav.group.warehouse': 'Склад',
  'nav.group.supply': 'Снабжение',
  'nav.incomingSupply': 'Входящий груз',
  'nav.group.procurement': 'Закупки и импорт',
  'nav.group.sales': 'Продажи',
  'nav.group.finance': 'Финансы',
  'nav.group.reports': 'Отчёты',
  'nav.group.system': 'Система',
  'nav.dashboard': 'Главная',
  'nav.reference': 'Категории и бренды',
  'nav.products': 'Товары',
  'nav.customers': 'Клиенты',
  'nav.suppliers': 'Поставщики',
  'nav.pricelists': 'Прайс-листы',
  'nav.stock': 'Остатки',
  'nav.receipts': 'Приход',
  'nav.issue': 'Списание',
  'nav.transfers': 'Перемещения',
  'nav.counts': 'Инвентаризация',
  'nav.movements': 'Журнал склада',
  'nav.purchaseOrders': 'Заказы поставщикам',
  'nav.shipments': 'Контейнеры',
  'nav.costing': 'Себестоимость',
  'nav.landedCost': 'Расчёт полной себестоимости',
  'nav.salesOrders': 'Заказы покупателей',
  'nav.invoices': 'Счета-фактуры',
  'nav.returns': 'Возвраты',
  'nav.returnsQuarantine': 'Карантин (QC)',
  'nav.payments': 'Платежи',
  'nav.receivables': 'Дебиторская задолженность (AR)',
  'nav.payables': 'Кредиторская задолженность (AP)',
  'nav.supplierPayments': 'Оплата поставщику',
  'nav.cashAccounts': 'Касса и банк',
  'nav.fxRates': 'Курсы валют',
  'nav.reportStock': 'Остатки на складе',
  'nav.reportStockValue': 'Стоимость склада',
  'nav.reportSales': 'Продажи',
  'nav.reportProfit': 'Валовая прибыль',
  'nav.reportDiscipline': 'Дисциплина клиента',
  'nav.reportArAging': 'Дебиторка по срокам',
  'nav.reportApAging': 'Кредиторка по срокам',
  'nav.reportCashFlow': 'Движение денежных средств',
  'nav.reportDeadStock': 'Медленно оборачиваемый товар',
  'nav.reportShipmentProfit': 'Рентабельность контейнера',
  'nav.reportReorder': 'Когда заказывать',
  'nav.reportAbc': 'ABC-анализ',
  'nav.reportXyz': 'XYZ-анализ',
  'nav.reportRfm': 'RFM — сегментация клиентов',
  'nav.reportLtv': 'Пожизненная ценность клиента (LTV)',
  'nav.reportSupplierScore': 'Показатель поставщика',
  'nav.reportContainer': 'Эффективность контейнера',
  'nav.reportStockAge': 'Возраст остатков',
  'nav.reportCustomerProfit': 'Прибыльность клиентов',
  'nav.users': 'Пользователи',
  'nav.group.security': 'Безопасность',
  'nav.settings': 'Настройки',
  'dashboard.title': 'Главная',
  'dashboard.welcome': 'Добро пожаловать, {name}',
  'dashboard.subtitle': 'Показатели отображаются в соответствии с вашими правами доступа.',
  'dashboard.yourRole': 'Ваша роль',
  'dashboard.yourPermissions': 'Количество прав доступа',
  'dashboard.openReport': 'Открыть отчёт →',
  'dashboard.empty': 'Для вас нет доступных показателей',
  'dashboard.emptyHint': 'Это может быть ожидаемо: каждая карточка требует своего права доступа. Экраны в боковом меню вам открыты.',
  'dashboard.salesToday': 'Продажи за сегодня',
  'dashboard.salesTodayHint': 'По проведённым (posted) отгрузочным накладным',
  'dashboard.salesMonth': 'Продажи за этот месяц',
  'dashboard.salesLines': '{count} строк',
  'dashboard.grossProfitMonth': 'Валовая прибыль (этот месяц)',
  // Короткая подпись: длинная обрывалась посреди слова в плитке.
  'dashboard.grossProfitHint': 'Выручка − себестоимость',
  'dashboard.arTotal': 'Дебиторская задолженность (AR)',
  'dashboard.arHint': 'Остаток неоплаченных счетов-фактур',
  'dashboard.arOverdue': 'Из них просрочено: {amount}',
  'dashboard.arCustomers': '{count} клиентов',
  'dashboard.stockValue': 'Стоимость склада',
  'dashboard.stockValueHint': 'По полной себестоимости, складов: {count}',
  'dashboard.inTransitValue': 'Стоимость товара в пути',
  'dashboard.inTransitHint': 'Товар в контейнере, ещё не принятый на склад',
  'dashboard.inTransitQty': 'Количество в пути: {qty}',
  'dashboard.inTransitTodo': 'Отчёт по остаткам показывает КОЛИЧЕСТВО товара в пути, но не его стоимость.',
  'dashboard.stockSummary': 'Остатки на складе',
  'dashboard.stockSummaryHint': 'Позиции с ненулевым остатком',
  'dashboard.stockSkuCount': '{count} SKU',
  'dashboard.deadStock': 'Медленно оборачиваемый товар',
  'dashboard.deadStockHint': 'Без списаний более {days} дней',
  'dashboard.deadStockCount': '{count} позиций',
  'dashboard.pendingTasks': 'Складские задачи в ожидании',
  'dashboard.pendingTasksHint': 'Непринятые перемещения и незакрытые инвентаризации',
  'dashboard.pendingTransfers': 'Непринятых перемещений: {count}',
  'dashboard.pendingCounts': 'Открытых инвентаризаций: {count}',
  'dashboard.openTransfers': 'Открыть перемещения →',
  'dashboard.topCustomers': 'Крупнейшие клиенты',
  'dashboard.topCustomersHint': 'По выручке за этот месяц, первые пять',
  'dashboard.cashFlowMonth': 'Движение денежных средств (этот месяц)',
  'dashboard.cashFlowHint': 'Приход − расход',
  'dashboard.cashIn': 'Приход: {amount}',
  'dashboard.cashOut': 'Расход: {amount}',
  'dashboard.lastContainer': 'Последний контейнер',
  'dashboard.lastContainerHint': 'Доля расходов относительно стоимости товара',

  // Строка логистики — вместо двух прежних плиток.
  'dashboard.logistics.inTransit': 'Товар в пути',
  'dashboard.logistics.lastContainer': 'Последний контейнер: {docNo}',
  'period.title': 'Период',
  'period.today': 'Сегодня',
  'period.thisWeek': 'Эта неделя',
  'period.thisMonth': 'Этот месяц',
  'period.lastMonth': 'Прошлый месяц',
  'period.thisYear': 'Этот год',
  'period.from': 'Начало',
  'period.to': 'Окончание',
  'report.export': 'Экспорт в Excel',
  'report.exportHint': 'Файл формируется из строк на экране — дополнительный запрос на сервер не отправляется.',
  'report.exportSubtitle': 'Файл создан: {at} · Строк: {count}',
  'report.exportEmpty': 'Нет строк для экспорта',
  'report.exportFailed': 'Не удалось скачать файл',
  'report.print': 'PDF',
  'report.printHint': 'Откроется окно печати — там есть «Сохранить → PDF»',
  'report.generatedAt': 'Сформирован: {at}',
  'report.currency': 'Валюта: {currency}',
  'report.orgUnknown': '⚠️ Название организации не определено',
  'report.asOf': 'Дата состояния',
  'report.total': 'Итого',
  'report.loadError': 'Не удалось загрузить отчёт',
  'report.empty': 'По этим условиям данных нет',
  'report.emptyHint': 'Расширьте период или проверьте фильтр.',
  'report.valueHidden': 'Столбцы с денежными суммами вам не показываются — это вопрос прав доступа, а не ошибка.',
  'report.insufficient.no_data': 'Данных нет — за этот период движений не найдено.',
  'report.insufficient.single_purchase': 'За период всего одна покупка — частота не измеряется. Для повторяемости нужно минимум две покупки.',
  'report.insufficient.too_few_periods': 'Периодов наблюдения недостаточно — история товара короткая. Выберите более длинное окно или дождитесь оборота товара.',
  'report.insufficient.too_few_peers': 'База для сравнения мала — клиентов недостаточно, чтобы квинтильные баллы были осмысленными.',
  'report.insufficient.short_history': 'История сотрудничества короткая — месячная величина была бы экстраполяцией, поэтому она не рассчитана.',
  'report.insufficient.zero_base': 'База равна нулю — процент или долю рассчитать невозможно.',
  'report.insufficient.ambiguous_source': 'Источников несколько — показатель нельзя отнести к одному из них.',
  'report.abc.title': 'ABC-анализ',
  'report.abc.description': 'Товары делятся на группы A/B/C по выручке. В каждой строке видно и то, сколько денег сегодня заморожено в этом товаре — самая ценная строка это товар из группы C, склад которого забит.',
  'report.abc.thresholds': 'Границы',
  'report.abc.preset': '{a}/{b}/{c}',
  'report.abc.rank': '№',
  'report.abc.class': 'Группа',
  'report.abc.revenue': 'Выручка',
  'report.abc.share': 'Доля',
  'report.abc.cumulative': 'Накопительно',
  'report.abc.quantity': 'Количество',
  'report.abc.grossProfit': 'Валовая прибыль',
  'report.abc.margin': 'Маржа',
  'report.abc.stockValue': 'Заморожено на складе',
  'report.abc.groupCount': '{count} товаров',
  'report.xyz.title': 'XYZ-анализ',
  'report.xyz.description': 'Насколько стабилен спрос. X — прогнозируется, Z — случайный и требует большого страхового запаса. Читается вместе с ABC: AX — важный и стабильный, CZ — незначительный и случайный.',
  'report.xyz.class': 'XYZ',
  'report.xyz.combined': 'ABC-XYZ',
  'report.xyz.cv': 'Вариация',
  'report.xyz.periods': 'Периоды',
  'report.xyz.periodsValue': '{observed} ({active} с продажами)',
  'report.xyz.totalQty': 'Всего спрос',
  'report.xyz.mean': 'Среднее',
  'report.xyz.stdDev': 'Отклонение',
  'report.xyz.reason': 'Пояснение',
  'report.xyz.lookback': 'Окно наблюдения',
  'report.xyz.bucket': 'Период',
  'report.xyz.bucket.week': 'Неделя',
  'report.xyz.bucket.month': 'Месяц',
  'report.xyz.matrix': 'Матрица ABC × XYZ (количество товаров)',
  'report.xyz.matrixHint': 'AX — автоматический заказ, хватит небольшого запаса. AZ — важный, но случайный: нужен большой страховой запас. CZ — запас можно не держать.',
  'report.rfm.title': 'RFM — сегментация клиентов',
  'report.rfm.description': 'Клиенты по давности покупки (R), частоте (F) и сумме (M). Баллы ОТНОСИТЕЛЬНЫЕ: «где клиент находится по сравнению с остальными вашими клиентами». Поэтому рядом с баллом показаны и исходные значения.',
  'report.rfm.code': 'Код',
  'report.rfm.customer': 'Клиент',
  'report.rfm.segment': 'Сегмент',
  'report.rfm.rfmCode': 'RFM',
  'report.rfm.r': 'R',
  'report.rfm.f': 'F',
  'report.rfm.m': 'M',
  'report.rfm.recencyDays': 'С последней покупки',
  'report.rfm.purchases': 'Покупки',
  'report.rfm.monetary': 'Сумма',
  'report.rfm.lastPurchase': 'Последняя покупка',
  'report.rfm.reason': 'Примечание',
  'report.rfm.segments': 'Распределение по сегментам',
  'report.rfm.segment.champion': 'Самые ценные',
  'report.rfm.segment.loyal': 'Лояльные',
  'report.rfm.segment.potential': 'Перспективные',
  'report.rfm.segment.at_risk': 'В зоне риска',
  'report.rfm.segment.lost': 'Потерянные',
  'report.rfm.segment.needs_attention': 'Требуют внимания',
  'report.rfm.segment.unscored': 'Без оценки',
  'report.ltv.title': 'Пожизненная ценность клиента (LTV)',
  'report.ltv.description': 'Сколько валовой прибыли принёс клиент за всё время сотрудничества (с учётом возвратов). Это не ПРОГНОЗ, а факт: будущий «срок жизни» клиента был бы догадкой, а эта цифра считается по реальным продажам.',
  'report.ltv.code': 'Код',
  'report.ltv.customer': 'Клиент',
  'report.ltv.value': 'LTV',
  'report.ltv.monthly': 'В месяц',
  'report.ltv.revenue': 'Выручка',
  'report.ltv.grossProfit': 'Валовая прибыль',
  'report.ltv.returns': 'Возвраты',
  'report.ltv.orders': 'Заказы',
  'report.ltv.avgOrder': 'Средний чек',
  'report.ltv.lifespan': 'Срок сотрудничества',
  'report.ltv.firstOrder': 'Первая покупка',
  'report.ltv.lastOrder': 'Последняя покупка',
  'report.ltv.minLifespan': 'Минимальная история для расчёта в месяц',
  'report.supplier.title': 'Показатели поставщика',
  'report.supplier.description': 'Насколько надёжен завод: обещанный срок и факт, брак (по возвратам), недостача при приёмке и динамика цен. Дешёвый поставщик не всегда дёшев.',
  'report.supplier.code': 'Код',
  'report.supplier.name': 'Поставщик',
  'report.supplier.score': 'Надёжность',
  'report.supplier.onTime': 'В срок',
  'report.supplier.promisedLead': 'Обещано (дней)',
  'report.supplier.actualLead': 'Факт (дней)',
  'report.supplier.bias': 'Отклонение (дней)',
  'report.supplier.defect': 'Брак',
  'report.supplier.defectQty': 'Количество брака',
  'report.supplier.shortage': 'Недостача',
  'report.supplier.priceChange': 'Изменение цены',
  'report.supplier.priceChangeHint': 'Нет данных второго периода для сравнения — расширьте окно.',
  'report.supplier.orders': 'Заказы',
  'report.supplier.ordersValue': '{received} / {total}',
  'report.supplier.soleSource': 'Товары, к которым привязывается брак',
  'report.supplier.soleSourceValue': '{sole} / {total}',
  'report.supplier.lookback': 'Окно наблюдения',
  'report.supplier.unattributed': '{qty} шт. брака не привязано ни к одному поставщику — у этих товаров несколько активных поставщиков. Чтобы понять, какой завод виноват, укажите для товара единственного поставщика.',
  'report.container.title': 'Эффективность контейнеров',
  'report.container.description': 'План и факт: разница ETA/ATA, доля расходов в стоимости товара и история задержек. На вопрос «принёс ли контейнер прибыль» отвечает отчёт по рентабельности, а этот оценивает сам поток.',
  'report.container.docNo': 'Документ',
  'report.container.containerNo': 'Контейнер',
  'report.container.supplier': 'Поставщик',
  'report.container.eta': 'ETA (план)',
  'report.container.ata': 'ATA (факт)',
  'report.container.delay': 'Задержка (дней)',
  'report.container.delayValue': '{days} дн.',
  'report.container.notMeasured': 'Не измерено: нет ETA или фактической даты',
  'report.container.plannedTransit': 'План в пути (дней)',
  'report.container.actualTransit': 'Факт в пути (дней)',
  'report.container.purchaseValue': 'Стоимость товара',
  'report.container.cost': 'Расходы',
  'report.container.costShare': 'Доля расходов',
  'report.container.qty': 'Количество',
  'report.container.lookback': 'Окно наблюдения',
  'report.container.unmeasured': 'У {count} задержка не измерена',
  'report.container.delayChart': 'История задержек (по ETA)',
  'report.container.delayChartHint': 'Столбцы показывают только ЗАДЕРЖКУ: контейнер, пришедший вовремя или раньше, остаётся пустым местом, а неизмеренные на график вообще не попадают. Точное значение видно при наведении курсора на столбец.',
  'report.container.costTypes': 'По видам расходов',
  'report.stockAge.title': 'Возраст складских запасов',
  'report.stockAge.description': 'Сколько дней остаток лежит на полке. Возраст считается по слоям FIFO — простой вариант «с даты последнего прихода» скрывал бы медленно оборачивающийся товар.',
  'report.stockAge.onHand': 'Остаток',
  'report.stockAge.avgAge': 'Средний возраст',
  'report.stockAge.oldest': 'Самый старый слой',
  'report.stockAge.unknown': 'Возраст неизвестен',
  'report.stockAge.unknownHint': 'Для этого количества не найдена запись прихода — это начальный остаток, перенесённый при запуске программы или введённый вручную.',
  'report.stockAge.unknownAlert': 'По {positions} позициям возраст остатка в {qty} шт. не определён — не найдена запись прихода. Это количество НЕ ВКЛЮЧЕНО в группу «самые старые».',
  'report.stockAge.value': 'Стоимость',
  'report.stockAge.chart': 'Остаток по возрастным группам',
  'report.profitability.title': 'Прибыльность клиентов',
  'report.profitability.description': 'Выручка − себестоимость − скидки − возвраты. Вывод «невыгодный» чаще всего рождается из скидок и возвратов, а в отчёте по валовой прибыли он не виден.',
  'report.profitability.code': 'Код',
  'report.profitability.customer': 'Клиент',
  'report.profitability.netProfit': 'Чистая прибыль',
  'report.profitability.margin': 'Чистая маржа',
  'report.profitability.listRevenue': 'Выручка (по прайс-листу)',
  'report.profitability.discount': 'Скидка',
  'report.profitability.discountPct': 'Скидка, %',
  'report.profitability.cogs': 'Себестоимость',
  'report.profitability.bonusCost': 'Себестоимость бонусов',
  'report.profitability.returns': 'Возвраты',
  'report.profitability.orders': 'Заказы',
  'report.profitability.quantity': 'Количество',
  'report.profitability.excludesTitle': 'Расходы, НЕ ВОШЕДШИЕ в этот отчёт',
  'report.stock.title': 'Остатки на складе',
  'report.stock.description': 'Остаток по каждому складу и каждому SKU. Ответ на вопрос «есть ли этот товар?».',
  'report.stock.warehouse': 'Склад',
  'report.stock.onHand': 'Остаток',
  'report.stock.reserved': 'Зарезервировано',
  'report.stock.available': 'Свободный остаток',
  'report.stock.inTransit': 'В пути',
  'report.stock.avgCost': 'Средняя себестоимость',
  'report.stock.totalValue': 'Стоимость',
  'report.stockValuation.title': 'Стоимость складских запасов',
  'report.stockValuation.description': 'Деньги, замороженные в товаре на складе, по полной себестоимости. В разрезе складов.',
  'report.stockValuation.skuCount': 'Количество SKU',
  'report.stockValuation.totalQty': 'Общее количество',
  'report.stockValuation.totalValue': 'Общая стоимость',
  'report.stockValuation.warehouseName': 'Название склада',
  'report.sales.title': 'Продажи',
  'report.sales.description': 'Выручка считается по отгрузкам, а не по счетам-фактурам: настоящей продажей считается момент, когда товар покинул склад.',
  'report.sales.chartLabel': 'Выручка по дням',
  'report.sales.groupBy': 'Разрез',
  'report.sales.groupBy.day': 'День',
  'report.sales.groupBy.customer': 'Клиент',
  'report.sales.groupBy.product': 'Товар',
  'report.sales.groupBy.agent': 'Продавец',
  'report.sales.date': 'Дата',
  'report.sales.customer': 'Клиент',
  'report.sales.sku': 'SKU',
  'report.sales.productName': 'Наименование',
  'report.sales.agent': 'Продавец',
  'report.sales.agentUnnamed': 'Сотрудник #{id}',
  'report.sales.agentNote': 'В разрезе продавца отчёт возвращает только ID сотрудника, а не его имя.',
  'report.sales.revenue': 'Выручка',
  'report.sales.quantity': 'Количество',
  'report.sales.lineCount': 'Строк',
  'report.agent.title': 'Активность торговых агентов',
  'report.agent.description': 'Сколько заказов сотрудник ввёл за период, скольким разным клиентам и на какую сумму. Для заказов, введённых в поле, дополнительно проверяется место визита.',
  'report.agent.agent': 'Торговый агент',
  'report.agent.agentUnnamed': 'Сотрудник #{id}',
  'report.agent.agentUnknown': 'Сотрудник не указан',
  'report.agent.orderCount': 'Заказы',
  'report.agent.customerCount': 'Клиенты',
  'report.agent.totalBase': 'Всего продаж',
  'report.agent.avgOrderBase': 'Средний заказ',
  'report.agent.fieldOrderCount': 'Введено в поле',
  'report.agent.measurable': 'Измеримые',
  'report.agent.missing': 'Не измерено',
  'report.agent.confirmed': 'Подтверждённые визиты',
  'report.agent.confirmedOf': '{confirmed} из {measurable}',
  'report.agent.pct': 'Подтверждено, %',
  'report.agent.pctUnmeasured': 'не измерено',
  'report.agent.filterAgent': 'Торговый агент',
  'report.agent.filterAgentAll': 'Все',
  'report.agent.filterAgentHint': 'Список строится из строк самого отчёта: сотрудники, вводившие заказы в этом периоде.',
  'report.agent.radius': 'Радиус, в котором визит считается подтверждённым: {meters} м',
  'report.agent.radiusHint': 'Заказ, введённый в пределах этого расстояния от сохранённой точки клиента, считается «подтверждённым».',
  'report.agent.caveatTitle': 'Этот показатель — не оружие',
  'report.agent.caveatBody': 'Низкий процент НЕ означает, что агент солгал. На телефоне могло быть не выдано разрешение на геолокацию, внутри здания GPS может не работать, а сохранённая точка магазина — устареть. Цифра ставит вопрос, а не даёт ответ — сначала спросите о причине.',
  'report.agent.scopeNote': 'Охват зависит от роли: продавец видит только свою строку, ограничение накладывается на сервере.',
  'report.agent.unmeasuredNote': '«Не измерено» и «0%» — НЕ ОДНО И ТО ЖЕ: в первом случае измеримых заказов вообще не было, во втором измерение прошло и ни один заказ не подтвердился.',
  'report.profit.title': 'Валовая прибыль',
  'report.profit.description': 'Прибыль = выручка − себестоимость. Себестоимость фиксируется в момент отгрузки товара со склада и в дальнейшем не меняется.',
  'report.profit.by': 'Разрез',
  'report.profit.by.product': 'Товар',
  'report.profit.by.customer': 'Клиент',
  'report.profit.code': 'Код',
  'report.profit.name': 'Наименование',
  'report.profit.quantity': 'Количество',
  'report.profit.revenue': 'Выручка',
  'report.profit.cogs': 'Себестоимость',
  'report.profit.bonusCost': 'Себестоимость бонусов',
  'report.profit.bonusHint': 'Бонусные строки добавляют к выручке 0, но списывают себестоимость ПОЛНОСТЬЮ — это скрытая скидка, которая уменьшает прибыль.',
  'report.profit.grossProfit': 'Валовая прибыль',
  'report.profit.marginPct': 'Маржа',
  'disc.title': 'Дисциплина клиента — план и факт',
  'disc.description':
    'Один дилер по месяцам: сколько взял, сколько заплатил и совпало ли это с согласованным планом.',
  'disc.customer': 'Клиент',
  'disc.pickCustomer': 'Выберите клиента — отчёт строится по одному дилеру.',
  'disc.failingCount': '{month}: {count} дилеров отклонились от нормативов (закупка или оплата).',
  'disc.mustPay': 'Обязательный платёж',
  'disc.shortfall': 'Не хватает',
  'disc.lastPayment': 'Последний платёж',
  'disc.neverPaid': 'не платил',
  'disc.collectTotal':
    '{month}: к взысканию — {amount} ({count} дилеров). Список начинается с наибольшей суммы.',
  'disc.allGood': '{month}: все дилеры выполнили план.',
  'disc.overviewHint': 'Список отсортирован на сервере: сначала по числу невыполненных показателей, затем по сумме долга. То есть первая строка — дилер, с которым нужно поговорить сегодня. Нажмите на имя, чтобы открыть дилера по месяцам.',
  'disc.bucket': 'Разрез',
  'disc.bucketMonth': 'По месяцам',
  'disc.bucketWeek': 'По неделям',
  'disc.weekLabel': '{week}-я неделя',
  'disc.weekNote': 'В недельном разрезе проценты НЕ оцениваются (цвет не ставится): норматив месячный — «оплатите 95% закупа за этот месяц» не является недельным обязательством. Недельные строки показывают, КОГДА внутри месяца пришли деньги; вывод делается в месячном разрезе.',
  'disc.month': 'Месяц',
  'disc.opening': 'Долг на начало',
  'disc.sales': 'Продажи',
  'disc.payment': 'Оплата',
  'disc.returned': 'Возврат',
  'disc.discount': 'Скидка',
  'disc.writeOff': 'Списано',
  'disc.closing': 'Долг на конец',
  'disc.purchase': 'Закуп / остаток прошлого месяца',
  'disc.paymentRatio': 'Оплата / закуп',
  'disc.collection': 'Оплата / (остаток + закуп)',
  'disc.planPurchase': 'План: закуп %',
  'disc.factPurchase': 'Факт: закуп %',
  'disc.planPayment': 'План: оплата %',
  'disc.factPayment': 'Факт: оплата %',
  'disc.planCollection': 'План: сбор %',
  'disc.factCollection': 'Факт: сбор %',
  'disc.hint':
    'Число в ячейке — ФАКТ в процентах, план виден при наведении. Зелёный — план выполнен, жёлтый — больше половины плана, красный — меньше. При нулевом плане цвет не ставится. Долг на конец = долг на начало + продажи − оплата − возврат − скидка − списано, и он становится долгом на начало следующего месяца.',
  'report.arAging.title': 'Задолженность клиентов (AR aging)',
  'report.arAging.description': 'Распределено по возрасту задолженности. Долг старше 90 дней — это уже не взыскание, а вероятность потери.',
  'report.arAging.code': 'Код',
  'report.arAging.customer': 'Клиент',
  'report.arAging.notDue': 'Срок не наступил',
  'report.arAging.d0_30': '0–30 дней',
  'report.arAging.d31_60': '31–60 дней',
  'report.arAging.d61_90': '61–90 дней',
  'report.arAging.d90plus': '90+ дней',
  'report.arAging.total': 'Всего долг',
  'report.arAging.overdue': 'Просроченный долг',
  'report.arAging.oldestDue': 'Самый старый срок',
  'report.arAging.invoiceCount': 'Счета-фактуры',
  'report.arAging.creditLimit': 'Кредитный лимит',
  'report.cashFlow.title': 'Движение денежных средств',
  'report.cashFlow.description': 'Ежедневные поступления и выплаты по кассе и банку, в разрезе статей ДДС.',
  'report.cashFlow.date': 'Дата',
  'report.cashFlow.category': 'Статья ДДС',
  'report.cashFlow.in': 'Поступление',
  'report.cashFlow.out': 'Выплата',
  'report.cashFlow.net': 'Сальдо',
  'report.deadStock.title': 'Медленно оборачиваемый товар',
  'report.deadStock.description': 'Товар, у которого есть остаток, но давно не было списаний. Это деньги, выпавшие из оборота.',
  'report.deadStock.threshold': 'Порог неподвижности',
  'report.deadStock.days': '{days} дн.',
  'report.deadStock.daysIdle': 'Без движения',
  'report.deadStock.lastOutbound': 'Последнее списание',
  'report.deadStock.never': 'Списаний не было',
  'report.deadStock.onHand': 'Остаток',
  'report.deadStock.value': 'Стоимость',
  'report.landedCost.title': 'Состав себестоимости SKU',
  'report.landedCost.description': '«Почему эта панель стоит {example}?» — ответ в строках расходов ниже. Себестоимость каждого SKU раскрывается до вида расходов.',
  'report.landedCost.shipment': 'Отгрузка #{id}',
  'report.landedCost.sku': 'SKU',
  'report.landedCost.quantity': 'Количество',
  'report.landedCost.purchaseUnitCost': 'Цена товара (за шт.)',
  'report.landedCost.landedUnitCost': 'Расходы (за шт.)',
  'report.landedCost.totalUnitCost': 'Полная себестоимость (за шт.)',
  'report.landedCost.costType': 'Вид расходов',
  'report.landedCost.costName': 'Примечание',
  'report.landedCost.allocMethod': 'Распределение',
  'report.landedCost.allocRatio': 'Доля (коэффициент)',
  'report.landedCost.allocatedBase': 'Сумма',
  'report.landedCost.uncategorized': 'Вид не указан',
  'report.landedCost.empty': 'По этой отгрузке распределённых расходов не найдено',
  'report.landedCost.emptyHint': 'Полная себестоимость ещё не рассчитана или в отгрузке нет строк расходов.',
  'report.landedCost.backToShipments': '← Список контейнеров',
  'report.landedCost.skuBreakdown': 'Состав расходов',
  'report.landedCost.skuTotal': '{sku}: {qty} шт. × {cost}',
  'report.shipment.title': 'Рентабельность контейнера',
  'report.shipment.description': '«Принёс ли этот контейнер прибыль?» — главный вопрос импортного бизнеса. По каждой отгрузке: стоимость товара, расходы и их соотношение.',
  'report.shipment.landedExplainer': 'Доля расходов — самая ВАЖНАЯ колонка. Это отношение распределённых расходов к стоимости товара: 109% означает, что фрахт, таможня, сертификаты и всё остальное вместе обошлись дороже самого товара. Именно поэтому назначать цену по счёту из Китая не работает.',
  'report.shipment.docNo': 'Документ',
  'report.shipment.containerNo': 'Контейнер',
  'report.shipment.eta': 'ETA',
  'report.shipment.ata': 'Прибыл',
  'report.shipment.delay': 'Задержка',
  'report.shipment.delayDays': '+{days} дн.',
  'report.shipment.earlyDays': '−{days} дн.',
  'report.shipment.onTime': 'В срок',
  'report.shipment.lcStatus': 'Статус себестоимости',
  'report.shipment.skuCount': 'SKU',
  'report.shipment.receivedQty': 'Принято',
  'report.shipment.shortageQty': 'Недостача',
  'report.shipment.purchaseValue': 'Стоимость товара',
  'report.shipment.landedValue': 'Расходы',
  'report.shipment.totalCost': 'Полная себестоимость',
  'report.shipment.landedPct': 'Доля расходов',
  'report.shipment.openBreakdown': 'Состав',
  'report.shipment.rowHint': 'Нажмите на строку — откроется состав себестоимости каждого SKU в этом контейнере.',
  'report.shipment.filterAll': 'Все контейнеры',
  'report.shipment.empty': 'Контейнеры не найдены',
  'report.shipment.emptyHint': 'Возможно, ещё не принята ни одна отгрузка.',
  'report.reorder.title': 'Когда пора заказывать',
  'report.reorder.description': 'Срок поставки 120–150 дней. Правило «товар закончился → заказываю» означает четыре месяца простоя: решение нужно принимать задолго до того, как товар кончится.',
  'report.reorder.formula': 'Среднедневной расход = ПРОДАЖИ за последние {lookback} дней ÷ {lookback}. Покрытие = (остаток + в пути) ÷ среднедневной расход. Если покрытие меньше срока поставки плюс страхового запаса — пора заказывать. Перемещения и списания образцов в спрос не входят: это не продажи.',
  'report.reorder.lookbackDays': 'Период спроса, дней',
  'report.reorder.safetyDays': 'Страховой запас, дней',
  'report.reorder.leadTimeDays': 'Стандартный срок поставки, дней',
  'report.reorder.leadTimeHint': 'Если у поставщика указан фактический срок поставки, используется он; это значение — только для остальных.',
  'report.reorder.onHand': 'Остаток',
  'report.reorder.inTransit': 'В пути',
  'report.reorder.sold': 'Продано (за период)',
  'report.reorder.dailyAverage': 'Среднедневной расход',
  'report.reorder.daysOfCover': 'Покрытие, дней',
  'report.reorder.leadTime': 'Срок поставки',
  'report.reorder.suggestedQty': 'Рекомендуемое количество',
  'report.reorder.status': 'Статус',
  'report.reorder.status.order_now': 'ЗАКАЗАТЬ',
  'report.reorder.status.ok': 'Достаточно',
  'report.reorder.status.no_demand': 'Нет спроса',
  'report.reorder.noDemandHint': 'За период не было ни одной продажи: покрытие не рассчитывается. Это не значит «достаточно» — это значит «товар не движется».',
  'report.reorder.empty': 'Закупаемые товары не найдены',
  'report.reorder.emptyHint': 'Возможно, в каталоге нет активных товаров с признаком «закупается».',
  'dashboard.pulse.title': 'Пульс продаж',
  'dashboard.pulse.thisMonth': 'Этот месяц',
  'dashboard.pulse.today': 'Сегодня',
  'dashboard.pulse.orders': '{count} строк',
  'dashboard.pulse.chartLabel': 'Выручка по дням, этот месяц',
  'dashboard.pulse.comparedTo': 'к той же дате прошлого месяца',
  'dashboard.pulse.noSales': 'В этом месяце продаж пока нет',
  'dashboard.attention.title': 'Требует внимания',
  'dashboard.attention.allClear': 'Срочных задач нет',
  'dashboard.attention.allClearHint': 'Нет просроченной задолженности, непринятых перемещений и заканчивающегося товара.',
  'dashboard.attention.transfers': 'Непринятые перемещения',
  'dashboard.attention.discipline': 'Дилеры не по плану',
  'dashboard.attention.arOverdue': 'Просроченная задолженность',
  'dashboard.attention.reorder': 'Пора заказывать',
  'dashboard.attention.deadStock': 'Медленно оборачиваемый товар',
  'dashboard.attention.counts': 'Открытые инвентаризации',
  'dashboard.attention.items': '{count} шт.',
  'dashboard.attention.unknown': 'Не удалось загрузить',
  'dashboard.topProducts': 'Самые продаваемые товары',
  'dashboard.share': 'Доля',
  'nav.reorderRuns': 'Автозаказ',
  'reorder.title': 'Автозаказ',
  'reorder.description': 'Система сама выполняет анализ по расписанию категорий: что заканчивается, сколько нужно и с какого завода. Результат — черновики заказов поставщику, утверждает их человек.',
  'reorder.new': 'Новый анализ',
  'reorder.runDue': 'Проверить очередные',
  'reorder.docNo': 'Документ',
  'reorder.runDate': 'Дата',
  'reorder.category': 'Категория',
  'reorder.categoryAll': 'Все категории',
  'reorder.lineCount': 'Строки',
  'reorder.suggestedCount': 'К заказу',
  'reorder.poCount': 'Черновики заказов',
  'reorder.status': 'Статус',
  'reorder.status.draft': 'Новый',
  'reorder.status.reviewed': 'Просмотрено',
  'reorder.status.ordered': 'Заказано',
  'reorder.status.cancelled': 'Отменён',
  'reorder.empty': 'Анализ ещё не выполнялся',
  'reorder.emptyHint': 'Запустите первый анализ кнопкой «Новый анализ» или задайте категории период пересмотра.',
  'reorder.filterStatus': 'По статусу',
  'nav.staff': 'Сотрудники',
  'nav.commission': 'Комиссия',
  'nav.kpi': 'KPI — план и факт',
  'hr.commission.title': 'Комиссия',
  'hr.commission.description': 'Комиссия за период рассчитывается, проверяется и ЗАКРЫВАЕТСЯ. После закрытия результат не меняется — при обнаружении ошибки создаётся корректирующий расчёт.',
  'hr.commission.new': 'Рассчитать период',
  'hr.commission.preview': 'Сначала пробный расчёт',
  'hr.commission.docNo': 'Документ',
  'hr.commission.period': 'Период',
  'hr.commission.employees': 'Сотрудники',
  'hr.commission.totalNet': 'К выплате',
  'hr.commission.totalDeduction': 'Удержания',
  'hr.commission.status': 'Статус',
  'hr.commission.status.draft': 'Черновик',
  'hr.commission.status.reviewed': 'Просмотрено',
  'hr.commission.status.closed': 'Закрыт',
  'hr.commission.status.cancelled': 'Отменён',
  'hr.commission.runType.regular': 'Обычный',
  'hr.commission.runType.adjustment': 'Корректировка',
  'hr.commission.empty': 'Комиссия ещё не рассчитывалась',
  'hr.commission.emptyHint': 'Сначала нужно задать правило (ставка или ступени), затем рассчитать период. Расчёт никому не выплачивает деньги — он создаёт черновик.',
  'hr.commission.filterStatus': 'По статусу',
  'hr.commission.form.title': 'Расчёт за период',
  'hr.commission.form.hint': 'Сначала нажмите «пробный расчёт»: он НИЧЕГО не записывает и показывает, кому сколько причитается. Настоящий расчёт занимает период — на один месяц приходится один обычный расчёт.',
  'hr.commission.form.month': 'Месяц',
  'hr.commission.form.notes': 'Примечание',
  'hr.commission.form.dryRun': 'Пробный расчёт (без записи)',
  'hr.commission.form.submit': 'Рассчитать',
  'hr.commission.dryRunTitle': 'Результат пробного расчёта — не сохранён',
  'hr.commission.dryRunHint': 'Эти цифры не записаны в базу. Вы можете изменить правило и повторить пробный расчёт.',
  'hr.commission.detail.title': 'Расчёт комиссии',
  'hr.commission.employee': 'Сотрудник',
  'hr.commission.rule': 'Правило',
  'hr.commission.basis': 'База',
  'hr.commission.basis.revenue': 'Выручка',
  'hr.commission.basis.gross_profit': 'Валовая прибыль',
  'hr.commission.basis.collection': 'Собранные платежи',
  'hr.commission.basisAmount': 'Сумма базы',
  'hr.commission.deductionBasis': 'Удержания из базы',
  'hr.commission.netBasis': 'Чистая база',
  'hr.commission.rawCommission': 'До удержаний',
  'hr.commission.deduction': 'Сумма удержаний',
  'hr.commission.net': 'К выплате',
  'hr.commission.rate': 'Фактическая ставка',
  'hr.commission.orders': 'Заказы',
  'hr.commission.customers': 'Клиенты',
  'hr.commission.newCustomers': 'Новые клиенты',
  'hr.commission.hiddenBasis': 'Не показывается',
  'hr.commission.hiddenBasisHint': 'В правиле на базе валовой прибыли сумма базы — это маржа. Вашей роли она не раскрывается (ТЗ §60). Сумма к выплате при этом видна всегда.',
  'hr.commission.review': 'Проверено',
  'hr.commission.close': 'ЗАКРЫТЬ период',
  'hr.commission.closeConfirm': 'После закрытия результат НЕ МЕНЯЕТСЯ. При обнаружении ошибки создаётся корректирующий расчёт. Продолжить?',
  'hr.commission.closedAt': 'Закрыт',
  'hr.commission.correctsRun': 'Корректируемый расчёт',
  'hr.commission.reviewFirst': 'Перед закрытием расчёт должен быть проверен — это необратимое действие.',
  'hr.commission.flag.negative_basis': 'Удержания больше базы',
  'hr.commission.flag.negative_basisHint': 'Возвраты и отмены превысили продажи. Комиссия обрезана до нуля — отрицательная комиссия не записывается, потому что это удержание из зарплаты, а это отдельное решение.',
  'hr.commission.flag.cap_hit': 'Достигнут потолок',
  'hr.commission.flag.cap_hitHint': 'Применена максимальная сумма из правила. Возможно, сотрудник заработал больше.',
  'hr.commission.flag.below_min_basis': 'Ниже минимальной базы',
  'hr.commission.flag.below_min_basisHint': 'В правиле задан минимальный порог, и база ниже него — комиссия не выплачивается.',
  'hr.commission.flag.high_deduction': 'Слишком большие удержания',
  'hr.commission.flag.high_deductionHint': 'Удержания съели больше половины комиссии. Почти всегда дело не в продажах, а в другой проблеме: магазин не платит, есть проблема с товаром или заказы фиктивные.',
  'hr.commission.flag.zero_commission': 'Нулевая комиссия',
  'hr.commission.flag.zero_commissionHint': 'База была, но из-за удержаний или условия правила выплата не сложилась.',
  'hr.commission.flag.no_documents': 'Нет документов для расчёта',
  'hr.commission.flag.no_documentsHint': 'Это НЕ «выплачено ноль». В базу не попал ни один документ: заказы могут быть ещё черновиками или платёж не поступил. Ответ не в правиле, а в процессе.',
  'hr.commission.sources': 'Из каких документов',
  'hr.commission.sources.hint': 'За каждой цифрой стоит документ. Совпадение итога с базой проверено во время расчёта.',
  'hr.commission.sources.kind': 'Вид',
  'hr.commission.sources.doc': 'Документ',
  'hr.commission.sources.date': 'Дата',
  'hr.commission.sources.amount': 'Сумма',
  'hr.commission.sources.earning': 'В базу',
  'hr.commission.sources.return': 'Возврат',
  'hr.commission.sources.cancellation': 'Отменён',
  'hr.commission.sources.overdue': 'Просрочено',
  'hr.commission.sources.empty': 'Нет исходных документов',
  'hr.commission.sources.hidden': 'На базе валовой прибыли список источников тоже раскрывает маржу и не показывается.',
  'hr.rule.title': 'Правила комиссии',
  'hr.rule.code': 'Код',
  'hr.rule.name': 'Наименование',
  'hr.rule.target': 'Кому',
  'hr.rule.targetAll': 'Все сотрудники',
  'hr.rule.method': 'Метод',
  'hr.rule.method.percent': 'Процент',
  'hr.rule.method.tiered': 'Ступени',
  'hr.rule.method.fixed': 'Фиксированная сумма',
  'hr.rule.tiers': 'Ступени',
  'hr.rule.cap': 'Потолок',
  'hr.rule.deductions': 'Удержания',
  'hr.rule.empty': 'Правила комиссии не заданы',
  'hr.rule.emptyHint': 'Без правила расчёт не создаст ни одной строки. Правило задаётся для роли или для конкретного сотрудника.',
  'hr.kpi.title': 'KPI — план и факт',
  'hr.kpi.description': 'Факт считается ОДНОВРЕМЕННО с расчётом комиссии и из тех же цифр. Отдельного расчёта нет, чтобы они не разошлись.',
  'hr.kpi.metric': 'Показатель',
  'hr.kpi.plan': 'План',
  'hr.kpi.actual': 'Факт',
  'hr.kpi.achievement': 'Выполнение',
  'hr.kpi.noPlan': 'План не задан',
  'hr.kpi.noPlanHint': 'Нет плана — это НЕ значит «не выполнено». Процент выполнения тоже не показывается.',
  'hr.kpi.met': 'Выполнено',
  'hr.kpi.notMet': 'Не выполнено',
  'hr.kpi.empty': 'KPI за этот период не рассчитаны',
  'hr.kpi.emptyHint': 'KPI записываются вместе с расчётом комиссии. Сначала рассчитайте период.',
  'hr.kpi.metric.sales_volume': 'Объём продаж',
  'hr.kpi.metric.gross_profit': 'Валовая прибыль',
  'hr.kpi.metric.collection': 'Собранные платежи',
  'hr.kpi.metric.new_customers': 'Новые клиенты',
  'hr.kpi.metric.repeat_customers': 'Повторные клиенты',
  'hr.kpi.metric.avg_order': 'Средний чек',
  'hr.kpi.metric.order_count': 'Количество заказов',
  'hr.kpi.metric.return_rate': 'Доля возвратов',
  'hr.kpi.returnRateHint': 'По этому показателю МЕНЬШЕ — лучше: выполнение ниже плана здесь хороший результат.',
  'hr.kpi.month': 'Месяц',
  'hr.kpi.employee': 'Сотрудник',
  'hr.kpi.allEmployees': 'Все сотрудники',
  'reorder.form.title': 'Новый анализ',
  'reorder.form.hint': 'Если параметр не задан, он берётся из настроек категории. Параметры сохраняются ВМЕСТЕ с результатом — даже если категория позже изменится, этот анализ читается со своими исходными допущениями.',
  'reorder.form.lookbackDays': 'Период спроса, дней',
  'reorder.form.coverDays': 'Период покрытия, дней',
  'reorder.form.safetyDays': 'Страховой запас, дней',
  'reorder.form.includeInTransit': 'Учитывать товар в пути',
  'reorder.form.includeInTransitHint': 'Обычно — да. Отключается в периоды, когда завод несколько раз сорвал сроки: если контейнеру «в пути» больше нет доверия, считать его остатком — значит создать новую нехватку.',
  'reorder.form.notes': 'Примечание',
  'reorder.form.submit': 'Запустить анализ',
  'reorder.form.duplicate': 'По этой категории анализ сегодня уже выполнялся. Откройте его или запустите повторно завтра.',
  'reorder.due.title': 'Категории, которым пора',
  'reorder.due.hint': 'Сначала ничего не записывается — показывается только список. После вашего подтверждения по каждой позиции создаётся отдельный анализ.',
  'reorder.due.none': 'Сегодня ни по одной категории срок не подошёл',
  'reorder.due.every': 'Каждые {days} дн.',
  'reorder.due.lastRun': 'Последний анализ',
  'reorder.due.never': 'Никогда',
  'reorder.due.run': 'Проанализировать {count} категорий',
  'reorder.due.created': 'Создано анализов: {count}',
  'reorder.detail.params': 'Допущения',
  'reorder.detail.paramsValue': 'Период спроса {lookback} дн. · покрытие {cover} дн. · страховой запас {safety} дн. · товар в пути: {inTransit}',
  'reorder.detail.review': 'Отметить как просмотренный',
  'reorder.detail.createOrders': 'Создать черновики заказов',
  'reorder.detail.createOrdersHint': 'Группируются по поставщикам. Документы остаются ЧЕРНОВИКАМИ — система не может сама принять обязательство на 3–4 месяца.',
  'reorder.detail.ordersCreated': 'Создано черновиков заказов: {count}',
  'reorder.detail.skipped': 'Не вошло в заказ: отклонено {rejected} · без поставщика {noSupplier} · нулевое количество {zeroQty}',
  'reorder.detail.missingPrice': 'Строк без цены: {count}',
  'reorder.detail.alreadyOrdered': 'Заказы по этому анализу уже созданы',
  'reorder.detail.openPo': 'Открыть заказ',
  'reorder.line.sku': 'SKU',
  'reorder.line.name': 'Наименование',
  'reorder.line.onHand': 'Остаток',
  'reorder.line.inTransit': 'В пути',
  'reorder.line.inTransitHint': 'Остаток по подтверждённым заказам поставщику: товар в производстве на заводе и товар, идущий в контейнере.',
  'reorder.line.reserved': 'Зарезервировано',
  'reorder.line.sold': 'Продано',
  'reorder.line.dailyAvg': 'Среднее за день',
  'reorder.line.leadTime': 'Срок поставки',
  'reorder.line.target': 'Требуется',
  'reorder.line.suggested': 'К заказу',
  'reorder.line.supplier': 'Поставщик',
  'reorder.line.noSupplier': 'Нет поставщика',
  'reorder.line.edit': 'Исправить',
  'reorder.line.reject': 'Отклонить',
  'reorder.line.rejected': 'Отклонено',
  'reorder.line.restore': 'Вернуть',
  'reorder.line.rejectReason': 'Причина отклонения',
  'reorder.line.rejectReasonHint': 'Минимум 3 символа. Причина сохраняется в документе.',
  'reorder.line.onlySuggested': 'Только те, что будут заказаны',
  'reorder.line.empty': 'Нет строк',
  'reorder.flag.negative_stock': 'Отрицательный остаток',
  'reorder.flag.negative_stockHint': 'Этот товар уже распродан — строка стоит в списке первой.',
  'reorder.flag.no_supplier': 'Нет поставщика',
  'reorder.flag.no_supplierHint': 'К товару не привязан активный поставщик — в заказ не попадёт.',
  'reorder.flag.no_price': 'Цена неизвестна',
  'reorder.flag.no_priceHint': 'В черновике цена останется нулевой. Заказ не останавливается: задержать заказ на 4 месяца из-за одного SKU без цены — это ровно тот случай, который мы хотим предотвратить.',
  'reorder.flag.above_formula': 'Больше формулы',
  'reorder.flag.above_formulaHint': 'Причина: MOQ (минимальная партия) или ручная корректировка.',
  'reorder.flag.below_formula': 'Меньше формулы',
  'reorder.flag.below_formulaHint': 'Количество уменьшено вручную.',
  'reorder.flag.draft_po': 'Есть неподтверждённый черновик',
  'reorder.flag.draft_poHint': 'По этому SKU есть незакрытый черновик, и он НЕ учтён в расчёте (это не обязательство). Ответом может быть не новый заказ, а подтверждение существующего.',
  'table.rowsPerPage': 'Строк на странице',
  'table.page': '{page} / {total}',
  'table.first': 'Первая',
  'table.previous': 'Предыдущая',
  'table.next': 'Следующая',
  'table.last': 'Последняя',
  'table.empty': 'Строки не найдены',
  'table.sortAsc': 'По возрастанию',
  'table.sortDesc': 'По убыванию',
  'table.total': 'Всего: {count}',
  'table.addRow': 'Новая строка (Enter)',
  'table.loadError': 'Не удалось загрузить данные',
  'table.pending': 'Экран ещё не готов',
  // --- Массовые действия ---
  'table.selectedCount': 'Выбрано строк: {count}',
  'table.selectAll': 'Выбрать всё на странице',
  'table.selectRow': 'Выбрать строку',
  'table.expandRow': 'Показать состав',
  'table.collapseRow': 'Скрыть состав',
  'bulk.progress': 'Выполняется: {done} / {total}',
  'bulk.partial': 'Успешно: {ok} · Не удалось: {failed}',
  'bulk.allDone': 'Выполнено: {count}',
  'bulk.failedHint':
    'Откройте невыполненные по одному — у каждой своя причина остановки.',
  'table.columns': 'Столбцы',
  'table.columnsAll': 'Показать все',
  'table.columnsLast': 'Хотя бы один столбец должен оставаться видимым',
  'table.clearSearch': 'Очистить поиск',
  'picker.product': 'Товар',
  'picker.productPlaceholder': 'SKU или наименование',
  'picker.productEmpty': 'Товар не найден — попробуйте старый код',
  'picker.productNoStock': 'Нет остатка',
  'picker.customer': 'Клиент',
  'picker.customerPlaceholder': 'Код, наименование или телефон',
  'picker.customerEmpty': 'Клиент не найден',
  'warehouse.title': 'Склад',
  'warehouse.select': 'Выберите склад',
  'warehouse.all': 'Все склады',
  'warehouse.from': 'Со склада',
  'warehouse.to': 'На склад',
  'inv.qty': 'Количество',
  'inv.unitCost': 'Себестоимость за единицу',
  'inv.lotNo': 'Партия (лот)',
  'inv.notes': 'Примечание',
  'inv.occurredAt': 'Дата документа',
  'inv.occurredAtHint': 'Вводить вчерашний документ сегодня — обычная ситуация: дата должна отражать день реального события.',
  'inv.product': 'Товар',
  'inv.sku': 'SKU',
  'inv.name': 'Наименование',
  'inv.warnings': 'Предупреждения',
  'inv.done': 'Выполнено',
  'inv.lineAdd': 'Добавить строку',
  'inv.lineRemove': 'Удалить строку',
  'inv.selectWarehouseFirst': 'Сначала выберите склад',
  'inv.docNo': 'Документ',
  'inv.status': 'Статус',
  'inv.date': 'Дата',
  'stock.title': 'Остатки на складе',
  'stock.description': 'Текущий остаток. Каждая строка ведёт в журнал: ответ на вопрос «откуда взялось это число?» — в один клик.',
  'stock.searchPlaceholder': 'Поиск по SKU или наименованию',
  'stock.onHand': 'Остаток',
  'stock.reserved': 'Зарезервировано',
  'stock.available': 'Свободно',
  'stock.inTransit': 'В пути',
  'stock.avgCost': 'Средняя себестоимость',
  'stock.totalValue': 'Стоимость',
  'stock.updatedAt': 'Последнее движение',
  'stock.includeZero': 'Показывать нулевые остатки',
  'stock.includeZeroHint': 'SKU, который поступил один раз и был полностью распродан, навсегда останется нулевой строкой — поэтому такие строки обычно скрывают.',
  'stock.empty': 'Остатки не найдены',
  'stock.emptyHint': 'Расширьте фильтр или включите нулевые остатки.',
  'stock.loadError': 'Не удалось загрузить остатки',
  'stock.valueHidden': 'Колонки себестоимости и стоимости вам не показываются — это вопрос прав доступа, а не ошибка.',
  'stock.categoryGap': 'На этом экране нет разреза по категориям. Разрез по категориям — в отчёте «Остатки на складе».',
  'stock.openReport': 'Отчёт по остаткам →',
  'stock.rowHint': 'Нажмите на строку — откроется журнал по этому товару и складу.',
  'movement.title': 'Журнал склада',
  'movement.description': 'Каждый приход и каждое списание. Любое число из остатков раскрывается здесь построчно — спор об учёте заканчивается на этой таблице.',
  'movement.occurredAt': 'Время',
  'movement.txnType': 'Тип',
  'movement.txnTypeAll': 'Все типы',
  'movement.quantity': 'Количество',
  'movement.balanceQty': 'Остаток (после)',
  'movement.unitCost': 'Себестоимость за единицу',
  'movement.totalCost': 'Сумма',
  'movement.avgCostAfter': 'Средняя (после)',
  'movement.source': 'Источник',
  'movement.sourceAll': 'Все документы',
  'movement.sourceRef': '{table} — документ №{id}',
  'movement.reversal': 'Сторно',
  'movement.reversed': 'Сторнировано',
  'movement.empty': 'Движения не найдены',
  'movement.emptyHint': 'Расширьте период или снимите фильтр по товару.',
  'movement.loadError': 'Не удалось загрузить журнал',
  'movement.filterProduct': 'По товару',
  'movement.clearFilters': 'Очистить фильтры',
  'txn.receipt': 'Приход',
  'txn.issue': 'Списание',
  'txn.transfer_in': 'Перемещение (приход)',
  'txn.transfer_out': 'Перемещение (списание)',
  'txn.adjustment': 'Корректировка',
  'txn.count': 'Инвентаризация',
  'txn.return_in': 'Возврат от клиента',
  'txn.return_out': 'Возврат поставщику',
  'txn.revaluation': 'Переоценка',
  'txn.sample': 'Образец',
  'txn.display': 'Витрина',
  'txn.trial_out': 'Выдано на тест',
  'txn.trial_in': 'Возврат с теста',
  'src.manual': 'Вручную',
  'src.stock_transfer_lines': 'Перемещение между складами',
  'src.stock_count_lines': 'Инвентаризация',
  'src.delivery_lines': 'Накладная',
  'src.goods_receipt_lines': 'Приёмка (импорт)',
  'src.sales_return_lines': 'Возврат товара',
  'src.partner_supply_notices': 'Уведомление о поставке',
  'src.unknown': 'Другой документ',
  'receipt.title': 'Приход вручную',
  'receipt.description': 'Приходы КРОМЕ импортной приёмки: возврат от клиента, вернувшийся с теста образец, найденный вручную остаток.',
  'receipt.txnType': 'Тип прихода',
  'receipt.submit': 'Записать приход',
  'receipt.costWhy': 'Себестоимость ОБЯЗАТЕЛЬНА: без неё не рассчитывается средняя себестоимость и COGS следующего списания получится неверным.',
  'receipt.done': 'Приход записан: {qty} {sku}',
  'receipt.importHint': 'Приёмка контейнера через этот экран не вводится — она приходит из документа закупки (goods receipt) и рассчитывает полную себестоимость.',
  'issue.title': 'Списание вручную',
  'issue.description': 'Списания КРОМЕ продажи: образец, витрина, выдача на тест, возврат поставщику.',
  'issue.txnType': 'Тип списания',
  'issue.submit': 'Записать списание',
  'issue.noCost': 'При списании себестоимость не вводится: оно оценивается по ТЕКУЩЕЙ средней. Ручная цена списания открыла бы путь к «подгонке» прибыли.',
  'issue.done': 'Списание записано: {qty} {sku}',
  'issue.available': 'Свободный остаток: {qty}',
  'transfer.title': 'Перемещение между складами',
  'transfer.description': 'Списание записывается СРАЗУ: товар физически в пути, и показывать его в остатке склада-отправителя было бы неправдой. Приход — при приёмке.',
  'transfer.new': 'Новое перемещение',
  'transfer.create': 'Создать перемещение',
  'transfer.sameWarehouse': 'Склад-отправитель и склад-получатель не могут совпадать',
  'transfer.lines': 'Строки',
  'transfer.receive': 'Принять',
  'transfer.partialHint': 'По недошедшей строке укажите НОЛЬ — недостающее количество останется в документе и попадёт в предупреждения.',
  'transfer.receiveFull': 'Принять всё полностью',
  'transfer.receivePartial': 'Частичная приёмка',
  'transfer.receivedQty': 'Принято',
  'transfer.sentQty': 'Отправлено',
  'transfer.status.in_transit': 'В пути',
  'transfer.status.received': 'Принято',
  'transfer.status.cancelled': 'Отменён',
  'transfer.list': 'Документы перемещения',
  'transfer.statusAll': 'Все статусы',
  'transfer.lineCount': 'Строк',
  'transfer.totalQty': 'Всего количество',
  'transfer.createdBy': 'Кто создал',
  'transfer.empty': 'Документы перемещения не найдены',
  'transfer.emptyHint': 'Расширьте фильтр или создайте новое перемещение.',
  'transfer.loadError': 'Не удалось загрузить документы перемещения',
  'transfer.pending': 'Ожидают приёмки: {count}',
  'transfer.pendingNone': 'Нет перемещений, ожидающих приёмки',
  'transfer.openDoc': 'Открыть документ',
  'transfer.closeDoc': 'Закрыть документ',
  'transfer.created': 'Перемещение создано: {docNo}',
  'transfer.receivedOk': '{docNo} принят',
  'transfer.ledger': 'Движения по перемещению (из журнала)',
  'count.title': 'Инвентаризация',
  'count.description': 'Пересчёт вводит кладовщик, а ПОДТВЕРЖДАЕТ другой сотрудник. Недостача, которую сам посчитал и сам утвердил, не видна никому.',
  'count.new': 'Новый лист',
  'count.create': 'Создать лист',
  'count.type': 'Тип пересчёта',
  'count.type.full': 'Полная (весь склад)',
  'count.type.cycle': 'Циклическая (выбранные SKU)',
  'count.type.blind': 'Слепой пересчёт (остаток системы не виден)',
  'count.typeHint': 'При «слепом пересчёте» системный остаток счётчику не показывается. Сотрудник, увидевший число, невольно подгоняет запись под него, и пересчёт теряет смысл.',
  'count.products': 'Пересчитываемые товары',
  'count.productsHint': 'Если оставить пустым — в лист попадут ВСЕ товары, у которых есть строка на складе (полная инвентаризация).',
  'count.systemQty': 'Система',
  'count.countedQty': 'Посчитано',
  'count.varianceQty': 'Расхождение',
  'count.varianceValue': 'Сумма расхождения',
  'count.reason': 'Причина',
  'count.reasonRequired': 'В строке с расхождением необходимо указать причину',
  'count.saveLines': 'Сохранить строки',
  'count.post': 'Утвердить и записать в журнал',
  'count.postHint': 'После утверждения расхождения записываются в журнал склада, и отменить это нельзя.',
  'count.created': 'Лист создан: {docNo}',
  'count.saved': 'Строки сохранены',
  'count.posted': '{docNo} утверждён и записан в журнал',
  'count.approveElsewhere': 'Вы не можете утвердить этот лист — так задумано: недостача, которую сам посчитал и сам утвердил, не видна никому. Сохраните строки и сообщите финансисту или руководителю.',
  'count.list': 'Документы инвентаризации',
  'count.kind': 'Тип документа',
  'count.kind.all': 'Все',
  'count.kind.count': 'Инвентаризация (CNT)',
  'count.kind.adjustment': 'Корректировка (ADJ)',
  'count.kindHint': 'Пересчёт и корректировка хранятся в одной таблице и различаются только префиксом номера документа. Показывать их вперемешку — значит порождать вопрос «откуда взялся этот документ?».',
  'count.statusAll': 'Все статусы',
  'count.lineCount': 'Строк',
  'count.varianceLines': 'Строк с расхождением',
  'count.createdBy': 'Кто создал',
  'count.empty': 'Документы инвентаризации не найдены',
  'count.emptyHint': 'Расширьте фильтр или создайте новый лист.',
  'count.loadError': 'Не удалось загрузить документы инвентаризации',
  'count.open': 'Открытых листов: {count}',
  'count.openDoc': 'Открыть лист',
  'count.closeDoc': 'Закрыть лист',
  'count.detailLoadError': 'Не удалось загрузить лист',
  'count.blindSystemHidden': 'Слепой пересчёт: системный остаток на экране НЕ ПОКАЗЫВАЕТСЯ. Сервер отдаёт его в ответе на чтение, но экран его не выводит, чтобы сохранить смысл пересчёта.',
  'count.varianceValueHint': 'Денежная сумма расхождения показывается именно на этом экране — это отдельное узкое право, больше нигде себестоимость не раскрывается.',
  'count.status.draft': 'Вводится',
  'count.status.counted': 'Посчитано',
  'count.status.posted': 'Утверждён',
  'count.status.cancelled': 'Отменён',
  'variance.damaged': 'Повреждено',
  'variance.lost': 'Утеряно',
  'variance.miscount': 'Ошибка пересчёта',
  'variance.theft': 'Хищение',
  'variance.found': 'Найдены излишки',
  'variance.expired': 'Истёк срок годности',
  'variance.other': 'Другое',
  'variance.select': 'Выберите причину',
  'so.title': 'Заказы покупателей',
  'so.new': 'Новый заказ',
  'so.searchPlaceholder': 'Номер документа или клиент',
  'so.docNo': 'Документ',
  'so.customer': 'Клиент',
  'so.orderDate': 'Дата',
  'so.deliveryDate': 'Доставка',
  'so.total': 'Сумма',
  'so.paymentMethod': 'Оплата',
  'so.status': 'Статус',
  'so.statusAll': 'Все статусы',
  'so.empty': 'Заказы не найдены',
  'so.emptyHint': 'Расширьте фильтр или создайте новый заказ.',
  'so.loadError': 'Не удалось загрузить заказы',
  'so.onlyPreorder': 'Только со строками пре-заказа',
  'so.onlyPreorderHint': 'Заказы, проданные из контейнера в пути. При сдвиге ETA контейнера затрагиваются именно они.',
  'so.status.draft': 'Черновик',
  'so.status.submitted': 'Отправлен',
  'so.status.confirmed': 'Подтверждён',
  'so.status.partially_delivered': 'Частично отгружен',
  'so.status.delivered': 'Отгружен',
  'so.status.invoiced': 'Счёт-фактура выставлена',
  'so.status.closed': 'Закрыт',
  'so.status.cancelled': 'Отменён',
  'so.pay.cash': 'Наличные',
  'so.pay.transfer': 'Перевод',
  'so.pay.mixed': 'Смешанная',

  'so.source': 'Канал',
  'so.source.erp': 'Офис',
  'so.source.agent': 'Агент',
  'so.source.portal': 'Онлайн',
  'so.source.pos': 'Касса',

  'so.kinds': 'Строк',
  'so.kindsHint':
    'Сколько строк в заказе — те же строки, что видны при раскрытии. Не количество.',
  'so.linesLoadError': 'Не удалось загрузить строки заказа',
  'so.linesEmpty': 'В этом заказе нет строк',
  'so.openCard': 'Открыть карточку заказа',
  'so.newTitle': 'Новый заказ покупателя',
  'so.header': 'Шапка заказа',
  'so.currency': 'Валюта',
  'so.paymentTermDays': 'Срок оплаты, дней',
  'so.notes': 'Примечание',
  'so.submit': 'Создать заказ',
  'so.customerRequired': 'Необходимо выбрать клиента',
  'so.warehouseRequired': 'Необходимо выбрать склад',
  'so.linesRequired': 'Нужна хотя бы одна заполненная строка',
  'so.created': 'Заказ создан: {docNo}',
  'so.keyboardTitle': 'Ввод с клавиатуры',
  'so.keyboardHint': 'Tab — следующая ячейка, Enter — новая строка, Escape — очистить строку. В поле товара ↓/↑ двигают по списку, а Tab выбирает активную позицию и переходит к количеству. Мышь не нужна.',
  'bulk.open': 'Вставить список',
  'bulk.title': 'Вставьте список',
  'bulk.hint': 'Каждая строка: КОД, количество, цена. Колонки разделяются TAB или «;» (при копировании из Excel так и получается). Оставьте цену пустой — возьмётся договорная цена клиента.',
  'bulk.placeholder': 'LMP-001\t10\nPNL-060\t25\t24.50',
  'bulk.hintNoPrice': 'Каждая строка: КОД, количество. Колонки разделяются TAB или «;» (при копировании из Excel так и получается). В этом документе цена не вводится — её определяет сервер.',
  'bulk.placeholderNoPrice': 'LMP-001\t10\nPNL-060\t25',
  'bulk.rows': 'строк: {count}',
  'bulk.apply': 'Добавить',
  'bulk.resolving': 'Проверяем коды…',
  'bulk.tooMany': 'За один раз до {max} строк. Вставьте список частями — ничего не потеряется.',
  'bulk.invalid': 'Ошибки в {count} строках (строки: {lines}). Код пуст, количество не больше нуля или неверный формат цены.',
  'bulk.unknownTitle': 'Эти коды не найдены',
  'bulk.unknownBody': '{skus} — остальные добавлены. Проверьте код или сначала заведите товар в каталоге.',
  'bulk.noneResolved': 'Ни один код не найден — ничего не добавлено',
  'so.lines': 'Строки',
  'so.lineNo': '№',
  'so.lineQty': 'Количество',
  'so.lineListPrice': 'Цена по прайс-листу',
  'so.linePrice': 'Цена',
  'so.lineAmount': 'Сумма',
  'so.lineDiscount': 'Скидка',
  'so.lineType': 'Обеспечение',
  'so.linePriceSource': 'Источник цены',
  'so.lineBonus': 'Бонус',
  'so.lineRemove': 'Удалить строку',
  'so.lineAdd': 'Добавить строку (Enter)',
  'so.priceLoading': 'Цена определяется…',
  'so.priceMissing': 'Цена не найдена — введите вручную',
  'price.customer_price': 'Цена клиента',
  'price.price_list': 'Прайс-лист',
  'price.manual': 'Вручную',
  'price.sourceHint.customer_price': 'Специальная цена, согласованная с клиентом',
  'price.sourceHint.price_list': 'Из прайс-листа «{code}»',
  'price.sourceHint.manual': 'Цена введена вручную — подразумеваемая скидка {pct}%',
  'so.fulfillment.stock': 'На складе',
  'so.fulfillment.preorder': 'В пути (пре-заказ)',
  'so.preorderShipment': 'Контейнер',
  'so.preorderShipmentRequired': 'Для строки пре-заказа необходимо выбрать контейнер',
  'so.preorderSelectShipment': 'Выберите контейнер',
  'so.preorderEta': 'ETA {date}',
  'so.preorderFree': 'свободно {qty}',
  'so.preorderNoShipment': 'Этого товара нет в открытых контейнерах',
  'so.preorderNoAccess': 'У вас нет права просматривать список контейнеров — строку пре-заказа ввести нельзя. При необходимости обратитесь к руководителю.',
  'so.promisedDate': 'Обещанная дата',
  'so.promisedDateHint': 'Дата, названная клиенту. При сдвиге ETA контейнера предупреждение придёт именно по этой строке.',
  'so.preorderWhy': 'Срок поставки 120–150 дней: клиент покупает товар, который ещё не вышел из Китая. Это не исключение, а половина бизнеса — поэтому «на складе» и «в пути» в строке ПУТАТЬ нельзя.',
  'so.mixSummary': 'Строк на складе: {stock}, в пути: {preorder}',
  'so.bonusHint': 'Цена бонусной строки — 0, но СЕБЕСТОИМОСТЬ реальная: этот товар стоит компании денег и вычитается из маржи. Бонус — это скрытая скидка.',
  'so.bonusCostWarning': 'Бонус: цена 0, себестоимость сохраняется',
  'so.bonusValue': 'Стоимость бонуса (по прайс-листу)',
  'so.totals': 'Итого',
  'so.subtotal': 'Сумма строк',
  'so.discountTotal': 'Скидка',
  'so.grandTotal': 'Сумма к оплате',
  'so.totalPreview': 'Предварительный расчёт — итоговая сумма придёт с сервера',
  'so.lineCount': 'Строк: {count}',
  'so.paymentChanged': 'Способ оплаты изменён: {from} → {to}',
  'so.paymentChangedBody': 'Все строки ПЕРЕсчитаны. Цена за наличные и по переводу отличается на 3–7%, и эта разница не должна исчезнуть незаметно — ниже показано, что изменилось.',
  'so.repricing': 'Строки пересчитываются…',
  'so.repricedNone': 'Ни в одной строке цена не изменилась.',
  'so.repricedManualKept': 'Введённые вручную цены не тронуты — они результат договорённости и автоматически не правятся.',
  'so.repricedOld': 'Старая цена',
  'so.repricedNew': 'Новая цена',
  'so.repricedDelta': 'Разница',
  'so.repricedLost': 'Для этого способа оплаты цена не найдена',
  'so.dismiss': 'Закрыть',
  'so.credit': 'Состояние кредита',
  'so.creditLimit': 'Лимит',
  'so.creditDebt': 'Текущая задолженность',
  'so.creditAvailable': 'Свободный лимит',
  'so.creditOverdue': 'Просрочено',
  'so.creditBlockedCustomer': 'Клиент ЗАБЛОКИРОВАН — этот заказ не будет подтверждён',
  'so.creditWillExceed': 'Сумма заказа превышает свободный лимит. При подтверждении кредитная проверка его остановит.',
  'so.creditNoLimit': 'Лимит не установлен',
  'so.creditCurrencyNote': 'Сравнение показывается только для заказов в USD: задолженность ведётся в USD, а сумма в другой валюте пересчитывается по курсу сервера.',
  'so.creditLoadError': 'Не удалось загрузить задолженность клиента',
  'so.detailTitle': 'Заказ {docNo}',
  'so.confirm': 'Подтвердить',
  'so.confirmHint': 'При подтверждении проверяется кредитный лимит и товар резервируется.',
  'so.confirmed': 'Заказ подтверждён',
  'so.cancel': 'Отменить',
  'so.cancelTitle': 'Отмена заказа',
  'so.cancelReason': 'Причина отмены',
  'so.cancelReasonRequired': 'Причина должна содержать не менее 3 символов',
  'so.cancelled': 'Заказ отменён',
  'so.createDelivery': 'Создать накладную',
  'so.createDeliveryHint': 'Накладная создаётся, но НЕ ПРОВОДИТСЯ: её печатают, грузят в машину, и после фактической отгрузки кладовщик её подтверждает.',
  'so.deliveryCreated': 'Накладная создана: {docNo}',
  'so.createInvoice': 'Создать счёт-фактуру',
  'so.createInvoiceHint': 'Счёт-фактура выписывается на ФАКТИЧЕСКИ отгруженный товар — она строится из строк проведённой накладной.',
  'so.invoiceCreated': 'Счёт-фактура создана: {docNo}',
  'so.deliveries': 'Накладные',
  'so.invoices': 'Счета-фактуры',
  'so.noDeliveries': 'Накладных нет',
  'so.noInvoices': 'Счетов-фактур нет',
  'so.notFound': 'Заказ не найден или вам не виден',
  'so.deliveredQty': 'Отгружено',
  'so.creditCheck': 'Кредитная проверка',
  'so.creditCheck.passed': 'Пройдена',
  'so.creditCheck.blocked': 'Остановлен',
  'so.creditBlockedBody': 'Этот заказ остановлен из-за кредитного лимита. Он не отменён — он открыт для переговоров: если клиент внесёт оплату или руководитель пропустит его сверх лимита, подтверждение продолжится.',
  'so.creditCheck.overridden': 'ПРОПУЩЕН СВЕРХ ЛИМИТА',
  'so.creditOverriddenTitle': 'Этот заказ ПРОПУЩЕН сверх кредитного лимита',
  'so.creditOverriddenBody': 'Открытая задолженность клиента превышает лимит, но сотрудник осознанно пропустил заказ. Причина сохраняется в журнале аудита. Сделать это решение невидимым нельзя — если долг не будет взыскан, ответ начинается с этой строки.',
  'so.overrideTitle': 'Пропуск сверх кредитного лимита',
  'so.overrideReason': 'Причина',
  'so.overrideReasonRequired': 'Причина должна содержать не менее 5 символов',
  'so.overrideSubmit': 'Подтвердить с указанием причины',
  'so.overrideNoPermission': 'У вас нет права пропускать заказ сверх кредитного лимита. Обратитесь к руководителю.',
  'so.margin': 'Маржа',
  'so.marginCogs': 'Себестоимость',
  'so.marginProfit': 'Валовая прибыль',
  'so.marginPct': 'Маржа, %',
  'so.marginBonusCost': 'Себестоимость бонуса',
  'so.marginHidden': 'Показатели маржи вам не раскрываются — это вопрос прав доступа.',
  'dlv.title': 'Доставки',
  'dlv.description': 'Что доставляется сегодня и кто везёт. После выписки накладной к ней привязывается водитель — машину грузит кладовщик, значит он же знает, кому её отдать.',
  'dlv.docNo': 'Накладная',
  'dlv.salesOrder': 'Заказ',
  'dlv.date': 'Дата',
  'dlv.status': 'Статус документа',
  'dlv.status.draft': 'Черновик',
  'dlv.status.posted': 'Проведена',
  'dlv.status.cancelled': 'Отменена',
  'dlv.statusAll': 'Все статусы',
  'dlv.driver': 'Водитель',
  'dlv.driverAll': 'Все водители',
  'dlv.driverStatus': 'Статус доставки',
  'dlv.driverStatus.unassigned': 'Не назначен',
  'dlv.driverStatus.pending': 'Ожидает',
  'dlv.driverStatus.delivered': 'Доставлено',
  'dlv.driverStatus.failed': 'Не доставлено',
  'dlv.filterUnassigned': 'Только неназначенные',
  'dlv.filterUnassignedHint': 'Утренняя работа начинается с этого списка: доставки, которые ещё никому не переданы.',
  'dlv.filterDate': 'Дата доставки',
  'dlv.searchPlaceholder': 'Номер накладной или заказа',
  'dlv.empty': 'Доставки не найдены',
  'dlv.emptyHint': 'Расширьте фильтр по дате или статусу.',
  'dlv.loadError': 'Не удалось загрузить список доставок',
  'dlv.actions': 'Действие',
  'dlv.assign': 'Назначить',
  'dlv.reassign': 'Переназначить',
  'dlv.unassign': 'Снять',
  'dlv.assignTitle': '{docNo} — назначение водителя',
  'dlv.assignDriverPlaceholder': 'Выберите водителя',
  'dlv.assignMany': 'Назначить на {count} доставок',
  'dlv.assignVehicle': 'Номер машины',
  'dlv.assignVehicleHint': 'Необязательно. Загружаемую машину вы видите прямо сейчас — вводить её потом на отдельном экране почти никогда не получается.',
  'dlv.assignSubmit': 'Назначить',
  'dlv.assigned': '{docNo} — назначен водитель {driver}',
  'dlv.unassignDone': '{docNo} — назначение снято',
  'dlv.unassignHint': 'При снятии очищаются и имя водителя, и номер машины: они были записаны от этого водителя при назначении.',
  'dlv.assignedAt': 'Назначено',
  'dlv.driversEmpty': 'Нет активных водителей. Чтобы назначить, сотруднику сначала нужно выдать роль водителя — это делает администратор.',
  'dlv.driversLoadError': 'Не удалось загрузить список водителей',
  'dlv.notAssignable': 'Не изменяется',
  'dlv.notAssignableHint': 'Отменённый документ или завершённая доставка повторно не назначаются — это было бы переписыванием истории.',
  'dlv.failReason': 'Причина недоставки',
  'dlv.receivedBy': 'Принял',
  'dlv.deliveredAt': 'Время доставки',
  'dlv.cashTitle': 'Наличные на руках у водителей',
  'dlv.cashHint': 'Это НЕ платёж: задолженность клиента не уменьшается и в кассу деньги не поступили. Когда деньги сданы, платёж создаёт финансист — именно тогда закрывается долг.',
  'dlv.cashEmpty': 'За этот период наличные у водителей не накапливались',
  'dlv.cashLoadError': 'Не удалось загрузить данные по наличным',
  'dlv.cashDeliveries': 'Доставок: {count}',
  'dlv.cashTotal': 'Итого',
  'dlv.cashAmount': 'Сумма',
  'customer.tab.card': 'Карточка',
  'customer.tab.portal': 'Пользователи кабинета',
  'pu.title': 'Пользователи кабинета клиента',
  'pu.description': 'Сотрудники магазина входят в кабинет по НОМЕРУ ТЕЛЕФОНА. Для каждого сотрудника открывается отдельная учётная запись: чтобы затем можно было определить, кто оформил заказ.',
  'pu.empty': 'У этого клиента нет пользователей кабинета',
  'pu.emptyHint': 'Если открыть кабинет, продавец сам оформит заказ и увидит свою задолженность.',
  'pu.loadError': 'Не удалось загрузить пользователей кабинета',
  'pu.phone': 'Телефон',
  'pu.fullName': 'Имя',
  'pu.position': 'Должность',
  'pu.positionHint': 'Функция в магазине: владелец, продавец, бухгалтер. Произвольный текст.',
  'pu.canOrder': 'Оформление заказов',
  'pu.canOrder.yes': 'Может оформлять заказы',
  'pu.canOrder.no': 'Только просмотр',
  'pu.canOrderHint': '«Только просмотр» — это НЕ блокировка: человек входит в кабинет, видит каталог, свою задолженность и историю заказов, но не может отправить новый заказ. Именно это и нужно бухгалтеру магазина.',
  'pu.status': 'Статус',
  'pu.active': 'Активен',
  'pu.blocked': 'Заблокирован',
  'pu.mustChange': 'Требуется смена пароля',
  'pu.invitedAt': 'Открыт',
  'pu.lastLoginAt': 'Последний вход',
  'pu.neverLoggedIn': 'Ещё не входил',
  'pu.new': 'Открыть кабинет',
  'pu.newTitle': 'Новый пользователь кабинета',
  'pu.phoneHint': 'Пишите в произвольном формате (можно и +998 90 123-45-67) — сервер приведёт номер к единому виду.',
  'pu.phoneRequired': 'Номер телефона должен содержать не менее 9 символов',
  'pu.fullNameRequired': 'Имя должно содержать не менее 2 символов',
  'pu.submit': 'Открыть и выдать пароль',
  'pu.block': 'Заблокировать',
  'pu.unblock': 'Разблокировать',
  'pu.blockTitle': '{name} — блокировка кабинета',
  'pu.blockReasonRequired': 'Причина блокировки должна содержать не менее 3 символов',
  'pu.blockReasonWhy': 'Причина остаётся в аудите: вопрос «почему эта учётная запись закрыта?» через месяц возникнет неизбежно.',
  'pu.blockDone': '{name} — кабинет заблокирован',
  'pu.unblockDone': '{name} — кабинет разблокирован',
  'pu.reset': 'Сбросить пароль',
  'pu.resetHint': 'Старый пароль сразу перестанет действовать, а открытые сеансы будут завершены. Новый пароль вы передадите продавцу сами.',
  'pu.secretTitle': 'Временный пароль — показывается ОДИН РАЗ',
  'pu.secretBody': 'Запишите этот пароль сейчас или продиктуйте продавцу. В базе хранится только его хеш, то есть сервер его ПОВТОРНО НЕ ВЫДАСТ: после закрытия этого окна единственный путь — сбросить пароль заново.',
  'pu.secretFor': '{name} · {phone}',
  'pu.secretAck': 'Я записал',
  'pu.actions': 'Действие',
  'pu.created': 'Кабинет для {name} открыт',
  'pu.resetDone': 'Для {name} выдан новый пароль',
  'po.title': 'Заказы поставщику',
  'po.description': 'Заказ, размещённый на китайском заводе. Строки — в валюте завода (CNY), рядом — эквивалент в долларах по курсу ДОКУМЕНТА, а не по сегодняшнему курсу.',
  'po.new': 'Новый заказ',
  'po.newTitle': 'Новый заказ поставщику',
  'po.detailTitle': 'Заказ поставщику {docNo}',
  'po.searchPlaceholder': 'Номер документа или поставщик',
  'po.docNo': 'Документ',
  'po.supplier': 'Поставщик',
  'po.supplierRequired': 'Необходимо выбрать поставщика',
  'po.legalEntity': 'Юридическое лицо',
  'po.orderDate': 'Дата заказа',
  'po.expectedDate': 'Ожидаемая дата',
  'po.expectedDateHint': 'Ожидаемая дата с фабрики. Срок производства и поставки 120–150 дней — план строится исходя из этого.',
  'po.currency': 'Валюта',
  'po.status': 'Статус',
  'po.statusAll': 'Все статусы',
  'po.notes': 'Примечание',
  'po.lines': 'Строки',
  'po.lineQty': 'Количество',
  'po.lineUnitPrice': 'Цена ({currency}/шт.)',
  'po.lineAmount': 'Сумма ({currency})',
  'po.lineBase': 'Эквивалент в USD',
  'po.received': 'Принято',
  'po.outstanding': 'Ожидается',
  'po.total': 'Итого ({currency})',
  'po.totalBase': 'Итого (USD)',
  'po.fxRate': 'Курс документа',
  'po.fxRateLine': '1 USD = {rate} {currency}',
  'po.fxRateWhy': 'Эквивалент в USD рассчитан по курсу ДОКУМЕНТА, а не по сегодняшнему курсу. Если заказ размещён 4 месяца назад, тогдашний курс не имеет отношения к сегодняшней стоимости — курс фиксируется в документе и не меняется.',
  'po.priceHidden': 'Столбцы цены и суммы вам не показываются — у вас нет права просматривать данные поставщиков. Это вопрос прав доступа, а не ошибка; при необходимости обратитесь к руководителю.',
  'po.submit': 'Создать заказ',
  'po.created': 'Заказ создан: {docNo}',
  'po.approve': 'Утвердить',
  'po.approveTitle': 'Утверждение заказа',
  'po.approveHint': 'После утверждения заказ считается переданным на фабрику, и строки изменить нельзя: если документ разойдётся с фактически идущим товаром, разница при приёмке будет выглядеть как «недостача», хотя на самом деле неверен документ.',
  'po.approveNotes': 'Примечание (попадает в аудит)',
  'po.approved': 'Заказ утверждён',
  'po.approvedAt': 'Утверждён',
  'po.notApprovable': 'В этом статусе утверждение невозможно — утверждаются только черновик и отправленный заказ.',
  'po.cancel': 'Отменить',
  'po.cancelTitle': 'Отмена заказа',
  'po.cancelHint': 'Отменённый заказ выбывает из списка «ожидаемый товар», и вернуть его нельзя. Если товар уже поступил (приёмка проведена), отмена НЕВОЗМОЖНА — отмена документа не убирает остаток на складе и рассчитанную себестоимость.',
  'po.cancelReason': 'Причина (обязательно, попадает в аудит)',
  'po.cancelReasonHint': 'Не менее 3 символов. Ответ на вопрос «почему заказ отменён?» останется именно здесь.',
  'po.cancelConfirm': 'Да, отменить',
  'po.cancelled': 'Заказ отменён',
  'po.cancelledTitle': 'Заказ отменён',
  'po.notCancellable': 'В этом статусе отмена невозможна — товар уже принят или документ закрыт.',
  'po.linesRequired': 'Нужна хотя бы одна полностью заполненная строка',
  'po.empty': 'Заказы не найдены',
  'po.emptyHint': 'Расширьте фильтр или создайте новый заказ.',
  'po.loadError': 'Не удалось загрузить заказы поставщику',
  'po.notFound': 'Заказ не найден или недоступен вам',
  'po.includeCancelled': 'Показывать также отменённые',
  'po.noSuppliers': 'Список поставщиков пуст или закрыт для вас',
  'po.status.draft': 'Черновик',
  'po.status.submitted': 'Отправлен',
  'po.status.approved': 'Утверждён',
  'po.status.in_production': 'В производстве',
  'po.status.shipped': 'Отгружен',
  'po.status.partially_received': 'Принят частично',
  'po.status.received': 'Принят',
  'po.status.closed': 'Закрыт',
  'po.status.cancelled': 'Отменён',
  'shp.title': 'Контейнеры',
  'shp.description': 'Отгрузки в пути и прибывшие. В каждой строке — ETA и факт, статус себестоимости и САМОЕ ГЛАВНОЕ — сколько продано из контейнера.',
  'shp.new': 'Новый контейнер',
  'shp.newTitle': 'Новый контейнер',
  'shp.detailTitle': 'Контейнер {docNo}',
  'shp.searchPlaceholder': 'Номер документа или контейнера',
  'shp.docNo': 'Документ',
  'shp.containerNo': 'Контейнер',
  'shp.blNo': 'Коносамент (BL)',
  'shp.departurePort': 'Порт отправления',
  'shp.arrivalPort': 'Порт прибытия',
  'shp.etd': 'ETD (план)',
  'shp.eta': 'ETA (план)',
  'shp.atd': 'Отправлен (факт)',
  'shp.ata': 'Прибыл (факт)',
  'shp.delay': 'Задержка',
  'shp.delayDays': '+{days} дн.',
  'shp.earlyDays': '−{days} дн.',
  'shp.onTime': 'В срок',
  'shp.noAta': 'Ещё не прибыл',
  'shp.delayHint': 'Задержка — единственная мера надёжности поставщика. План в 120–150 дней опирается именно на этот столбец.',
  'shp.status': 'Статус',
  'shp.statusAll': 'Все статусы',
  'shp.lcStatus': 'Статус себестоимости',
  'shp.lcStatusAll': 'Все статусы себестоимости',
  'shp.notes': 'Примечание',
  'shp.lines': 'Строки',
  'shp.lineQty': 'Количество',
  'shp.sold': 'Продано',
  'shp.free': 'Свободно',
  'shp.soldPct': 'Доля проданного',
  'shp.weightKg': 'Брутто, кг/шт.',
  'shp.netWeightKg': 'Нетто, кг/шт.',
  'shp.volumeM3': 'Объём, м³/шт.',
  'shp.dimHint': 'Это ФАКТИЧЕСКИЙ замер: при другой упаковке он отличается от данных карточки товара. Если оставить пустым, распределение возьмёт значения из справочника товаров. БРУТТО — с упаковкой (по нему распределяется фрахт), НЕТТО — сам товар (для таможенной декларации).',
  'shp.customsTitle': 'Итого для таможни',
  'shp.customsHint': '1 партия груза — 1 документ: эти цифры переносятся в декларацию как есть. Итог считается ИЗ СТРОК (количество × значение на штуку), поэтому сложение колонки таблицы на глаз даёт другой результат.',
  'shp.totalQty': 'Всего штук',
  'shp.totalCartons': 'Всего коробок',
  'shp.totalGross': 'Итого брутто, кг',
  'shp.totalNet': 'Итого нетто, кг',
  'shp.totalVolume': 'Итого объём, м³',
  'shp.customsIncompleteTitle': 'Итог неполный',
  'shp.customsIncompleteBody': 'Строк без замера: брутто — {gross}, нетто — {net}, объём — {volume}. Они НЕ вошли в итог, то есть в декларацию может уйти заниженная цифра. Проверьте колонки N.W. и G.W. в инвойсе.',
  'shp.presoldTitle': 'Продано до прихода контейнера',
  'shp.presoldBody': 'Из этой отгрузки {sku} продан на 100% — свободный остаток равен нулю. Если всё продано ещё до прихода контейнера, значит заказано МАЛО: деньги остались на столе. Определяйте количество следующего заказа, ориентируясь на эту строку.',
  'shp.presoldBadge': 'Продано полностью',
  'shp.underOrdered': 'Заказано мало — по {count} SKU нет свободного остатка',
  'shp.linesUnavailable': 'Не удалось загрузить строки — «продано/свободно» не показывается',
  'shp.empty': 'Контейнеры не найдены',
  'shp.emptyHint': 'Расширьте фильтр или включите показ закрытых.',
  'shp.includeClosed': 'Показывать также закрытые',
  'shp.loadError': 'Не удалось загрузить контейнеры',
  'shp.notFound': 'Контейнер не найден или недоступен вам',
  'shp.created': 'Контейнер создан: {docNo}',
  'shp.submit': 'Создать контейнер',
  'shp.advanceStatus': 'Перевести статус в «{status}»',
  'shp.statusChanged': 'Статус изменён: {status}',
  'shp.openReceipt': 'Принять товар',
  'shp.openProfit': 'Отчёт о рентабельности',
  'shp.status.planned': 'Запланирован',
  'shp.status.in_transit': 'В пути',
  'shp.status.at_customs': 'На таможне',
  'shp.status.cleared': 'Выпущен с таможни',
  'shp.status.received': 'Принят',
  'shp.status.closed': 'Закрыт',
  'lcs.pending': 'Не рассчитана',
  'lcs.estimated': 'Предварительная',
  'lcs.final': 'Окончательная',
  'shp.tab.lines': 'Строки',
  'shp.tab.costs': 'Расходы',
  'shp.tab.landedCost': 'Расчёт себестоимости',
  'cost.title': 'Расходы по контейнеру',
  'cost.description': 'Фрахт, таможня, брокер, сертификаты. Каждый расход вводится в СВОЕЙ валюте и переводится в доллары по курсу на СВОЮ дату.',
  'cost.add': 'Добавить расход',
  'cost.type': 'Вид расхода',
  'cost.typeSelect': 'Выберите вид',
  'cost.description2': 'Примечание',
  'cost.amount': 'Сумма',
  'cost.currency': 'Валюта',
  'cost.fxRate': 'Курс',
  'cost.amountBase': 'Эквивалент в USD',
  'cost.incurredDate': 'Дата расхода',
  'cost.incurredDateHint': 'Курс берётся ИМЕННО на эту дату. Пошлина уплачивается в UZS и считается по курсу на дату пошлины — а не по сегодняшнему курсу.',
  'cost.documentRef': 'Номер документа',
  'cost.isEstimate': 'Предварительный (документ ещё не поступил)',
  'cost.isEstimateHint': 'С предварительным расходом себестоимость рассчитывается как «estimate», и товар выходит в продажу. После поступления документов выполняется пересчёт «final».',
  'cost.estimateBadge': 'Предварительный',
  'cost.supplier': 'Кому оплачивается',
  'cost.supplierHint': 'Оставьте пустым: пошлина и сбор платятся государству, отсрочки не бывает',
  'cost.supplierNone': 'Никому (пошлина, сбор)',
  'cost.supplierAssign': 'Указать контрагента',
  'cost.supplierSaved': 'Контрагент записан',
  'cost.invoicedBadge': 'Счёт поступил',
  'cost.invoicedLocked': 'По этой строке счёт признан — контрагент и сумма больше не меняются.',
  'cost.allocMethod': 'Способ распределения',
  'cost.allocRecommended': 'Рекомендуется: {method}',
  'cost.allocOverridden': 'Отличается от рекомендованного',
  'cost.allocWhy': 'Способ распределения — ФИНАНСОВОЕ решение, а не выбор разработчика. Светодиодные товары лёгкие, но объёмные: распределение морского фрахта по весу делает крупный плафон искусственно дешёвым, а маленькую лампу — искусственно дорогой. На типовом контейнере один неверный выбор переносит $448 на неверный SKU.',
  'cost.totalBase': 'Итого расходов (USD)',
  'cost.added': 'Расход добавлен',
  'cost.empty': 'По этому контейнеру расходы не введены',
  'cost.emptyHint': 'Без расходов расчёт себестоимости даёт только цену товара — это не полная себестоимость.',
  'cost.loadError': 'Не удалось загрузить расходы',
  'cost.amountRequired': 'Сумма должна быть больше нуля',
  'cost.typeRequired': 'Необходимо выбрать вид расхода',
  'cost.noEditPermission': 'У вас нет права добавлять расходы. При необходимости обратитесь к руководителю.',
  'alloc.value': 'По стоимости',
  'alloc.quantity': 'По количеству',
  'alloc.weight': 'По весу',
  'alloc.volume': 'По объёму',
  'alloc.manual': 'Вручную',
  'alloc.hint.value': 'Страхование, пошлина, банковская комиссия — пропорционально стоимости',
  'alloc.hint.quantity': 'Поштучные сборы, сертификация',
  'alloc.hint.weight': 'Внутренняя перевозка, авиагруз — по весу',
  'alloc.hint.volume': 'Контейнерный фрахт и хранение — место продаётся по объёму',
  'alloc.hint.manual': 'Расход, относящийся к одному SKU, — долю вводит оператор',
  'costing.title': 'Раздел себестоимости',
  'costing.intro': 'Выберите контейнер: загрузите заводской счёт-фактуру, введите расходы и посмотрите себестоимость каждого товара. Расход распределяется по кубатуре, весу, количеству или стоимости — способ выбирается в строке каждого расхода.',
  'costing.selectPrompt': 'Чтобы начать работу, выберите контейнер из списка выше.',
  'costing.containers': 'Контейнеры',
  'costing.docNo': 'Документ',
  'costing.container': 'Контейнер',
  'costing.lcStatus': 'Статус себестоимости',
  'costing.lineCount': 'Строки',
  'costing.costCount': 'Расходы',
  'costing.costTotal': 'Итого расходов',
  'costing.eta': 'Прибытие (ETA)',
  'costing.noContainers': 'Контейнеры не найдены',
  'costing.open': 'Открыть',
  'costing.estimateCount': 'предварительных: {count}',
  'costing.totalRow': 'ИТОГО',
  'costing.archived': 'В архиве',
  'costing.basis.receipt': 'По приёмке — проводится',
  'costing.basis.shipment': 'По отгрузке — ожидаемая, не проводится',
  'costing.basis.none': 'Не рассчитано',
  'costing.rate': 'Курс {currency} — {rate} ({date})',
  'costing.totalQty': 'Всего штук',
  'costing.totalCartons': 'Коробки',
  'costing.totalVolume': 'Общий объём',
  'costing.totalWeight': 'Общий вес',
  'costing.purchaseBase': 'Цена Китая (USD)',
  'costing.costsBase': 'Расходы (USD)',
  'costing.runType': 'Вид расчёта',
  'costing.runType.estimate': 'Предварительный (estimate)',
  'costing.runType.final': 'Окончательный (final)',
  'costing.runTypeHint': 'Предварительный — пока не поступили все документы. Окончательный — после поступления всех документов; разница попадает в стоимость запасов, а по проданной части — в COGS.',
  'costing.result': 'РЕЗУЛЬТАТ — себестоимость каждого товара',
  'costing.resultHint': 'В столбце каждого расхода два числа: сумма, отнесённая на этот товар, и его доля в базе распределения. Доля соответствует именно способу этого расхода (если распределяется по объёму — доля объёма).',
  'costing.sku': 'Товар',
  'costing.qty': 'Количество',
  'costing.bases': 'База распределения',
  'costing.chinaPrice': 'Цена Китая',
  'costing.landedUnit': 'Расходы / шт.',
  'costing.totalUnitCost': 'СЕБЕСТОИМОСТЬ / шт.',
  'costing.landedPct': 'Доля расходов',
  'costing.noLines': 'Строк нет — сначала загрузите счёт-фактуру',
  'costing.cartons': '{count} коробок · {dims} см',
  'costing.valueShare': 'стоимость {pct}',
  'costing.balance': 'Проверка итогов',
  'costing.balanceHint': 'По каждому расходу: введённая сумма и сумма, распределённая по строкам. Разница должна быть НУЛЕВОЙ — остаток округления не теряется, он относится на самую крупную строку.',
  'costing.cost': 'Расход',
  'costing.entered': 'Введено',
  'costing.allocated': 'Распределено',
  'costing.diff': 'Разница',
  'costing.balanced': 'Сходится ✓',
  'costing.unbalanced': 'НЕ СХОДИТСЯ',
  'costing.noCosts': 'Расходы не введены',
  'costing.costs': 'Расходы и способ распределения',
  'costing.import': 'Загрузить заводской счёт-фактуру',
  'costing.importHint': 'Excel или CSV. Столбцы определены автоматически по заголовкам. Сначала «Предпросмотр» — в базу ничего не записывается; кнопка «Записать» открывается только при отсутствии ошибок.',
  'costing.import.file': 'Файл счёта-фактуры',
  'costing.import.mode': 'Режим',
  'costing.import.append': 'Добавить',
  'costing.import.replace': 'Заменить (старые строки удаляются)',
  'costing.import.po': 'ID заказа поставщику',
  'costing.import.poHint': 'Если указан: строки привязываются к заказу, а цена в юанях из счёта-фактуры сверяется с ценой в заказе.',
  'costing.import.preview': 'Предпросмотр',
  'costing.import.commit': 'Записать',
  'costing.import.template': 'Шаблон (.xlsx)',
  'costing.import.done': 'Записано строк: {created}, удалено строк: {removed}',
  'costing.import.rows': 'Строки',
  'costing.import.recognized': 'Распознано',
  'costing.import.unknown': 'Неизвестный код',
  'costing.import.missingDims': 'Без размеров',
  'costing.import.errors': 'Ошибки',
  'costing.import.columns': 'Лист «{sheet}», строка заголовка — {headerRow}. Распознанные столбцы: {columns}',
  'costing.import.unmapped': 'Нераспознанные столбцы: {columns}',
  'costing.import.row': 'Строка',
  'costing.import.grossKg': 'Брутто, кг',
  'costing.import.netKg': 'Нетто, кг',
  'costing.import.issues': 'Ошибка / предупреждение',
  'costing.import.ok': 'Без замечаний',
  'costing.runs': 'Расчёты себестоимости',
  'costing.run.done': 'Расчёт «{runType}» проведён. Стоимость запасов: {value}',
  'costing.run.needsReceipt': 'Для проведения нужен документ приёмки: расходы распределяются на ФАКТИЧЕСКИ поступившее количество, а не на ожидаемое.',
  'costing.run.estimate': 'Провести предварительную себестоимость',
  'costing.run.final': 'Провести окончательную себестоимость',
  'costing.run.hint': 'Исправление после проведения означает сторнирование и переоценку.',
  'costing.run.type': 'Вид',
  'costing.run.date': 'Дата',
  'costing.run.status': 'Статус',
  'costing.run.none': 'Ещё не рассчитано',
  'costing.defaults': 'Способ по умолчанию для вида расхода',
  'costing.defaultsHint': '«Растаможка обычно по кг» — задаётся один раз и выбирается автоматически при добавлении нового расхода. Себестоимость существующих контейнеров НЕ МЕНЯЕТСЯ.',
  'costing.defaultAlloc': 'Распределение по умолчанию',
  'lc.title': 'Расчёт полной себестоимости (landed cost)',
  'lc.description': '«Во сколько этот товар обошёлся на складе?» — единственный верный ответ на этот вопрос. Цена в китайском инвойсе — это даже не половина ответа.',
  'lc.preview': 'Предварительный расчёт',
  'lc.previewAgain': 'Пересчитать',
  'lc.previewHint': 'Этот расчёт НИЧЕГО не сохраняет. Исправление после проведения означает сторнирование и переоценку, а каждая продажа в промежутке успеет записаться с неверной себестоимостью — поэтому сначала смотрят, а потом записывают.',
  'lc.purchaseBase': 'Стоимость товара (USD)',
  'lc.costsBase': 'Расходы (USD)',
  'lc.inventoryValue': 'Итого стоимость запасов (USD)',
  'lc.landedPct': 'Доля расходов',
  'lc.landedPctBig': 'Расходы составляют {pct}% от цены товара',
  'lc.landedPctOver100': 'Расходы ДОРОЖЕ САМОГО ТОВАРА. Фрахт, таможня, сертификаты и всё остальное вместе стоят больше самого товара. Именно поэтому назначать цену, глядя на цену в китайском инвойсе, не работает.',
  'lc.landedPctExample': '{sku}: цена Китая {purchase}, поступление на склад {total} — разница {pct}.',
  'lc.landedPctUnder100': 'Доля расходов — отношение распределённых расходов к цене товара. Основой ценообразования служит не цена товара, а ПОЛНАЯ СЕБЕСТОИМОСТЬ.',
  'lc.purchaseRate': 'Курс товара ({currency})',
  'lc.purchaseRateHint': 'Курс берётся на ДАТУ ПРИЁМКИ: именно в этот день товар становится активом. Дата заказа была 4 месяца назад, и тогдашний курс не имеет отношения к сегодняшней стоимости актива.',
  'lc.receiptDate': 'Дата приёмки',
  'lc.sku': 'SKU',
  'lc.quantity': 'Поступившее количество',
  'lc.expectedQuantity': 'Ожидалось',
  'lc.shortage': 'Недостача',
  'lc.purchaseUnitCost': 'Цена товара (шт.)',
  'lc.landedUnitCost': 'Расходы (шт.)',
  'lc.totalUnitCost': 'Полная себестоимость (шт.)',
  'lc.linePct': 'Landed %',
  'lc.purchaseTotal': 'Сумма товара',
  'lc.landedTotal': 'Сумма расходов',
  'lc.warnings': 'Предупреждения',
  'lc.empty': 'Нет данных для расчёта',
  'lc.emptyHint': 'Себестоимость рассчитывается на ПРИНЯТЫЙ товар: если по этому контейнеру ещё нет документа приёмки, то и строк для расчёта нет.',
  'lc.loadError': 'Не удалось рассчитать себестоимость',
  'lc.compare': 'Сравнение способов распределения',
  'lc.compareHint': 'ВРЕМЕННО замените здесь способ в строке расхода и посмотрите разницу. Ничего не сохраняется — это ответ на вопрос «а что было бы, если сделать иначе».',
  'lc.compareRun': 'Сравнить',
  'lc.compareReset': 'Вернуть исходные способы',
  'lc.compareBase': 'Текущий способ',
  'lc.compareAlt': 'Выбранный способ',
  'lc.deltaUnit': 'Разница (шт.)',
  'lc.deltaTotal': 'Разница (итого)',
  'lc.deltaZeroSum': 'Сумма разниц РОВНО НУЛЕВАЯ: смена способа не меняет общую сумму расходов, а лишь переносит её между SKU. Если сумма не нулевая — в расчёте ошибка.',
  'lc.deltaMoved': 'Один выбор способа переносит {amount} со строки «{from}» на другие SKU.',
  'lc.deltaNone': 'Выбранный способ не изменил результат',
  'lc.deltaWhy': 'Это самый дорогой единичный выбор во всей системе. Себестоимость панели окажется ниже на 6,3%, себестоимость ленты — выше на 6,8%, и ОБЕ будут оценены неверно.',
  'lc.runType': 'Вид расчёта',
  'lc.runType.estimate': 'Предварительный (estimate)',
  'lc.runType.final': 'Окончательный (final)',
  'lc.runTypeHint': 'Товар обычно приходит раньше документов. «Предварительный» — распределяются известные расходы, и товар выходит в продажу. «Окончательный» — после поступления всех документов прежний расчёт сторнируется и вычисляется разница.',
  'lc.runDate': 'Дата документа',
  'lc.run': 'Рассчитать и записать в учёт',
  'lc.runConfirm': 'Себестоимость будет записана в складской учёт, а остаток переоценён. Это действие останется в журнале аудита.',
  'lc.runNotes': 'Примечание',
  'lc.ran': 'Себестоимость рассчитана и записана (расчёт №{runId})',
  'lc.noRunPermission': 'У вас нет права выполнять расчёт себестоимости. При необходимости обратитесь к руководителю.',
  'lc.cogsVariance': 'Отклонение по проданному товару (COGS variance)',
  'lc.cogsVarianceHint': 'Эта сумма НЕ ВЕРНЁТСЯ на склад: себестоимость проданного товара задним числом не меняется, иначе прибыль закрытого периода была бы переписана. Отклонение относится на текущий период.',
  'lc.runs': 'История расчётов',
  'lc.runNo': 'Расчёт №{id}',
  'lc.runStatus': 'Статус',
  'lc.runPostedAt': 'Записано',
  'lc.runTotal': 'Итого расходов',
  'lc.runReversalOf': 'Сторнирует №{id}',
  'lc.runsEmpty': 'Ещё не рассчитано',
  'lc.reverse': 'Сторнировать',
  'lc.reverseTitle': 'Сторнирование расчёта себестоимости',
  'lc.reverseReason': 'Причина сторнирования',
  'lc.reverseReasonRequired': 'Причина должна содержать не менее 3 символов',
  'lc.reverseHint': 'Сторнирование меняет себестоимость, маржу и ВСЕ отчёты. Вопрос «почему?» обязательно будет задан — причина остаётся в журнале аудита.',
  'lc.reversed': 'Расчёт сторнирован',
  'lc.noReversePermission': 'У вас нет права сторнировать расчёт — оно есть только у администратора и финансиста. При необходимости обратитесь к ним.',
  'lc.breakdown': 'Состав расходов',
  'lc.costName': 'Расход',
  'lc.allocBasis': 'База',
  'lc.allocRatio': 'Доля',
  'lc.allocated': 'Сумма (USD)',
  'lc.roundingAbsorbed': 'Разница округления отнесена на эту строку',
  'lc.roundingHint': 'Чтобы при распределении не потерялись копейки, разница округления относится на строку с наибольшей базой. Итог должен быть В ТОЧНОСТИ равен сумме расходов.',
  'lc.noViewPermission': 'У вас нет права просматривать расчёт себестоимости. При необходимости обратитесь к руководителю.',
  'gr.title': 'Приёмка товара',
  'gr.description': 'Приёмка товара из контейнера. Полная себестоимость распределяется на ФАКТИЧЕСКИ ПОСТУПИВШЕЕ количество — недостача ПОВЫШАЕТ себестоимость оставшихся штук.',
  'gr.new': 'Новая приёмка',
  'gr.newTitle': 'Приёмка из контейнера',
  'gr.detailTitle': 'Приёмка {docNo}',
  'gr.docNo': 'Документ',
  'gr.shipment': 'Контейнер',
  'gr.shipmentSelect': 'Выберите контейнер',
  'gr.shipmentRequired': 'Необходимо выбрать контейнер',
  'gr.purchaseOrder': 'Заказ поставщику',
  'gr.warehouse': 'Склад',
  'gr.receiptDate': 'Дата приёмки',
  'gr.receiptDateHint': 'Дата приёмки — это ДАТА КУРСА для конвертации CNY→USD: именно в этот день товар становится активом.',
  'gr.status': 'Статус',
  'gr.statusAll': 'Все статусы',
  'gr.status.draft': 'Черновик',
  'gr.status.posted': 'Проведён',
  'gr.status.cancelled': 'Отменён',
  'gr.lines': 'Строки',
  'gr.expectedQuantity': 'Ожидалось',
  'gr.quantity': 'Поступило фактически',
  'gr.shortage': 'Недостача',
  'gr.excess': 'Излишек',
  'gr.shortageReason': 'Причина недостачи',
  'gr.shortageReasonRequired': 'В строке с недостачей необходимо указать причину',
  'gr.claimStatus': 'Статус претензии',
  'gr.claimAmount': 'Сумма претензии',
  'gr.claimNote': 'Примечание к претензии',
  'gr.shortageWhy': 'Себестоимость распределяется на ПОСТУПИВШЕЕ количество, а не на ожидаемое. То есть если ожидалось 500 штук, а поступило 480, расходы делятся на 480 штук, и каждая штука дорожает. Распределение на ожидаемое количество показывало бы непоступивший товар «бесплатным».',
  'gr.claimWhy': 'Куда уйдут ДЕНЬГИ по недостаче, определяет статус претензии: «принята» — поставщик возвращает, и это не расход; «отклонена» или «нет» — сумма относится на УБЫТОК ПЕРИОДА, а НЕ на себестоимость. Иначе оставшиеся штуки искусственно дорожают, и сравнить их со следующей партией невозможно.',
  'gr.post': 'Провести',
  'gr.postHint': 'После проведения товар попадает в складской остаток и готов к расчёту себестоимости.',
  'gr.posted': '{docNo} проведён',
  'gr.created': 'Приёмка создана: {docNo}',
  'gr.submit': 'Создать приёмку',
  'gr.linesRequired': 'Нужна хотя бы одна строка',
  'gr.noPoLine': 'В этой строке нет строки заказа поставщику: цена (CNY) берётся именно из строки заказа, и без неё рассчитать себестоимость невозможно.',
  'gr.empty': 'Документы приёмки не найдены',
  'gr.emptyHint': 'Расширьте фильтр или создайте новую приёмку из контейнера.',
  'gr.loadError': 'Не удалось загрузить приёмки',
  'gr.notFound': 'Документ приёмки не найден или недоступен вам',
  'gr.pickShipment': 'Сначала выберите контейнер',
  'gr.loadLines': 'Загрузить строки контейнера',
  'gr.linesFromShipment': 'Строки взяты из выбранного контейнера — скорректируйте фактически поступившее количество.',
  'gr.costHidden': 'Колонки себестоимости вам не показываются — это вопрос прав доступа, а не ошибка.',
  'shortage.shortage': 'Недостача',
  'shortage.damaged': 'Повреждено',
  'shortage.wrong_item': 'Другой товар',
  'shortage.excess': 'Излишек',
  'claim.none': 'Претензии нет',
  'claim.pending': 'Готовится',
  'claim.sent': 'Отправлена',
  'claim.accepted': 'Принята',
  'claim.rejected': 'Отклонена',
  'claim.closed': 'Закрыта',
  'imp.title': 'Импорт из 1С и Excel',
  'imp.description': 'Импорт состоит из четырёх шагов: загрузка → сопоставление колонок → проверка → внесение. К следующему шагу переходят только после того, как УВИДЕЛИ результат предыдущего.',
  'imp.whyStaged': 'В реальных файлах заголовок стоит в 3-й строке, числа приходят текстом, а в одной ячейке написано «100 шт». Одна кнопка «выбрали файл — импортировали» на таком файле либо падает, либо, что хуже, молча вносит 4 000 строк неправильно.',
  'imp.step1': 'Файл',
  'imp.step2': 'Колонки',
  'imp.step3': 'Проверка',
  'imp.step4': 'Внесение',
  'imp.stepOf': 'Шаг {n}',
  'imp.entityType': 'Что импортируется',
  'imp.entity.product': 'Товары',
  'imp.entity.customer': 'Клиенты',
  'imp.entity.supplier': 'Поставщики',
  'imp.entity.stock': 'Остатки склада (входящие)',
  'imp.entity.ar': 'Долг клиентов (входящий)',
  'imp.entity.ap': 'Долг поставщикам (входящий)',
  'imp.entity.price': 'Цены',
  'imp.openingTitle': 'Входящие остатки — два условия',
  'imp.openingBody':
    '1) ПОРЯДОК: сначала должны быть перенесены товары, клиенты и поставщики — файлы остатков и долгов ссылаются на них. 2) УЧЁТ: эта загрузка НЕ создаёт проводку. Входящую проводку бухгалтер вводит один раз вручную в разделе «Бухгалтерия → Проводки» (на какой счёт капитала — его решение).',
  'imp.entityHint': 'Один файл — ОДИН тип. Тип нельзя угадать по заголовкам: список клиентов с колонками «Код | Наименование» ничем не отличается от списка поставщиков, а 4 000 строк, попавших не в ту таблицу, разделить потом почти невозможно.',
  'imp.template': 'Скачать шаблон',
  'imp.templateHint': 'В шаблоне заданы правильные названия колонок и одна строка-образец. Заполненный по нему файл сопоставляется полностью с первой попытки — угадывать названия колонок не нужно.',
  'imp.templateFailed': 'Не удалось скачать шаблон',
  'imp.file': 'Файл (.xlsx или .csv)',
  'imp.upload': 'Загрузить',
  'imp.uploading': 'Загрузка…',
  'imp.fileRequired': 'Файл обязателен',
  'imp.uploadFailed': 'Не удалось загрузить файл',
  'imp.sheets': 'Листы в файле',
  'imp.sheet': 'Лист',
  'imp.selectedSheet': 'Выбранный лист',
  'imp.rowCount': '{count} строк',
  'imp.headerRow': 'Строка заголовка',
  'imp.headerRowDetected': 'Определено: строка {row}',
  'imp.headerRowHint': 'Автоматическое определение строки заголовка — ПРЕДПОЛОЖЕНИЕ. Неверно определённый заголовок делает негодным весь файл, поэтому его можно исправить вручную.',
  'imp.detectedColumns': 'Обнаруженные колонки',
  'imp.mappingTitle': 'Сопоставление колонок',
  'imp.mappingHint': 'Слева — поле Alight, справа — колонка из файла. Автоматическое предложение уже проставлено; проверьте его и при необходимости измените.',
  'imp.evoField': 'Поле Alight',
  'imp.fileColumn': 'Колонка файла',
  'imp.columnNone': '— не сопоставлено —',
  'imp.required': 'обязательно',
  'imp.suggested': 'автоподбор',
  'imp.defaultValue': 'Фиксированное значение',
  'imp.defaultHint': 'Если колонки в файле нет вообще (например «тип» не указан, потому что все оптовые) — задайте значение один раз здесь.',
  'imp.applyMapping': 'Сохранить сопоставление',
  'imp.mappingSaved': 'Сопоставление сохранено',
  'imp.previewTitle': 'Образец результата (первые строки)',
  'imp.previewRow': 'Строка {n}',
  'imp.skippedRows': 'Пропущено строк до заголовка: {count}',
  'imp.requiredMissing': 'Не сопоставлены обязательные поля: {fields}',
  'imp.validate': 'Проверить',
  'imp.validating': 'Проверка…',
  'imp.validateHint': 'Проверку можно запускать сколько угодно раз, она ничего не записывает. Вместо того чтобы править файл и загружать заново — поправьте сопоставление и проверьте ещё раз.',
  'imp.totalRows': 'Всего строк',
  'imp.validRows': 'Корректных',
  'imp.errorRows': 'Ошибок',
  'imp.warningRows': 'Предупреждений',
  'imp.topErrors': 'Самые частые ошибки',
  'imp.rowNo': 'Строка',
  'imp.rowStatus': 'Статус',
  'imp.rowMessage': 'Сообщение',
  'imp.rowData': 'Значение из файла',
  'imp.filterAll': 'Все строки',
  'imp.filterErrors': 'Только ошибки',
  'imp.filterWarnings': 'Только предупреждения',
  'imp.filterValid': 'Только корректные строки',
  'imp.warningNotError': 'Предупреждение — не ОШИБКА. Похожий дубль («Люстра 60W» и «Люстра 80W») — это два настоящих товара, и оба должны попасть в базу. Такая строка остаётся «корректной» и попадёт в базу на шаге «Внесение»; предупреждение лишь привлекает внимание.',
  'imp.rowsEmpty': 'По этому фильтру строк нет',
  'imp.rowsLoadError': 'Не удалось загрузить строки',
  'imp.commit': 'Внести в базу',
  'imp.committing': 'Внесение…',
  'imp.commitHint': 'Вносятся только «корректные» строки, и все — в ОДНОЙ транзакции: половинчатого импорта не останется.',
  'imp.commitBlocked': 'Для внесения сначала пройдите проверку',
  'imp.committed': 'Внесено строк: {count}',
  'imp.commitFailed': 'Не удалось внести',
  'imp.imported': 'Импортировано',
  'imp.rollback': 'Откат (rollback)',
  'imp.rollbackTitle': 'Откат партии импорта',
  'imp.rollbackReason': 'Причина отката',
  'imp.rollbackReasonRequired': 'Причина должна содержать не менее 3 символов',
  'imp.rollbackHint': 'Откат — это УДАЛЕНИЕ записей из базы, то есть единственное исключение из правила «мастер-данные никогда не удаляются». Через неделю вопрос «почему откатили?» обязательно возникнет.',
  'imp.rolledBack': 'Партия откачена',
  'imp.rollbackFailed': 'Не удалось откатить',
  'imp.batches': 'Партии импорта',
  'imp.batchNo': 'Партия №{id}',
  'imp.fileName': 'Файл',
  'imp.createdAt': 'Создана',
  'imp.batchStatus': 'Статус',
  'imp.open': 'Открыть',
  'imp.newBatch': 'Новый импорт',
  'imp.batchesEmpty': 'Импорта ещё не было',
  'imp.batchesLoadError': 'Не удалось загрузить партии',
  'imp.status.uploaded': 'Загружена',
  'imp.status.validated': 'Проверена',
  'imp.status.dry_run': 'Пробный запуск',
  'imp.status.committed': 'Внесена',
  'imp.status.rolled_back': 'Откачена',
  'imp.rowStatus.pending': 'Ожидает',
  'imp.rowStatus.valid': 'Корректна',
  'imp.rowStatus.error': 'Ошибка',
  'imp.rowStatus.imported': 'Внесена',
  'imp.rowStatus.skipped': 'Пропущена',
  'settings.title': 'Настройки',
  'settings.usersTitle': 'Пользователи',
  'settings.rolesTitle': 'Роли и права доступа',
  'settings.priceListsTitle': 'Прайс-листы',
  'settings.cashAccountsTitle': 'Кассы и банковские счета',
  'settings.systemTitle': 'Системные настройки',
  'settings.auditTitle': 'Журнал аудита',
  'usr.description': 'Пользователи, роли и область доступа. При смене роли или пароля ВСЕ сессии этого сотрудника отзываются.',
  'usr.sessionsRevokedWarning': 'ВНИМАНИЕ: при изменении роли, области доступа или пароля все открытые сессии пользователя немедленно отзываются, и ему придётся войти заново. Это не техническая деталь — иначе в уже открытом окне он продолжал бы работать со старыми правами, то есть понижение роли теряло бы смысл.',
  'usr.sessionsRevokedDone': 'Сессии отозваны ({count})',
  'usr.new': 'Новый пользователь',
  'usr.fullName': 'ФИО',
  'usr.email': 'Email',
  'usr.phone': 'Телефон',
  'usr.password': 'Пароль',
  'usr.passwordHint': 'Не менее {min} символов. Длина важнее сложности: правила обязательных символов заставляют людей выбирать предсказуемые пароли.',
  'usr.passwordTooShort': 'Пароль должен содержать не менее {min} символов',
  'usr.locale': 'Язык',
  'usr.role': 'Роль',
  'usr.roleSelect': 'Выберите роль',
  'usr.scope': 'Область доступа',
  'usr.scopeType': 'Тип области доступа',
  'usr.scope.all': 'Вся организация',
  'usr.scope.branch': 'Филиал',
  'usr.scope.warehouse': 'Склад',
  'usr.scopeId': 'Объект области доступа',
  'usr.scopeHint': 'Область доступа определяет, «какие данные видны»: кладовщик видит только свой склад, продавец — свой филиал.',
  'org.title': 'Организационная структура',
  'org.description': 'Филиалы, их склады и кассы. Новый филиал открывается сразу со складом и кассой, иначе в нём нельзя торговать.',
  'org.newBranch': 'Новый филиал',
  'org.wizardTitle': 'Открытие нового филиала',
  'org.wizardHint': 'Филиал, его склад и касса создаются ОДНИМ действием. Если коды склада и кассы оставить пустыми, они будут образованы из кода филиала.',
  'org.branchCode': 'Код филиала',
  'org.branchCodeHint': 'Заглавные буквы, цифры и дефис: SAMARQAND. Код потом НЕ ИЗМЕНЯЕТСЯ — он печатается в документах.',
  'org.branchName': 'Название филиала',
  'org.address': 'Адрес',
  'org.phone': 'Телефон',
  'org.legalEntity': 'Юридическое лицо',
  'org.warehouseCode': 'Код склада',
  'org.warehouseName': 'Название склада',
  'org.cashCode': 'Код кассы',
  'org.cashName': 'Название кассы',
  'org.optional': 'необязательно',
  'org.create': 'Открыть филиал',
  'org.creating': 'Открытие…',
  'org.setupDone': 'Филиал открыт: {code}',
  'org.setupDetails': 'Склад: {warehouse} · Касса: {cash} ({currency})',
  'org.nextStep': 'Следующий шаг',
  'org.goToUsers': 'Назначить сотрудника',
  'org.branch': 'Филиал',
  'org.warehouses': 'Склады',
  'org.cashAccounts': 'Кассы',
  'org.staff': 'Сотрудники',
  'org.staffCount': 'Сотрудников: {count}',
  'org.noStaff': 'Сотрудники не назначены',
  'org.noStaffHint': 'В этом филиале никто не работает — документов в нём не появится. Задайте сотруднику область доступа «филиал» в разделе Настройки → Пользователи.',
  'org.stockValue': 'Стоимость остатка',
  'org.warehouseCount': 'Складов: {count}',
  'org.positions': 'Позиций: {count}',
  'org.empty': 'Пусто',
  'org.archived': 'В архиве',
  'org.archive': 'Архивировать',
  'org.archiveBranchHint': 'Филиал НЕ УДАЛЯЕТСЯ — история связанных с ним документов сохраняется. Перед архивированием остаток нужно переместить в другой филиал, а сотрудников перевести.',
  'org.archiveWarehouseHint': 'Склад с остатком архивировать нельзя — товар исчез бы из отчётов.',
  'org.archiveCashHint': 'Кассу с остатком архивировать нельзя.',
  'org.branchArchived': 'Филиал архивирован: {code}',
  'org.warehouseArchived': 'Склад архивирован: {code}',
  'org.cashArchived': 'Касса архивирована: {code}',
  'org.newWarehouse': 'Добавить склад',
  'org.warehouseCreated': 'Склад создан: {code}',
  'org.whType': 'Тип',
  'org.whType.main': 'Основной',
  'org.whType.transit': 'Транзитный (товар в пути)',
  'org.whType.quarantine': 'Карантин (осмотр)',
  'org.whTypeHint': 'Транзитный склад на всю компанию один — он в центре. Карантинный склад один на филиал и нужен только для возвратов, требующих осмотра.',
  'org.unassignedCash': 'Кассы, не привязанные к филиалу',
  'org.unassignedCashHint': 'Центральные и валютные кассы остаются здесь. Кассу филиала выберите в списке и привяжите.',
  'org.attach': 'Привязать',
  'org.detach': 'Отвязать',
  'org.attached': 'Касса привязана к филиалу',
  'org.selectBranch': 'Выберите филиал',
  'org.save': 'Сохранить',
  'org.saved': 'Сохранено',
  'org.edit': 'Изменить',
  'org.loadError': 'Не удалось загрузить организационную структуру',
  'usr.status': 'Статус',
  'usr.active': 'Активен',
  'usr.inactive': 'Заблокирован',
  'usr.lastLogin': 'Последний вход',
  'usr.neverLoggedIn': 'Не входил',
  'usr.create': 'Создать',
  'usr.created': 'Пользователь создан: {email}',
  'usr.setRole': 'Изменить роль',
  'usr.roleChanged': 'Роль изменена: {role}',
  'usr.setScope': 'Изменить область доступа',
  'usr.scopeChanged': 'Область доступа изменена',
  'usr.resetPassword': 'Сбросить пароль',
  'usr.resetPasswordTitle': 'Задать новый пароль',
  'usr.passwordReset': 'Пароль изменён',
  'usr.newPasswordHint': 'Новый пароль НЕ ВОЗВРАЩАЕТСЯ в ответе: вы вводите его сами и сами передаёте сотруднику.',
  'usr.activate': 'Активировать',
  'usr.deactivate': 'Заблокировать',
  'usr.activated': 'Пользователь активирован',
  'usr.deactivated': 'Пользователь заблокирован',
  'usr.sessions': 'Сессии',
  'usr.sessionsTitle': '{name} — сессии',
  'usr.sessionAgent': 'Устройство',
  'usr.sessionIp': 'IP',
  'usr.sessionCreated': 'Начата',
  'usr.sessionExpires': 'Действует до',
  'usr.sessionRevoked': 'Отозвана',
  'usr.sessionActive': 'Активна',
  'usr.revokeSessions': 'Отозвать все сессии',
  'usr.sessionsEmpty': 'Сессий нет',
  'usr.self': 'Это — ВАША запись. Вы не можете изменить свою роль, область доступа и активность: иначе администратор мог бы случайно лишить себя прав.',
  'usr.noRoleAssign': 'У вас нет права менять роль и область доступа — оно есть только у администратора. При необходимости обратитесь к администратору.',
  'usr.empty': 'Пользователи не найдены',
  'usr.loadError': 'Не удалось загрузить пользователей',
  'role.description': 'Матрица «роль → право доступа». При наличии права `role.manage` каждый раздел и функцию открывают или закрывают прямо здесь; без него экран остаётся только для чтения.',
  'role.code': 'Код',
  'role.name': 'Наименование',
  'role.users': 'Пользователи',
  'role.permissions': 'Права доступа',
  'role.module': 'Модуль',
  'role.permissionCode': 'Код права доступа',
  'role.granted': 'Предоставлено',
  'role.notGranted': 'Нет',
  'role.select': 'Выберите роль',
  'role.label.admin': 'Администратор',
  'role.label.manager': 'Руководитель',
  'role.label.finance': 'Финансист',
  'role.label.warehouse': 'Кладовщик',
  'role.label.sales': 'Продавец',
  'nav.language': 'Язык',
  'nav.theme.toDark': 'Перейти на тёмную тему',
  'nav.theme.toLight': 'Перейти на светлую тему',
  'role.matrixHint': 'Колонки — роли, строки — права доступа. Эта таблица должна совпадать с согласованным перечнем прав; при расхождении истина — В БАЗЕ.',
  'role.loadError': 'Не удалось загрузить роли',
  'role.empty': 'Роли не найдены',
  'role.editHint': 'Выберите роль, затем отметьте функции внутри разделов. Пока не нажата «Сохранить», ничего не меняется. Изменение вступает в силу сразу — следующее действие сотрудника с этой ролью уже идёт по новым правам.',
  'role.viewEditor': 'Редактирование',
  'role.viewMatrix': 'Вся матрица',
  'role.new': 'Новая роль',
  'role.newCode': 'Код',
  'role.newCodeHint': 'только строчные латинские буквы, цифры и дефис; 2–32 символа',
  'role.newName': 'Наименование',
  'role.newDescription': 'Описание',
  'role.created': 'Роль «{code}» создана. Она пока ПУСТАЯ — отметьте её функции ниже.',
  'role.codeInvalid': 'Неверный код: только строчные латинские буквы, цифры и дефис (2–32 символа)',
  'role.deleteConfirm': 'Удалить роль «{name}» полностью? Вместе с ней удалятся все её права доступа, и это необратимо.',
  'role.deleted': 'Роль «{code}» удалена',
  'role.systemHint': 'Системные роли не удаляются — программа обращается к ним по имени. Их права при этом менять можно.',
  'role.selectHint': 'Выберите одну из ролей выше, чтобы её отредактировать.',
  'role.permissionsOf': 'Роль «{name}»: разделы и функции',
  'role.summary': 'разделов: {modules}, функций: {permissions}',
  'role.filter': 'Поиск по разделу или функции',
  'role.filterEmpty': 'По запросу функции не найдены',
  'role.selectAll': 'Отметить все',
  'role.clearAll': 'Снять все',
  'role.pendingChanges': 'будет выдано: {added}, снято: {removed}',
  'role.noChanges': 'Изменений нет',
  'role.savedResult': 'Сохранено: выдано {added}, снято {removed}. Всего у роли {granted} прав.',
  'role.locked': 'У вас нет этого права — выдать его роли вы не можете',
  'role.lockedBanner': 'У этой роли есть {count} прав, которых НЕТ у вас ({codes}). Сервер не даст записать такой набор обратно, поэтому сохранение здесь закрыто. Роль должен править тот, у кого эти права есть.',
  'role.catalogueError': 'Не удалось загрузить список разделов и функций',
  'role.err.escalation': 'Нельзя выдать право, которого у вас нет',
  'role.err.lockout': 'Нельзя заблокировать последнего администратора',
  'role.err.systemRole': 'Системную роль удалить нельзя',
  'role.err.inUse': 'В роли есть пользователи',
  'pl.description': 'Без прайс-листа ни один заказ не будет оценён. Способ оплаты — важнейшая колонка: цена за наличные и по переводу отличается на 3–7%.',
  'pl.paymentWhy': 'Наличные и перевод — ДВЕ РАЗНЫЕ цены. Разница составляет 3–7% и теряется незаметно: продавец договаривается «за наличные», а документ выписывается по прайс-листу для перевода. Поэтому способ оплаты стоит на видном месте списка.',
  'pl.new': 'Новый прайс-лист',
  'pl.code': 'Код',
  'pl.name': 'Наименование',
  'pl.currency': 'Валюта',
  'pl.paymentMethod': 'Способ оплаты',
  'pl.payment.any': 'Любой',
  'pl.payment.cash': 'Наличные',
  'pl.payment.transfer': 'Перевод',
  'pl.isDefault': 'Основной прайс-лист',
  'pl.isDefaultHint': 'Основной прайс-лист может быть ТОЛЬКО ОДИН: если их два, порядок выбора цены становится неопределённым и один товар продаётся по двум разным ценам.',
  'pl.validFrom': 'Действует с',
  'pl.validTo': 'Действует по',
  'pl.itemCount': 'Строк',
  'pl.status': 'Статус',
  'pl.create': 'Создать',
  'pl.created': 'Прайс-лист создан: {code}',
  'pl.items': 'Строки прайс-листа',
  'pl.itemsOf': '{name} — строки прайс-листа',
  'pl.sku': 'SKU',
  'pl.product': 'Товар',
  'pl.price': 'Цена',
  'pl.minQty': 'Минимальное количество',
  'pl.minQtyHint': 'Ступень по объёму: начиная с этого количества действует данная цена.',
  'pl.itemsEmpty': 'В этом прайс-листе нет строк',
  'pl.selectList': 'Выберите прайс-лист слева',
  'pl.bulk': 'Массовый ввод',
  'pl.bulkTitle': 'Перенос цен из Excel',
  'pl.bulkHint': 'Скопируйте колонки из Excel и вставьте сюда. Каждая строка: SKU, цена и (необязательно) минимальное количество — через TAB или точку с запятой.',
  'pl.bulkPlaceholder': 'LED-PNL-600	18.00\nLED-BLB-09	1.50	100',
  'pl.bulkParsed': 'Распознано строк: {count}',
  'pl.bulkUnknownSku': 'Не найдено в каталоге: {sku}',
  'pl.bulkInvalid': 'Строка {n}: неверная цена или SKU',
  'pl.bulkApply': 'Внести',
  'pl.bulkDone': 'Всего {total}: новых {created}, обновлено {updated}',
  'pl.bulkEmpty': 'Нет строк для внесения',
  'pl.loadError': 'Не удалось загрузить прайс-листы',
  'pl.noEdit': 'У вас нет права изменять прайс-лист. При необходимости обратитесь к руководителю.',
  'cash.description': 'Кассы и банковские счета. Без них не будет записан ни один платёж. Каждый счёт — в СВОЕЙ валюте: сумовая касса и долларовая касса — две отдельные записи.',
  'cash.new': 'Новый счёт',
  'cash.code': 'Код',
  'cash.name': 'Наименование',
  'cash.type': 'Тип',
  'cash.type.cash': 'Касса',
  'cash.type.bank': 'Банк',
  'cash.currency': 'Валюта',
  'cash.legalEntity': 'Юридическое лицо',
  'cash.bankName': 'Название банка',
  'cash.accountNo': 'Номер счёта',
  'cash.balance': 'Баланс',
  'cash.status': 'Статус',
  'cash.create': 'Создать',
  'cash.created': 'Счёт создан: {code}',
  'cash.archive': 'Архивировать',
  'cash.archived': 'Счёт архивирован',
  'cash.archiveHint': 'Счёт с остатком архивировать нельзя: деньги исчезнут из отчёта, но останутся в операциях, и касса разойдётся с бухгалтерией.',
  'cash.empty': 'Счета не найдены',
  'cash.loadError': 'Не удалось загрузить счета',
  'cash.noEdit': 'У вас нет права создавать счета. При необходимости обратитесь к руководителю.',
  'cfg.description': 'Настраиваемые значения бизнес-правил. Они хранятся не в коде, а в базе: их меняет БИЗНЕС, и каждое изменение попадает в аудит.',
  'cfg.key': 'Ключ',
  'cfg.value': 'Значение',
  'cfg.dataType': 'Тип',
  'cfg.about': 'Для чего нужно',
  'cfg.edit': 'Изменить',
  'cfg.saved': '«{key}» сохранено',
  'cfg.invalidNumber': 'Допускается только число',
  'cfg.invalidJson': 'Неверный формат JSON',
  'cfg.moneyAsText': 'Денежные и процентные значения хранятся ТЕКСТОМ — если хранить их числом, значение округляется и появляется ошибка на уровне копеек.',
  'cfg.typeMismatch': 'Тип значения в базе отличается от объявленного («{declared}»). Редактор выбран по фактическому типу.',
  'cfg.empty': 'Настройки не найдены',
  'cfg.loadError': 'Не удалось загрузить настройки',
  'cfg.boolTrue': 'Включено',
  'cfg.boolFalse': 'Выключено',
  'audit.occurredAt': 'Время',
  'audit.actor': 'Кто',
  'audit.actorIp': 'IP',
  'audit.entity': 'Документ',
  'audit.entityTable': 'Тип документа',
  'audit.entityId': 'ID записи',
  'audit.action': 'Действие',
  'audit.changes': 'Изменения',
  'audit.field': 'Поле',
  'audit.oldValue': 'Было',
  'audit.newValue': 'Стало',
  'audit.noChanges': 'Изменений полей нет',
  'audit.limit': 'Количество записей',
  'audit.unknownActor': 'Сотрудник #{id}',
  'audit.system': 'Система',
  'audit.empty': 'Записи не найдены',
  'audit.loadError': 'Не удалось загрузить журнал аудита',
  'audit.clearFilters': 'Очистить фильтры',
  'audit.action.insert': 'Создано',
  'audit.action.update': 'Изменено',
  'audit.action.delete': 'Удалено',
  'audit.action.login': 'Вход',
  'audit.action.logout': 'Выход',
  'audit.description': 'В одном списке: изменения документов, входы и выходы, печать и отказы в доступе. В каждой записи — какая учётная запись, с какого IP и с какого устройства.',
  'audit.filtersError': 'Не удалось загрузить списки фильтров — выбор по типу документа недоступен',
  'audit.total': '{count} записей',
  'audit.device': 'Устройство',
  'audit.rawUserAgent': 'Сырой User-Agent: {value}',
  'audit.filterAction': 'Действие',
  'audit.filterActionHint': 'Можно выбрать несколько сразу. Если не выбрано ничего — показываются все.',
  'audit.groupDocument': 'Действия с документами',
  'audit.groupAccess': 'Доступ и прочие события',
  'audit.actionAll': 'Все',
  'audit.action.override': 'В обход правила',
  'audit.action.loginFailed': 'Вход отклонён',
  'audit.action.permissionDenied': 'Отказано в доступе',
  'audit.action.export': 'Выгружено',
  'audit.action.print': 'Напечатано',
  'audit.action.unknown': 'Неизвестное действие ({code})',
  'audit.editWindow.override': 'Обошли окно исправления',
  'audit.editWindow.overrideHint': 'Окно исправления в 24 часа уже истекло. Действие проведено СОЗНАТЕЛЬНО по праву `correction.override` — правило не нарушено, его обошли.',
  'audit.editWindow.within': 'В пределах окна исправления',
  'audit.event': 'Событие',
  'audit.device.notRecorded': 'Устройство не записано',
  'audit.device.notRecordedHint': 'Запись создана до того, как устройство начали фиксировать, — самих данных нет.',
  'audit.device.unrecognized': 'Не распознано',
  'audit.device.unrecognizedHint': 'Строка устройства ЕСТЬ, но не совпала с шаблонами. Сырая строка здесь.',
  'audit.device.desktop': 'компьютер',
  'audit.device.mobile': 'телефон',
  'audit.device.tablet': 'планшет',
  'audit.device.bot': 'скрипт',
  'audit.device.unknownKind': 'неизвестный тип',
  'audit.allTables': 'Все типы документов',
  'audit.tableUntranslated': 'Нет названия: {code}',
  'audit.tableUntranslatedHint': 'Название этого типа документа ещё не заведено — на экране код разработчика. Показывается сам код: замена на «Прочий документ» полностью потеряла бы, о каком документе речь.',
  'audit.untranslatedCount': 'Без названия: {count} тип(ов) документов',
  'audit.table.accountingPeriods': 'Учётный период',
  'audit.table.approvalDelegations': 'Делегирование согласования',
  'audit.table.approvalRequests': 'Запрос на согласование',
  'audit.table.approvalRules': 'Правило согласования',
  'audit.table.bonusEntries': 'Начисление бонуса',
  'audit.table.branches': 'Филиал',
  'audit.table.cashAccounts': 'Счёт кассы',
  'audit.table.cashFlowItems': 'Статья ДДС',
  'audit.table.cashTransactions': 'Движение по кассе',
  'audit.table.charityAppropriations': 'Отчисление на благотворительность',
  'audit.table.charityPayouts': 'Выплата на благотворительность',
  'audit.table.commissionRules': 'Правило комиссии',
  'audit.table.commissionRuns': 'Расчёт комиссии',
  'audit.table.costTypes': 'Вид затрат',
  'audit.table.creditNotes': 'Кредит-нота',
  'audit.table.customerContacts': 'Контакт клиента',
  'audit.table.customerPrices': 'Цена для клиента',
  'audit.table.customerUsers': 'Пользователь кабинета клиента',
  'audit.table.customers': 'Клиент',
  'audit.table.dailyRates': 'Дневной курс валюты',
  'audit.table.dayClosings': 'Закрытие дня',
  'audit.table.dealerRebateTiers': 'Ступень скидки дилера',
  'audit.table.dealerUsers': 'Пользователь дилера',
  'audit.table.dealers': 'Дилер',
  'audit.table.deliveries': 'Накладная на доставку',
  'audit.table.documents': 'Документ (скан, сертификат)',
  'audit.table.employeeAdvances': 'Аванс сотруднику',
  'audit.table.employeeDebts': 'Долг сотрудника',
  'audit.table.employees': 'Сотрудник',
  'audit.table.expenses': 'Расход',
  'audit.table.fxRevaluations': 'Переоценка валюты',
  'audit.table.goodsReceipts': 'Приёмка товара',
  'audit.table.installers': 'Мастер',
  'audit.table.inventoryTransactions': 'Движение по складу',
  'audit.table.invoices': 'Счёт-фактура',
  'audit.table.journals': 'Бухгалтерская проводка',
  'audit.table.kpiPlans': 'План KPI',
  'audit.table.landedCostRuns': 'Расчёт себестоимости',
  'audit.table.payments': 'Платёж',
  'audit.table.payrollRuns': 'Расчёт зарплаты',
  'audit.table.poPaymentTerms': 'Условие оплаты закупки',
  'audit.table.priceListItems': 'Строка прайс-листа',
  'audit.table.priceLists': 'Прайс-лист',
  'audit.table.printTemplates': 'Шаблон печати',
  'audit.table.productPoints': 'Баллы за товар (мастер)',
  'audit.table.products': 'Товар',
  'audit.table.purchaseOrders': 'Заказ поставщику',
  'audit.table.qrBatches': 'Партия QR-кодов',
  'audit.table.qrCodes': 'QR-код',
  'audit.table.redemptions': 'Обмен на подарок',
  'audit.table.reorderRunLines': 'Строка автозаказа',
  'audit.table.reorderRuns': 'Расчёт автозаказа',
  'audit.table.rewards': 'Подарок',
  'audit.table.salesOrders': 'Заказ покупателя',
  'audit.table.salesReturnLines': 'Строка возврата',
  'audit.table.salesReturns': 'Возврат от покупателя',
  'audit.table.sessions': 'Сессия',
  'audit.table.settings': 'Системная настройка',
  'audit.table.shipmentCosts': 'Затрата по контейнеру',
  'audit.table.shipments': 'Контейнер',
  'audit.table.stockCounts': 'Инвентаризация',
  'audit.table.stockTransfers': 'Перемещение между складами',
  'audit.table.supplierInvoices': 'Инвойс поставщика',
  'audit.table.suppliers': 'Поставщик',
  'audit.table.tenants': 'Организация',
  'audit.table.userRoles': 'Роль пользователя',
  'audit.table.users': 'Пользователь',
  'audit.table.warehouses': 'Склад',
  'audit.field.status': 'Статус',
  'audit.field.amount': 'Сумма',
  'audit.field.amountBase': 'Сумма (в базовой валюте)',
  'audit.field.totalAmount': 'Итого',
  'audit.field.totalBase': 'Итого (в базовой валюте)',
  'audit.field.balanceBase': 'Остаток (в базовой валюте)',
  'audit.field.balanceAmount': 'Остаток',
  'audit.field.vatAmount': 'Сумма НДС',
  'audit.field.vatBase': 'НДС (в базовой валюте)',
  'audit.field.vatRate': 'Ставка НДС',
  'audit.field.listAmount': 'Цена по прайсу',
  'audit.field.discountAmount': 'Скидка',
  'audit.field.priceAmount': 'Цена',
  'audit.field.unitCost': 'Себестоимость единицы',
  'audit.field.quantity': 'Количество',
  'audit.field.currency': 'Валюта',
  'audit.field.currencyCode': 'Код валюты',
  'audit.field.rate': 'Курс',
  'audit.field.fxRate': 'Курс валюты',
  'audit.field.fxRateManual': 'Курс введён вручную',
  'audit.field.rateDate': 'Дата курса',
  'audit.field.docNo': 'Номер документа',
  'audit.field.invoiceNo': 'Номер счёта',
  'audit.field.deliveryNo': 'Номер накладной',
  'audit.field.batchNo': 'Номер партии',
  'audit.field.lineCount': 'Количество строк',
  'audit.field.codeCount': 'Количество кодов',
  'audit.field.format': 'Формат',
  'audit.field.mode': 'Режим',
  'audit.field.method': 'Способ',
  'audit.field.paymentMethod': 'Способ оплаты',
  'audit.field.paymentTermDays': 'Срок оплаты (дней)',
  'audit.field.dueDate': 'Срок оплаты',
  'audit.field.invoiceDate': 'Дата счёта',
  'audit.field.orderDate': 'Дата заказа',
  'audit.field.receiptDate': 'Дата приёмки',
  'audit.field.incurredDate': 'Дата затраты',
  'audit.field.businessDate': 'Операционный день',
  'audit.field.validFrom': 'Действует с',
  'audit.field.postedAt': 'Проведено',
  'audit.field.occurredAt': 'Произошло',
  'audit.field.name': 'Название',
  'audit.field.nameUz': 'Название (узб.)',
  'audit.field.nameRu': 'Название (рус.)',
  'audit.field.fullName': 'ФИО',
  'audit.field.legalName': 'Юридическое наименование',
  'audit.field.code': 'Код',
  'audit.field.sku': 'Артикул',
  'audit.field.phone': 'Телефон',
  'audit.field.address': 'Адрес',
  'audit.field.notes': 'Примечание',
  'audit.field.description': 'Описание',
  'audit.field.reason': 'Причина',
  'audit.field.reasonCode': 'Код причины',
  'audit.field.reversalReason': 'Причина сторно',
  'audit.field.reversalDocNo': 'Документ сторно',
  'audit.field.writeoffReason': 'Причина списания',
  'audit.field.overrideReason': 'Причина обхода',
  'audit.field.differenceReason': 'Причина расхождения',
  'audit.field.isActive': 'Активен',
  'audit.field.isBlocked': 'Заблокирован',
  'audit.field.isDefault': 'По умолчанию',
  'audit.field.isSellable': 'Продаётся',
  'audit.field.isPurchasable': 'Закупается',
  'audit.field.creditLimitAmount': 'Кредитный лимит',
  'audit.field.creditLimitBase': 'Кредитный лимит (в базовой валюте)',
  'audit.field.creditLimitCurrency': 'Валюта кредитного лимита',
  'audit.field.outstandingBase': 'Открытый долг (в базовой валюте)',
  'audit.field.creditCheckResult': 'Результат проверки лимита',
  'audit.field.creditOverrideBy': 'Кто обошёл лимит',
  'audit.field.privilegeEscalationDenied': 'Попытка повысить права отклонена',
  'audit.field.sessionsRevoked': 'Отозванные сессии',
  'audit.field.role': 'Роль',
  'audit.field.locale': 'Язык',
  'audit.field.document': 'Документ',
  'audit.field.missingFields': 'Отсутствующие поля',
  'audit.field.salaryAmount': 'Зарплата',
  'audit.field.position': 'Должность',
  'audit.field.employeeNo': 'Табельный номер',
  'audit.field.hiredAt': 'Дата приёма',
  'audit.field.firedAt': 'Дата увольнения',
  'audit.field.containerNo': 'Номер контейнера',
  'audit.field.vehicleNo': 'Номер автомобиля',
  'audit.field.driverName': 'Водитель',
  'audit.field.eta': 'Ожидаемое прибытие',
  'audit.field.etd': 'Ожидаемая отправка',
  'audit.field.ata': 'Фактическое прибытие',
  'audit.field.weightKg': 'Вес (кг)',
  'audit.field.volumeM3': 'Объём (м³)',
  'audit.field.cashBalance': 'Остаток в кассе',
  'audit.field.cashIn': 'Приход',
  'audit.field.cashOut': 'Расход',
  'audit.field.countedAmount': 'Пересчитанная сумма',
  'audit.field.openingBalance': 'Начальный остаток',
  'audit.field.expectedBalance': 'Ожидаемый остаток',
  'audit.field.difference': 'Расхождение',
  'audit.field.inventoryValue': 'Стоимость склада',
  'audit.field.txnType': 'Тип движения',
  'audit.field.accountType': 'Тип счёта',
  'audit.field.customerType': 'Тип клиента',
  'audit.field.orderSource': 'Источник заказа',
  'audit.field.source': 'Источник',
  'dlr.description': 'Дилер — независимый торговец: покупает товар у нас, хранит его на своём складе и продаёт своим клиентам. Его продажи В НАШИ отчёты НЕ ПОПАДАЮТ; от него мы видим только объём закупок и от этого объёма начисляем ретробонус.',
  'dlr.channelTitle': 'Дилер существует и как клиент',
  'dlr.channelWhy': 'Каждый дилер привязывается к НАШЕМУ клиенту, и это обязательно: годовой бонус (ретробонус) считается от суммы выставленных ему счетов-фактур. У карточки дилера без клиента бонус всегда был бы нулевым.',
  'dlr.openBonus': 'Перейти к бонусным счетам',
  'dlr.code': 'Код',
  'dlr.name': 'Наименование',
  'dlr.customer': 'Клиент',
  'dlr.customerPick': 'Выберите клиента',
  'dlr.customerHint': 'База ретробонуса берётся из счетов-фактур, выставленных этому клиенту.',
  'dlr.territory': 'Территория',
  'dlr.contract': 'Договор',
  'dlr.until': 'до {date}',
  'dlr.status': 'Статус',
  'dlr.statusActive': 'Активен',
  'dlr.statusSuspended': 'Приостановлен',
  'dlr.statusTerminated': 'Расторгнут',
  'dlr.filterAll': 'Все',
  'dlr.suspend': 'Приостановить',
  'dlr.activate': 'Активировать',
  'dlr.terminate': 'Расторгнуть договор',
  'dlr.finalState': 'Конечное состояние — возврата нет',
  'dlr.new': 'Новый дилер',
  'dlr.create': 'Создать дилера',
  'dlr.createdMsg': 'Дилер создан: {code}',
  'dlr.noManage': 'У вас нет права изменять карточку дилера — это коммерческое решение, и у финансиста такого права нет. При необходимости обратитесь к руководителю.',
  'dlr.searchPlaceholder': 'Код, наименование или территория',
  'dlr.empty': 'Дилеры не найдены',
  'dlr.emptyHint': 'Чтобы добавить нового дилера, воспользуйтесь формой ниже.',
  'dlr.loadError': 'Не удалось загрузить список дилеров',
  // `dlr.searchLabel` o'chirildi — sabab `i18n.ts` da (ekran `common.search` ni ishlatadi).
  'bns.description': 'Бонус выплачивается двум сторонам: дилеру — процент от годового объёма закупок (ретробонус), мастеру — баллы за установленную им продукцию. В итоге и то и другое превращается в ОДНО — в деньги, уходящие из кассы, поэтому они в одном списке.',
  'bns.pointValue': 'Стоимость балла',
  'bns.pointValueIs': '1 балл = {value} USD',
  'bns.pointValueWhy': 'Стоимость выводится из каталога подарков: себестоимость всех активных подарков ÷ их цена в баллах. То есть реальная стоимость балла меняется вместе с каталогом, а курс на момент выплаты ФИКСИРУЕТСЯ в документе.',
  'bns.pointValueUnknown': 'Стоимость балла рассчитать не удалось: в каталоге подарков нет ни одного активного подарка с указанной себестоимостью. Чтобы выплатить бонус мастеру, сначала укажите себестоимость (Программа мастеров → Каталог подарков).',
  'bns.partyType': 'Кто',
  'bns.partyDealer': 'Дилер',
  'bns.partyInstaller': 'Мастер',
  'bns.code': 'Код / телефон',
  'bns.name': 'Наименование',
  'bns.points': 'Баллы',
  'bns.accrued': 'Начислено',
  'bns.paid': 'Выплачено',
  'bns.balance': 'Остаток',
  'bns.balanceFilter': 'Остаток',
  'bns.onlyWithBalance': 'Только с остатком',
  'bns.filterAll': 'Все',
  'bns.blocked': 'Заблокирован',
  'bns.accrue': 'Начислить ретробонус',
  'bns.accruedMsg': '{docNo}: начислено {amount} USD',
  'bns.payout': 'Выплатить',
  'bns.payoutTitle': '{name} — выплата бонуса',
  'bns.payoutConfirm': 'Провести выплату',
  'bns.payoutWarn': 'Это действие ВЫДАЁТ ДЕНЬГИ ИЗ КАССЫ, и отменить его нельзя. Движение записывается со статьёй ДДС, а остаток кассы уменьшается сразу.',
  'bns.cashAccount': 'Касса',
  'bns.cashPick': 'Выберите кассу',
  'bns.cashHint': 'Валюта берётся из кассы, а курс — на дату выплаты.',
  'bns.amountUsd': 'Сумма (USD)',
  'bns.amountHint': 'Остаток: {balance} USD. Можно выплачивать частями.',
  'bns.pointsToCash': 'Баллов к выплате',
  'bns.pointsHint': 'На балансе {balance} баллов. Баллы списываются сразу.',
  'bns.notes': 'Примечание',
  'bns.paidMsg': '{docNo}: выплачено {amount} {currency}',
  'bns.noPayout': 'У вас нет права выплачивать бонус — это равносильно выдаче денег из кассы, и оно есть только у финансиста и администратора. При необходимости обратитесь к ним.',
  'bns.searchPlaceholder': 'Код дилера, телефон мастера или наименование',
  'bns.empty': 'Бонусный счёт не найден',
  'bns.loadError': 'Не удалось загрузить бонусные счета',
  'bns.ledgerHint': 'Каждое начисление и каждая выплата остаются в реестре.',
  'bns.openLedger': 'Открыть реестр бонусов',
  'bnl.description': 'Реестр бонусов — неизменяемая история начислений и выплат. Запись не удаляется и не редактируется: бонус — обязательство компании, а выплата — деньги, ушедшие из кассы.',
  'bnl.immutable': 'Реестр НЕИЗМЕНЯЕМ. Исправление вносится только обратной записью, и это отдельное, зафиксированное действие.',
  'bnl.docNo': 'Документ',
  'bnl.occurredAt': 'Время',
  'bnl.entryType': 'Тип',
  'bnl.typeAccrual': 'Начислено',
  'bnl.typePayout': 'Выплачено',
  'bnl.basis': 'База',
  'bnl.pointsUnit': 'баллов',
  'bnl.amountBase': 'Сумма (USD)',
  'bnl.amount': 'Сумма по кассе',
  'bnl.balanceAfter': 'Остаток (после)',
  'bnl.reversal': 'Сторно',
  'bnl.searchPlaceholder': 'Номер документа',
  'bnl.empty': 'Реестр пуст',
  'bnl.loadError': 'Не удалось загрузить реестр бонусов',
  'loy.points': 'Баллы',
  'loy.pointsUnit': '{points} баллов',
  'loy.actions': 'Действия',
  'loy.sku': 'SKU',
  'loy.product': 'Товар',
  'loy.pointValue': 'Стоимость балла',
  'loy.pointValueUnit': '{value} / 1 балл',
  'loy.pointValueBasis': '{rewards} активных подарков: общая себестоимость {cost} ÷ всего {points} баллов',
  'loy.pointValueWhy': 'Стоимость балла ВЫВОДИТСЯ ИЗ КАТАЛОГА: общая себестоимость подарков ÷ их общая цена в баллах. То есть при изменении каталога меняется и денежная стоимость накопленных баллов — а количество баллов остаётся прежним.',
  'loy.pointValueMissing': 'СТОИМОСТЬ БАЛЛА НЕ РАССЧИТЫВАЕТСЯ',
  'loy.pointValueMissingBody': 'В каталоге нет ни одного активного подарка с указанной себестоимостью. В этом случае ВСЕ денежные суммы на этом экране неизвестны: запись «долг 150 баллов» ничего не даёт бюджету. Сначала укажите себестоимость подарка в каталоге подарков.',
  'loy.pointValueZeroRewards': 'Значение выведено из НУЛЯ подарков — то есть это не значение. Укажите себестоимость в каталоге подарков.',
  'loy.pointValueSample': 'Это значение — ОБРАЗЕЦ: оно поставлено как временный пример и его обязательно нужно заменить настоящим. После утверждения маркетингом оно будет определяться каталогом подарков.',
  'loy.title': 'Программа мастеров — состояние программы',
  'loy.description': 'Мастер устанавливает LED-продукцию, сканирует QR-код и накапливает баллы. Каждый балл — ОБЯЗАТЕЛЬСТВО КОМПАНИИ: деньги не ушли, товар не отгружен, но обещание дано. Этот экран показывает этот долг.',
  'loy.outstanding': 'Непогашенное обязательство',
  'loy.outstandingHint': 'Баллы на руках у мастеров — подарок могут запросить в любой день',
  'loy.outstandingInstallers': 'Баллы есть у {withBalance} мастеров (из {total})',
  'loy.pending': 'Обмены в очереди',
  'loy.pendingHint': 'Запрошенные или утверждённые, но ещё не выданные подарки',
  'loy.pendingCount': 'Заявок: {count}',
  'loy.awaiting': 'Ожидает сканирования',
  'loy.awaitingHint': 'Товар ПРОДАН, мастер ещё не сканировал',
  'loy.awaitingCodes': 'Активированных кодов: {codes}',
  'loy.awaitingWhy': 'Это ПОТЕНЦИАЛЬНОЕ обязательство, а не ошибка. Код активируется только при продаже товара, то есть выдача этих баллов ГАРАНТИРОВАНА: мастер просто ещё не сканировал. В бюджете их нужно учитывать уже сейчас.',
  'loy.awaitingByProduct': 'В разрезе товаров',
  'loy.awaitingEmpty': 'Активированных, но не сканированных кодов нет',
  'loy.codes': 'Коды',
  'loy.pointsPerCode': 'Баллов / код',
  'loy.missingRuleBadge': 'Нет правила',
  'loy.missingRuleWarn': 'По {count} товарам есть активированные коды, но НЕТ действующего на сегодня правила начисления баллов. При сканировании этих кодов баллы не начислятся, и мастер позвонит со словами «QR не работает».',
  'loy.totalOwed': 'Итого обязательство',
  'loy.totalOwedHint': 'Баланс + очередь + баллы, ожидающие сканирования',
  'loy.quickLinks': 'Экраны программы',
  'loy.fraudSignals': 'Сигналов в очереди контроля: {count}',
  'loy.fraudNone': 'Очередь контроля пуста',
  'loy.loadError': 'Не удалось загрузить состояние программы',
  'loy.installersTotal': 'Мастеров в реестре',
  'lpr.title': 'Правила начисления баллов',
  'lpr.description': 'Сколько баллов даёт одна коробка каждого товара. Товар БЕЗ правила баллов не даёт, и его код вообще не сканируется.',
  'lpr.frozenWhy': 'Начисленные баллы фиксируются В МОМЕНТ СКАНИРОВАНИЯ. Если изменить правило позже, прошлые сканирования не пересчитываются — иначе накопленные мастером баллы менялись бы каждую неделю.',
  'lpr.versionedWhy': 'Правило НЕ РЕДАКТИРУЕТСЯ, а ВЕРСИОНИРУЕТСЯ по датам (тот же приём, что и в прайс-листе): для акции добавляется новая строка. Поэтому на этом экране нет кнопки «изменить».',
  'lpr.points': 'Баллы',
  'lpr.validFrom': 'Действует с',
  'lpr.validTo': 'Действует по',
  'lpr.validToHint': 'Если оставить пустым — бессрочно. Для акции укажите дату окончания.',
  'lpr.notes': 'Примечание',
  'lpr.state': 'Статус',
  'lpr.state.active': 'Действует',
  'lpr.state.future': 'В будущем',
  'lpr.state.expired': 'Просрочено',
  'lpr.showAll': 'Показать все версии',
  'lpr.showAllHint': 'Обычно показываются только правила, действующие СЕГОДНЯ: по одному товару со временем накапливаются десятки версий, и они хоронят ответ.',
  'lpr.new': 'Новое правило',
  'lpr.create': 'Создать правило',
  'lpr.created': '{sku} — {points} баллов (с {from})',
  'lpr.productRequired': 'Товар обязателен',
  'lpr.pointsInvalid': 'Баллы должны быть целым числом от 0 до 1 000 000',
  'lpr.zeroAllowed': '0 РАЗРЕШЁН и отличается от ОТСУТСТВИЯ правила: 0 — «по этому товару баллы намеренно не начисляются», а отсутствие правила — «настроить забыли».',
  'lpr.noEdit': 'У вас нет права изменять правила начисления баллов — оно есть только у администратора и руководителя. Курс баллов — решение МАРКЕТИНГА, а не финансов; при необходимости обратитесь к руководителю.',
  'lpr.missingTitle': 'Товаров без правила начисления баллов: {count}',
  'lpr.missingBody': 'Сканирование этих товаров ОТКЛОНЯЕТСЯ с причиной «Нет правила начисления». Мастер позвонит со словами «QR не работает», и причину будут искать час — поэтому список стоит здесь.',
  'lpr.missingNone': 'У всех продаваемых товаров есть действующее сегодня правило начисления баллов.',
  'lpr.missingLoadError': 'Не удалось загрузить список товаров без правил.',
  'lpr.missingOrder': 'Порядок — по СРОЧНОСТИ: сверху товар с наибольшим числом активированных кодов. Активированный код означает «товар продан», то есть мастер прямо сейчас может пытаться сканировать и получать отказ.',
  'lpr.activatedCodes': 'Активированных кодов',
  'lpr.missingUrgent': 'У {count} есть активированные коды',
  'lpr.missingUrgentHint': 'Товар продан, код активирован, а правила нет — сканирование будет отклонено.',
  'lpr.missingScanning': 'Возможно, сканируется прямо сейчас',
  'lpr.missingRest': 'Ещё по {count} товарам правила нет — они менее срочные.',
  'lpr.stats.active': 'Действующих правил',
  'lpr.stats.future': 'Будущих',
  'lpr.stats.expired': 'Просроченных',
  'lpr.stats.missing': 'Товаров без правила',
  'lpr.empty': 'Правила начисления баллов не найдены',
  'lpr.emptyHint': 'Расширьте фильтр или создайте первое правило.',
  'lpr.loadError': 'Не удалось загрузить правила начисления баллов',
  'lpr.filterProduct': 'По товару',
  'lpr.clearFilter': 'Очистить фильтр',
  'lqr.title': 'Партии QR-кодов',
  'lqr.description': 'УНИКАЛЬНЫЙ код для каждой коробки. Код рождается в статусе «На складе» и НЕ СКАНИРУЕТСЯ — он активируется только при продаже товара.',
  'lqr.lifecycleWhy': 'created → (товар продан) → activated → (мастер отсканировал) → scanned. Активация привязана к отгрузке, то есть за товар, лежащий на складе, баллы начислить нельзя, и даже если рулон стикеров попадёт в чужие руки, баллы можно получить только за ПРОДАННОЕ.',
  'lqr.batchNo': 'Партия',
  'lqr.quantity': 'Количество кодов',
  'lqr.printedAt': 'Экспортировано',
  'lqr.notPrinted': 'Не экспортировано',
  'lqr.notes': 'Примечание',
  'lqr.st.created': 'На складе',
  'lqr.st.activated': 'Продан',
  'lqr.st.scanned': 'Отсканирован',
  'lqr.st.void': 'Аннулирован',
  'lqr.new': 'Новая партия',
  'lqr.createSubmit': 'Создать партию',
  'lqr.createdMsg': '{batchNo}: создано кодов — {quantity}',
  'lqr.quantityHint': 'От 1 до {max}. Лишние коды съедают бюджет печати.',
  'lqr.quantityInvalid': 'Количество должно быть целым числом от 1 до {max}',
  'lqr.noGenerate': 'У вас нет права выпускать и экспортировать коды — оно есть только у администратора и руководителя. При необходимости обратитесь к руководителю.',
  'lqr.export': 'Экспортировать коды',
  'lqr.exportTitle': 'Экспорт — это не чтение, а действие, равное ВЫПУСКУ КОДОВ',
  'lqr.exportBody': 'В ответе — ВСЕ коды партии открытым текстом. Тот, кто их получит, сможет собрать все баллы сразу после продажи товара, то есть этот файл — ценная бумага.',
  'lqr.exportAudited': 'САМО это действие попадает в журнал аудита как «экспорт», и у партии проставляется дата экспорта. Даже если вы не сохраните файл, запись останется — отменить её нельзя.',
  'lqr.exportUnderstood': 'Понимаю: действие попадёт в аудит и будет проставлена дата',
  'lqr.exportReprint': 'ВНИМАНИЕ: эта партия уже экспортировалась {date}. Повторный экспорт означает «печатаем ещё раз» и выглядит в аудите подозрительно — укажите причину в примечании.',
  'lqr.exportConfirm': 'Да, экспортировать {count} кодов',
  'lqr.exportDone': '{batchNo}: в файл выгружено кодов — {count}',
  'lqr.exportFailed': 'Не удалось экспортировать коды',
  'lqr.exportFileHint': 'Файл строится ИМЕННО из тех кодов, которые пришли с сервера — второй запрос не отправляется. Столбцы: порядковый номер, код, статус, артикул товара (SKU) и номер партии. Заголовок файла — serial;code;status;sku;batch_no',
  'lqr.empty': 'Партии QR-кодов не найдены',
  'lqr.emptyHint': 'Возможно, ещё не создана ни одна партия.',
  'lqr.loadError': 'Не удалось загрузить партии QR-кодов',
  'lst.title': 'Запас стикеров',
  'lst.why': 'При проведении отгрузки активируются коды этого товара. Если кодов НЕ ХВАТИТ, доставка НЕ ОСТАНОВИТСЯ — в журнал лишь запишется предупреждение, то есть товар уедет без стикеров, и мастеру нечего будет сканировать. Именно здесь видна эта тихая ошибка.',
  'lst.created': 'Остаток запаса',
  'lst.productStock': 'Остаток товара',
  'lst.order': 'Сортировка по возрастанию запаса: сверху товары, которые заканчиваются.',
  'lst.rest': 'Ещё товаров в списке: {count}.',
  'lst.emptyWarn': 'У {count} товаров НЕТ ЗАПАСА кодов: при следующей доставке на их коробки не попадут стикеры. Создайте новую партию.',
  'lst.lowWarn': 'У {count} товаров запас меньше {threshold} — печать и наклейка партии требуют времени, закажите заранее.',
  'lst.badgeEmpty': 'Нет запаса',
  'lst.badgeLow': 'Мало запаса',
  'lst.empty': 'Ни для одного товара QR-коды не созданы',
  'lst.loadError': 'Не удалось загрузить запас стикеров',
  'lrw.title': 'Каталог подарков',
  'lrw.description': 'На что обмениваются баллы. Себестоимость — цена подарка ДЛЯ КОМПАНИИ; именно она определяет реальную стоимость балла.',
  'lrw.code': 'Код',
  'lrw.name': 'Наименование',
  'lrw.pointsCost': 'Цена в баллах',
  'lrw.costBase': 'Себестоимость (USD)',
  'lrw.costBaseHint': 'Расход компании. Если не заполнено, этот подарок НЕ УЧАСТВУЕТ в расчёте стоимости балла.',
  'lrw.stockQty': 'Остаток',
  'lrw.stockUnlimited': 'Неограниченно',
  'lrw.stockHint': 'Пустое значение — неограниченно (как сертификат). 0 — закончился.',
  'lrw.status': 'Статус',
  'lrw.active': 'Активен',
  'lrw.inactive': 'Отключён',
  'lrw.derivedValue': 'Стоимость балла (расчётная)',
  'lrw.average': 'Среднее по каталогу: {value}',
  'lrw.averageMissing': 'Не удалось рассчитать среднее по каталогу — не заполнена себестоимость',
  'lrw.divergeWhy': 'Соотношение должно быть ЕДИНЫМ. Если один подарок выгоднее остальных, мастер обязательно это посчитает, и остальной каталог работать не будет. «Стоимость балла» в каждой строке = себестоимость ÷ цена в баллах; строки с отклонением более чем на ±{pct}% от среднего помечаются.',
  'lrw.divergeAlert': '{count} подарков отличаются от среднего по каталогу более чем на ±{pct}% — реальный курс балла задаётся именно этими строками.',
  'lrw.flag.high': 'Выгоднее среднего',
  'lrw.flag.highHint': 'Мастер выберет именно этот подарок — на практике курс балла задаётся этой строкой.',
  'lrw.flag.low': 'Хуже среднего',
  'lrw.flag.lowHint': 'Этот подарок на практике не запрашивают — мёртвая позиция в каталоге.',
  'lrw.flag.unknown': 'Без себестоимости',
  'lrw.new': 'Новый подарок',
  'lrw.create': 'Создать подарок',
  'lrw.createdMsg': 'Подарок создан: {code}',
  'lrw.edit': 'Редактировать',
  'lrw.editTitle': '{name} — редактирование',
  'lrw.saved': 'Подарок сохранён: {name}',
  'lrw.codeImmutable': 'Код НЕ РЕДАКТИРУЕТСЯ: это постоянный идентификатор, и его изменение разрывает историю обменов.',
  'lrw.deactivate': 'Отключить',
  'lrw.activate': 'Включить',
  'lrw.deactivateHint': 'Отключённый подарок не виден мастеру, но старые заявки остаются на месте, а сам он исключается из расчёта стоимости балла.',
  'lrw.moneyAsText': 'Себестоимость и остаток хранятся ТОЧНО: они не переводятся в округляемое число, потому что здесь важна даже 0,01.',
  'lrw.invalidMoney': 'Неверный формат суммы (например «12.5000»)',
  'lrw.invalidPoints': 'Цена в баллах должна быть целым числом больше 1',
  'lrw.codeRequired': 'Код и наименование обязательны для заполнения',
  'lrw.noEdit': 'У вас нет права изменять каталог подарков. Каталог — это МАРКЕТИНГОВЫЙ бюджет; при необходимости обратитесь к руководителю.',
  'lrw.empty': 'Подарки не найдены',
  'lrw.loadError': 'Не удалось загрузить каталог подарков',
  'lrd.title': 'Обмены подарков',
  'lrd.description': 'Заявки, отправленные мастерами. Утверждение → выдача; отклонение ВОЗВРАЩАЕТ баллы.',
  'lrd.deductedWhy': 'Баллы списываются УЖЕ в момент заявки — иначе мастер отправил бы одни и те же баллы на два подарка. То есть «утверждение» не является движением денег, а «отклонение» НЕ бесплатно: при отклонении баллы возвращаются мастеру обратной записью и его баланс сразу увеличивается.',
  'lrd.separationWhy': 'Из статуса «Запрошен» нельзя перейти сразу в «Выдан»: тот, кто утверждает заявку, и тот, кто выдаёт подарок, не должны быть одним человеком, иначе кладовщик сможет выписать подарок самому себе.',
  'lrd.docNo': 'Документ',
  'lrd.installer': 'Мастер',
  'lrd.reward': 'Подарок',
  'lrd.pointsCost': 'Баллы',
  'lrd.status': 'Статус',
  'lrd.statusAll': 'Все статусы',
  'lrd.requestedAt': 'Дата заявки',
  'lrd.issuedAt': 'Выдан',
  'lrd.rejectReason': 'Причина отклонения',
  'lrd.deliveryNote': 'Примечание к доставке',
  'lrd.status.requested': 'Запрошен',
  'lrd.status.approved': 'Утверждён',
  'lrd.status.issued': 'Выдан',
  'lrd.status.rejected': 'Отклонён',
  'lrd.status.cancelled': 'Отменён',
  'lrd.approve': 'Утвердить',
  'lrd.approved': '{docNo} утверждён — теперь подарок можно выдать',
  'lrd.issue': 'Выдать',
  'lrd.issueNote': 'Примечание к выдаче (телефон, адрес)',
  'lrd.issued': '{docNo} выдан — КОНЕЧНЫЙ статус',
  'lrd.reject': 'Отклонить',
  'lrd.rejectTitle': 'Отклонение заявки',
  'lrd.rejectHint': 'Причина ОБЯЗАТЕЛЬНА, и мастер её видит: заявка, отклонённая без причины, тут же отправляется повторно, и очередь снова заполняется.',
  'lrd.rejectReasonRequired': 'Причина должна содержать не менее 3 символов',
  'lrd.rejected': '{docNo} отклонён — мастеру возвращено баллов: {points} (новый баланс {balance})',
  'lrd.noApprove': 'У вас нет права утверждать заявки. При необходимости обратитесь к руководителю.',
  'lrd.empty': 'Заявки на обмен не найдены',
  'lrd.emptyHint': 'Расширьте фильтр по статусу.',
  'lrd.loadError': 'Не удалось загрузить обмены',
  'lrd.filterInstaller': 'Фильтр по мастеру #{id}',
  'lrd.clearFilter': 'Сбросить фильтр',
  'lin.title': 'Мастера',
  'lin.description': 'Мастера, зарегистрированные в программе, их баланс баллов и последняя активность.',
  'lin.notUserWhy': 'Мастер пользуется программой только для сканирования кодов и не имеет доступа к Alight. Поэтому на этом экране ему не выдают ни ролей, ни прав — есть только блокировка.',
  'lin.policyMore': 'Подробнее',
  'lin.blockPolicy': 'Блокировка ставится по подозрению, и проверка может его не подтвердить, а накопленные баллы — это долг компании перед мастером. Поэтому при блокировке баллы не трогают. Отозвать ошибочно начисленные баллы — отдельное действие: найти нужное сканирование в очереди контроля и сторнировать его.',
  'lin.phone': 'Телефон',
  'lin.name': 'ФИО',
  'lin.balance': 'Баланс',
  'lin.earned': 'Начислено',
  'lin.redeemed': 'Потрачено',
  'lin.lastScan': 'Последнее сканирование',
  'lin.neverScanned': 'Не сканировал',
  'lin.lastLogin': 'Последний вход',
  'lin.createdAt': 'Зарегистрирован',
  'lin.status': 'Статус',
  'lin.active': 'Активен',
  'lin.blocked': 'Заблокирован',
  'lin.verified': 'Подтверждён',
  'lin.block': 'Заблокировать',
  'lin.unblock': 'Разблокировать',
  'lin.blockTitle': '{name} — блокировка',
  'lin.unblockTitle': '{name} — разблокировка',
  'lin.blockReason': 'Причина блокировки',
  'lin.blockReasonRequired': 'Причина обязательна — она попадёт в аудит',
  'lin.blockKeepsPoints': 'Блокировка останавливает сканирование — накопленные баллы остаются у мастера.',
  'lin.blockedOk': '{name} заблокирован. Баланс не изменился: {balance} баллов.',
  'lin.unblockedOk': '{name} разблокирован',
  'lin.noBlock': 'У вас нет права блокировать мастеров — поэтому в строках эта кнопка не показывается. При необходимости обратитесь к руководителю.',
  'lin.filterAll': 'Все',
  'lin.filterActive': 'Только активные',
  'lin.filterBlocked': 'Только заблокированные',
  'lin.searchPlaceholder': 'Имя или телефон',
  'lin.openRedemptions': 'Обмены →',
  'lin.openFraud': 'Очередь контроля →',
  'lin.empty': 'Мастера не найдены',
  'lin.emptyHint': 'Расширьте фильтр или очистите поиск.',
  'lin.loadError': 'Не удалось загрузить мастеров',
  'lin.notFound': 'Мастер не найден или недоступен вам',
  'lin.openCard': 'Карточка →',
  'lin.unblockHint': 'После разблокировки мастер снова сможет сканировать. Коды, не отсканированные за время блокировки, не пропадают — они по-прежнему активны и могут быть отсканированы позже.',
  'lid.back': '← Список мастеров',
  'lid.telegram': 'Telegram подключён',
  'lid.balanceHint': 'Долг компании перед этим мастером',
  'lid.earnedTotal': 'Начислено: {points}',
  'lid.redeemedTotal': 'Потрачено: {points}',
  'lid.scanCount': 'Успешные сканирования',
  'lid.scanCountHint': 'Количество кодов, за которые начислены баллы',
  'lid.rejectedCount': 'Отклонённые попытки',
  'lid.rejectedCountHint': 'Сами по себе НЕ являются обвинением: честный мастер тоже ошибается при вводе кода. Решение принимается в очереди контроля, вместе с остальными разрезами.',
  'lid.ledger': 'Реестр баллов',
  'lid.ledgerWhy': 'Реестр НЕИЗМЕНЯЕМ: запись нельзя удалить или исправить, можно лишь добавить ОБРАТНУЮ запись. Поэтому «сторно» (сама запись является обратной) и «сторнировано» (эта запись была позже сторнирована) — два разных признака. В колонке источника для сканирования указывается SKU, а для обмена — наименование подарка.',
  'lid.ledgerEmpty': 'Реестр пуст — этот мастер ещё не накопил баллов',
  'lid.ledgerLimit': 'Показываются последние 200 записей.',
  'lid.occurredAt': 'Время',
  'lid.direction': 'Направление',
  'lid.balanceAfter': 'Баланс (после)',
  'lid.source': 'Источник',
  'lid.sourceRef': '{table} #{id}',
  'lid.reversal': 'Сторно',
  'lid.reversed': 'Сторнировано',
  'lid.dir.earn': 'Начислено',
  'lid.dir.redeem': 'Потрачено',
  'lid.dir.adjust': 'Корректировка',
  'lid.dir.expire': 'Сгорело',
  'lid.redemptions': 'Обмены',
  'lid.redemptionsEmpty': 'Этот мастер ещё не запрашивал подарков',
  'lid.reconOk': 'Баланс сходится с реестром: {balance} = {ledger}',
  'lid.reconFailedTitle': 'БАЛАНС НЕ СХОДИТСЯ С РЕЕСТРОМ',
  'lid.reconNumbers': 'Баланс {balance}, сумма по реестру {ledger}, расхождение {diff} баллов',
  'lid.reconFailedBody': 'Это ошибка не ОТОБРАЖЕНИЯ, а данных. Показанный баланс — это быстрая копия, а истина — в истории движений; если они разошлись, неверны и баланс, который видит мастер, и отчёт по обязательствам. Пока причина не найдена, не утверждайте обмены этого мастера, а исправление вносите отдельным корректирующим движением, а не ручной правкой баланса.',
  'lfr.title': 'Очередь контроля',
  'lfr.description': 'ОТКЛОНЁННЫЕ попытки сканирования. Схемы мошенничества видны именно здесь, а не в успешных сканированиях.',
  'lfr.days': 'Окно, дней',
  'lfr.minAttempts': 'Порог сигнала',
  'lfr.minAttemptsHint': 'Меньшее число попыток в очередь не попадает (2…1000).',
  'lfr.limit': 'Лимит строк',
  'lfr.window': 'Последние {days} дней · порог {min} попыток',
  'lfr.summary': 'Причины отклонения',
  'lfr.summaryTotal': 'Всего отклонений',
  'lfr.reason.not_found': 'Код не найден',
  'lfr.reason.already_scanned': 'Уже отсканирован',
  'lfr.reason.not_activated': 'Не активирован',
  'lfr.reason.void': 'Аннулированный код',
  'lfr.reason.installer_blocked': 'Мастер заблокирован',
  'lfr.reason.rate_limited': 'Превышен лимит',
  'lfr.reason.no_points_rule': 'Нет правила начисления',
  'lfr.summaryMeaning': 'Если доля «Код не найден» высока — коды ПОДБИРАЮТ. А доля «Нет правила начисления» — это не мошенничество, а ошибка НАСТРОЙКИ: честный мастер не получает баллы, и причина — на экране правил начисления баллов.',
  'lfr.byInstaller': 'По мастерам',
  'lfr.byInstallerMeaning': 'Много отклонений с одного аккаунта. Если доля «Код не найден» высока — он ПОДБИРАЕТ коды: честный мастер, даже ошибаясь при вводе, не сделает 200 ошибок.',
  'lfr.byCode': 'По кодам',
  'lfr.byCodeMeaning': 'Один код приходил много раз. Код каждой коробки УНИКАЛЕН, поэтому если один код приходит с разных АККАУНТОВ — его РАСПРОСТРАНИЛИ: фото выложили в чат или стикер переклеили.',
  'lfr.byIp': 'По IP-адресам',
  'lfr.byIpMeaning': 'Много АККАУНТОВ с одного адреса. Открыть на одном телефоне десятки аккаунтов и выбирать поминутный лимит с каждого — самый простой способ обойти ограничение («ферма аккаунтов»).',
  'lfr.recent': 'Последние попытки',
  'lfr.recentMeaning': 'Без агрегации, сырой вид. Расследование всегда начинается с вопроса «что именно сделал этот человек?», а по сводным таблицам это не восстановить.',
  'lfr.attempts': 'Попытки',
  'lfr.distinctCodes': 'Разных кодов',
  'lfr.distinctInstallers': 'Разных мастеров',
  'lfr.lastAt': 'Последняя попытка',
  'lfr.reasons': 'Причины',
  'lfr.code': 'Код',
  'lfr.ip': 'IP',
  'lfr.installer': 'Мастер',
  'lfr.notFoundShare': 'Не найдено',
  'lfr.signal': 'Сигнал',
  'lfr.signal.guessing': 'Подбор кодов',
  'lfr.signal.shared': 'Распространённый код',
  'lfr.signal.farming': 'Ферма аккаунтов',
  'lfr.unknownInstaller': 'Не зарегистрирован',
  'lfr.empty': 'По этому окну и порогу сигналов нет',
  'lfr.emptyHint': 'Расширьте окно или снизьте порог.',
  'lfr.loadError': 'Не удалось загрузить очередь контроля',
  'lfr.blockFromHere': 'Блокировка мастера — на экране «Мастера».',
  'lfr.reverseTitle': 'Сторнирование сканирования',
  'lfr.reverseWhy': 'Отзывает начисленные баллы обратной записью. Статус кода НЕ МЕНЯЕТСЯ — он является ДОКАЗАТЕЛЬСТВОМ начисления и нужен для расследования. САМОЙ ПО СЕБЕ БЛОКИРОВКИ мастера недостаточно: блокировка останавливает сканирование, но накопленные баллы остаются и будут обменяны на подарок.',
  'lfr.reverseSearch': 'Найти сканирование по коду',
  'lfr.reverseSearchPlaceholder': 'Полный код или его часть',
  'lfr.reverseSearchHint': 'Поиск работает и по части строки — достаточно нескольких символов с хвостика стикера. В списке только сканирования С НАЧИСЛЕНИЕМ баллов: отклонённые попытки — в таблицах выше.',
  'lfr.reverseSearchShort': 'Введите не менее {min} символов',
  'lfr.reverseSearchError': 'Не удалось найти сканирования',
  'lfr.reverseNoScans': 'По этому коду сканирований с начислением баллов не найдено',
  'lfr.reverseSelect': 'Выбрать',
  'lfr.reverseAlready': 'Сторнировано',
  'lfr.reverseSelected': '{code} — {points} баллов, мастер: {installer}. Баллы будут отозваны обратной записью.',
  'lfr.scannedAt': 'Отсканирован',
  'lfr.reverseReason': 'Причина сторнирования',
  'lfr.reverseReasonRequired': 'Причина должна содержать не менее 3 символов',
  'lfr.reverseSubmit': 'Отозвать баллы',
  'lfr.reverseDone': '{code}: отозвано баллов — {points}. Новый баланс мастера #{installer} — {balance} баллов.',
  'lfr.reverseNoPermission': 'У вас нет права сторнировать сканирование — это ТО ЖЕ право, что и на блокировку мастера: обе операции являются частями одной меры воздействия. При необходимости обратитесь к руководителю.',
  'lfr.reverseExceeds': 'Баллов недостаточно — мастер УЖЕ потратил их на подарок. Это не техническая ошибка: компания понесла убыток, а частичное сторнирование его СКРЫЛО БЫ. По подарку нужно отдельное решение.',
  'nav.goodsReceipts': 'Приход товара',
  'nav.supplierInvoices': 'Счета поставщиков',
  'nav.import': 'Загрузка из файла',
  'nav.roles': 'Роли',
  'nav.systemSettings': 'Настройки системы',
  'nav.organization': 'Оргструктура',
  'nav.group.loyalty': 'Программа для мастеров',
  'nav.loyaltyStatus': 'Состояние программы',
  'nav.loyaltyPointRules': 'Правила начисления баллов',
  'nav.loyaltyQrBatches': 'Партии QR-кодов',
  'nav.loyaltyRewards': 'Каталог подарков',
  'nav.loyaltyRedemptions': 'Обмены',
  'nav.loyaltyInstallers': 'Мастера',
  'nav.loyaltyFraud': 'Очередь контроля',
  'nav.dealers': 'Дилеры',
  'nav.bonusAccounts': 'Бонусные счета',
  'nav.bonusLedger': 'Реестр бонусов',
  'nav.deliveries': 'Доставки',
  'nav.reportAgentActivity': 'Активность торговых агентов',
  'ret.title': 'Возвраты',
  'ret.quarantineTitle': 'Товары в карантине',
  'ret.description': 'Товар, вернувшийся от клиента: приёмка, осмотр и дальнейшая судьба. Товар, требующий осмотра, попадает на склад КАРАНТИНА и не поступает в продажу.',
  'ret.new': 'Новый возврат',
  'ret.empty': 'Документов возврата нет',
  'ret.emptyHint': 'Когда клиент вернёт товар, здесь откроется документ.',
  'ret.docNo': 'Документ',
  'ret.date': 'Дата',
  'ret.customer': 'Клиент',
  'ret.invoice': 'Счёт-фактура',
  'ret.warehouse': 'Склад',
  'ret.quarantineWarehouse': 'Склад карантина',
  'ret.reason': 'Причина',
  'ret.settlement': 'Взаиморасчёт',
  'ret.total': 'Сумма',
  'ret.status': 'Статус',
  'ret.lineCount': 'Строки',
  'ret.qcRequired': 'Требуется осмотр',
  'ret.qcRequiredYes': 'Попадёт в карантин',
  'ret.qcRequiredNo': 'Напрямую на основной склад',
  'ret.qcRequiredHint': 'Значение по умолчанию зависит от причины. Если измените его, изменится и то, куда поступит товар.',
  'ret.filterStatus': 'Статус',
  'ret.filterReason': 'Причина',
  'ret.filterAll': 'Все',
  'ret.searchPlaceholder': 'Номер документа или имя клиента',
  'ret.status.draft': 'Черновик',
  'ret.status.approved': 'Утверждён',
  'ret.status.received': 'Принят',
  'ret.status.inspected': 'Осмотрен',
  'ret.status.settled': 'Закрыт',
  'ret.status.cancelled': 'Отменён',
  'ret.reason.defect': 'Брак',
  'ret.reason.damaged': 'Повреждён',
  'ret.reason.warranty': 'Гарантия',
  'ret.reason.wrong_item': 'Не тот товар',
  'ret.reason.customer_change': 'Клиент передумал',
  'ret.reason.other': 'Другое',
  'ret.settlement.credit_note': 'Кредит-нота',
  'ret.settlement.refund': 'Возврат денег',
  'ret.settlement.replacement': 'Замена',
  'ret.qc.pass': 'Годен',
  'ret.qc.fail': 'Не годен',
  'ret.qc.conditional': 'Условно годен',
  'ret.qc.pending': 'Не осмотрен',
  'ret.disp.resale': 'Возврат на полку',
  'ret.disp.repair': 'В ремонт',
  'ret.disp.replacement': 'Замена',
  'ret.disp.supplier_claim': 'Претензия заводу',
  'ret.disp.quarantine': 'Решения нет',
  'ret.disp.scrap': 'Утилизация',
  'ret.disp.resaleHint': 'Перемещается из карантина на основной склад и снова продаётся. После выполнения остаток на складе изменится.',
  'ret.disp.repairHint': 'Остаётся в карантине, пока мастер не починит — движения по складу нет.',
  'ret.disp.replacementHint': 'Клиенту выдаётся новый, старый остаётся у нас в карантине — движения по складу нет.',
  'ret.disp.supplier_claimHint': 'ДОКАЗАТЕЛЬСТВО для претензии заводу. Не списывается: иначе за возвращаемыми деньгами не будет стоять ничего.',
  'ret.disp.quarantineHint': 'Решение ещё не принято — товар ждёт в карантине.',
  'ret.disp.scrapHint': 'Списывается, и это НЕОБРАТИМО. Нужно подтверждение финансиста — обратитесь к нему.',
  'ret.defect.burnt': 'Сгорел / не горит',
  'ret.defect.not_working': 'Совсем не работает',
  'ret.defect.low_output': 'Низкая яркость',
  'ret.defect.flicker': 'Мерцает',
  'ret.defect.physical_damage': 'Повреждён корпус',
  'ret.defect.packaging_damage': 'Повреждена только упаковка',
  'ret.defect.wrong_spec': 'Характеристики не соответствуют',
  'ret.defect.incomplete': 'Некомплект',
  'ret.defect.other': 'Другое (примечание обязательно)',
  'ret.detail.approve': 'Утвердить',
  'ret.detail.receive': 'Принять товар',
  'ret.detail.dispose': 'Выполнить решение',
  'ret.detail.settle': 'Закрыть денежную часть',
  'ret.detail.cancel': 'Отменить',
  'ret.detail.approveHint': 'После утверждения документ не редактируется — кладовщик ждёт товар, опираясь на него.',
  'ret.detail.receiveHint': 'Товар поступает НА СКЛАД: если требуется осмотр — в карантин, иначе на основной склад. Это изменит остаток на складе.',
  'ret.detail.disposeHint': 'По каждой строке ВЫПОЛНЯЕТСЯ принятое решение: «возврат на полку» — перемещение, «утилизация» — списание, в остальных случаях товар остаётся в карантине.',
  'ret.detail.settleHint': 'Документ закрывается. Двойной записи в системе пока нет — кредит-ноту или возврат денег финансовый отдел оформляет ВРУЧНУЮ.',
  'ret.detail.cancelReason': 'Причина отмены',
  'ret.detail.cancelReasonHint': 'Причина сохраняется в документе и в журнале аудита',
  'ret.detail.pendingDisposition': 'Строк без решения: {count}',
  'ret.detail.settledAt': 'Закрыт',
  'ret.detail.approvedAt': 'Утверждён',
  'ret.detail.noPermission': 'У вас нет права на это действие',
  'ret.line.sku': 'SKU',
  'ret.line.name': 'Наименование',
  'ret.line.qty': 'Количество',
  'ret.line.price': 'Цена',
  'ret.line.amount': 'Сумма',
  'ret.line.cost': 'Себестоимость',
  'ret.line.qc': 'Осмотр',
  'ret.line.defect': 'Дефект',
  'ret.line.disposition': 'Решение',
  'ret.line.state': 'Товар',
  'ret.line.inStock': 'На складе',
  'ret.line.notReceived': 'Не поступил',
  'ret.line.done': 'Выполнено',
  'ret.line.saveQc': 'Сохранить осмотр',
  'ret.line.qcTitle': '{sku} — результат осмотра',
  'ret.line.notes': 'Примечание',
  'ret.line.add': 'Добавить строку',
  'ret.line.remove': 'Удалить',
  'ret.line.empty': 'Добавьте строку',
  'ret.form.title': 'Новый документ возврата',
  'ret.form.hint': 'Документ создаётся как ЧЕРНОВИК: склад пока не затрагивается. Товар поступает на склад только на этапе «приёмка».',
  'ret.form.customer': 'Клиент',
  'ret.form.warehouse': 'На какой склад возвращается',
  'ret.form.warehouseHint': 'Склад, которому товар будет принадлежать В ИТОГЕ. Если требуется осмотр, он сначала попадёт в карантин.',
  'ret.form.submit': 'Создать возврат',
  'ret.form.priceRequired': 'Если счёт-фактура не указан, цена вводится вручную — от неё считается возвращаемая сумма.',
  'ret.qr.description': 'Товары, находящиеся в карантине, по которым решение ещё не выполнено. Строки, ожидающие ответа завода, тоже здесь — про них забывают чаще всего.',
  'ret.qr.empty': 'Карантин пуст',
  'ret.qr.emptyHint': 'Товар появится здесь, когда будет принят возврат, требующий осмотра.',
  'ret.qr.days': 'В карантине, дней',
  'ret.qr.daysLong': 'Уже {days} дней',
  'ret.qr.minDays': 'Минимум дней',
  'ret.qr.open': 'Открыть документ',
  'ret.qr.searchPlaceholder': 'Документ, клиент, SKU или наименование',
  'supplier.description': 'Заводы и поставщики. Срок поставки (lead time) — основной параметр формулы перезаказа: при цикле 120–150 дней заказ нужно размещать за квартал до того, как товар закончится.',
  'supplier.new': 'Новый поставщик',
  'supplier.code': 'Код',
  'supplier.name': 'Наименование',
  'supplier.country': 'Страна',
  'supplier.address': 'Адрес',
  'supplier.phone': 'Телефон',
  'supplier.email': 'Email',
  'supplier.taxId': 'ИНН',
  'supplier.currency': 'Валюта',
  'supplier.paymentTerm': 'Условие оплаты',
  'supplier.leadTime': 'Срок поставки',
  'supplier.leadTimeHint': 'Количество дней от заказа до прибытия товара. Расчёт перезаказа опирается на это число.',
  'supplier.days': '{days} дней',
  'supplier.status': 'Статус',
  'supplier.active': 'Активен',
  'supplier.archived': 'В архиве',
  'supplier.contactOnlyNote': 'Вам доступны наименование и контакты поставщика. Валюта, условие оплаты, срок поставки и цены не показываются — это коммерческая информация, требующая другого права доступа.',
  'supplier.filterSearch': 'Поиск',
  'supplier.filterSearchHint': 'Код или наименование',
  'supplier.filterCountry': 'Код страны',
  'supplier.countryPlaceholder': 'CN',
  'supplier.filterStatus': 'Статус',
  'supplier.filterStatusAll': 'Все',
  'supplier.empty': 'Поставщики не найдены',
  'supplier.emptyHint': 'Измените фильтр или добавьте нового поставщика.',
  'supplier.contacts': 'Контакты',
  'supplier.noContacts': 'Контакты не заполнены',
  'supplier.primaryContact': 'Основной',
  'supplier.products': 'Привязанные товары',
  'supplier.productsHint': 'Собственный SKU завода, минимальная партия (MOQ) и последняя согласованная цена. Эти строки используются при формировании заказа поставщику.',
  'supplier.noProducts': 'Товары не привязаны',
  'supplier.supplierSku': 'SKU завода',
  'supplier.productRef': 'ID в каталоге',
  'supplier.productRefValue': '#{id}',
  'supplier.moq': 'MOQ',
  'supplier.moqHint': 'Минимальная партия, которую принимает завод',
  'supplier.lastPrice': 'Последняя цена',
  'supplier.lastPriceDate': 'Дата цены',
  'supplier.defectRate': 'Брак, %',
  'supplier.formCreate': 'Новый поставщик',
  'supplier.formEdit': 'Редактирование поставщика',
  'invoice.description': 'Счета-фактуры, выставленные клиентам. Просроченные с непогашенным долгом выделяются красным.',
  'invoice.docNo': 'Номер',
  'invoice.customer': 'Клиент',
  'invoice.date': 'Дата',
  'invoice.dueDate': 'Срок оплаты',
  'invoice.total': 'Сумма (с НДС)',
  'invoice.net': 'Сумма без налога',
  'invoice.vat': 'НДС ({rate})',
  'invoice.vatShort': 'НДС',
  'invoice.vatBase': 'НДС (USD)',
  'invoice.lineVatRate': 'НДС %',
  'invoice.lineVat': 'НДС',
  'invoice.paid': 'Оплачено',
  'invoice.credited': 'Кредитовано',
  'invoice.balance': 'Баланс',
  'invoice.statusLabel': 'Статус',
  'invoice.overdueDays': 'Просрочено на {days} дн.',
  'invoice.fxRate': 'Курс документа',
  'invoice.totalBase': 'Сумма (USD)',
  'invoice.notes': 'Примечание',
  'invoice.status.draft': 'Черновик',
  'invoice.status.issued': 'Выставлен',
  'invoice.status.partially_paid': 'Частично оплачен',
  'invoice.status.paid': 'Оплачен',
  'invoice.status.cancelled': 'Отменён',
  'invoice.filterSearch': 'Поиск',
  'invoice.filterSearchHint': 'Номер счёта или клиент',
  'invoice.filterStatus': 'Статус',
  'invoice.filterStatusAll': 'Все',
  'print.action': 'Печать',
  'print.hint': 'Официальная форма печатается на русском языке',
  'print.invoice': 'Печать счёта-фактуры',
  'print.deliveryNote': 'Печать накладной',
  'print.cashReceipt': 'Печать кассового ордера',
  'print.priceList': 'Печать прайс-листа',
  'print.barcodeLabel': 'Печать этикетки',
  'invoice.filterFrom': 'Дата с',
  'invoice.filterTo': 'Дата по',
  'invoice.filterOpenOnly': 'Только с задолженностью',
  'invoice.filterOverdue': 'Только просроченные',
  'invoice.empty': 'Счета-фактуры не найдены',
  'invoice.emptyHint': 'Измените фильтр. Счёт-фактура создаётся из проведённой накладной.',
  'invoice.lines': 'Строки',
  'invoice.linesHint': 'Строки формируются из ПРОВЕДЁННОЙ накладной — то есть здесь тот товар, который фактически ушёл со склада, а не план из заказа.',
  'invoice.lineSku': 'SKU',
  'invoice.lineName': 'Наименование',
  'invoice.lineQty': 'Количество',
  'invoice.linePrice': 'Цена',
  'invoice.lineAmount': 'Сумма',
  'invoice.fxGapTitle': 'Платёж прошёл, но задолженность осталась',
  'invoice.fxGapBody': 'Счёт-фактура {total}, оплачено {paid}, баланс {balance}.',
  'invoice.fxGapWhy': 'Обычная причина — курсовая разница: клиент полностью платит согласованную сумму в сумах, но она пересчитывается в USD по курсу на день платежа и не закрывает задолженность целиком. Точный расчёт виден в карточке платежа.',
  'invoice.fxGapUnexplained': 'Внимание: сумма оплаты и остатка не сошлась с суммой счёта-фактуры. Возможно, по документу проведён возврат или списание — проверьте платежи и возвраты.',
  'invoice.equationHint': 'Оплачено, кредитовано и баланс — вместе дают сумму счёта.',
  'invoice.equationTotal': 'Итого',
  'invoice.equationBrokenTitle': 'Цифры не сходятся',
  'invoice.equationBroken':
    'Оплачено, кредитовано и баланс в сумме не равны сумме счёта. Это сбой данных — покажите документ бухгалтерии, не исправляйте сами.',
  'invoice.creditsHidden':
    'Часть этого счёта закрыта кредит-нотой. Какой именно документ её закрыл — вам не показывается; сама сумма указана выше.',
  'invoice.customerPayments': 'Платежи клиента',
  'invoice.customerPaymentsHint': 'Это ВСЕ платежи КЛИЕНТА, а не только по этому счёту-фактуре: API не привязывает платёж к счёту-фактуре. Какой платёж какой счёт закрыл, видно в карточке платежа.',
  'invoice.noPayments': 'Платежей нет',
  'payment.description': 'Деньги, полученные от клиента. Платёж сначала создаётся черновиком, затем проводится — в этот момент деньги поступают в кассу и задолженность закрывается.',
  'payment.new': 'Новый платёж',
  'payment.docNo': 'Номер',
  'payment.date': 'Дата',
  'payment.customer': 'Клиент',
  'payment.amount': 'Сумма',
  'payment.currency': 'Валюта',
  'payment.amountBase': 'В USD',
  'payment.methodLabel': 'Способ',
  'payment.statusLabel': 'Статус',
  'payment.reference': 'Номер документа / примечание',
  'payment.cashAccount': 'Касса / банковский счёт',
  'payment.notes': 'Примечание',
  'payment.status.draft': 'Черновик',
  'payment.status.posted': 'Проведён',
  'payment.status.cancelled': 'Отменён',
  'payment.method.cash': 'Наличные',
  'payment.method.bank_transfer': 'Банковский перевод',
  'payment.method.card': 'Карта',
  'payment.method.other': 'Другое',
  'payment.filterSearch': 'Поиск',
  'payment.filterSearchHint': 'Номер платежа или клиент',
  'payment.filterStatus': 'Статус',
  'payment.filterStatusAll': 'Все',
  'payment.filterFrom': 'Дата с',
  'payment.filterTo': 'Дата по',
  'payment.filterUnallocated': 'Только неразнесённые (аванс)',
  'payment.empty': 'Платежи не найдены',
  'payment.emptyHint': 'Измените фильтр или введите новый платёж.',
  'payment.emptyHintReadOnly': 'Измените фильтр. Платёж вводит финансист — вам виден ФАКТ платежа.',
  'payment.post': 'Провести',
  'payment.allocate': 'Разнести по задолженности',
  'payment.autoAllocate': 'Разносить по задолженности автоматически',
  'payment.autoAllocateHint': 'Закрытие начинается с самого раннего срока оплаты. Если отключить, деньги останутся авансом и разносятся вручную позже.',
  'payment.chainTitle': 'Цепочка расчёта',
  'payment.chainReceived': 'Поступившая сумма',
  'payment.chainRate': 'Курс',
  'payment.chainRateHint': 'Зафиксирован в документе — далее не меняется',
  'payment.chainBase': 'Эквивалент в USD',
  'payment.chainBaseHint': 'На эту сумму уменьшится задолженность',
  'payment.chainRemaining': 'Остаток задолженности клиента',
  'payment.chainWhyFx': 'Задолженность в USD, а платёж поступил в другой валюте. Сумма пересчитана в USD по курсу на день платежа, и результат не совпал с задолженностью точно — разница остаётся задолженностью. Клиент мог заплатить согласованную сумму полностью: дело в курсе, а не в платеже.',
  'payment.chainWhyPartial': 'Платёж не закрыл задолженность полностью — остаток закроется следующим платежом.',
  'payment.unallocatedNote': 'Неразнесённая часть: {amount}. Это аванс клиента — деньги поступили, но пока не отнесены ни к одному счёту-фактуре.',
  'payment.allocations': 'Разнесение по задолженности',
  'payment.allocationsHint': 'Какой счёт-фактуру и на какую сумму закрыл этот платёж. Колонки «до» и «после» читаются вместе: разница — закрытая часть, «после» — остаток задолженности.',
  'payment.notPostedYet': 'Платёж ещё не проведён — задолженность не закрыта.',
  'payment.noAllocations': 'Не отнесён ни к одному счёту-фактуре (аванс).',
  'payment.allocInvoice': 'Счёт-фактура',
  'payment.allocDueDate': 'Срок',
  'payment.allocAmount': 'Закрыто',
  'payment.allocAmountBase': 'Закрыто (USD)',
  'payment.allocBefore': 'Задолженность — до',
  'payment.allocAfter': 'Задолженность — после',
  'payment.allocFx': 'Курсовая разница',
  'payment.writtenOff': 'Остаток {amount} закрыт как курсовая разница — сумма ниже порога и не взыскивается.',
  'payment.allocFxHint': 'Ноль не означает «разницы нет»: если у клиента курсовая политика «день платежа», разница отдельно не отражается и остаётся в остатке.',
  'payment.formTitle': 'Новый платёж',
  'payment.formHint': 'Платёж создаётся ЧЕРНОВИКОМ: деньги ещё не поступают в кассу и задолженность не закрывается. Второй шаг — «Провести».',
  'payment.formSubmit': 'Создать черновик',
  'payment.manualRate': 'Курс вручную',
  'payment.manualRatePlaceholder': 'курс дня',
  'payment.manualRateHint': 'Если оставить поле пустым, используется курс дня. Если реальный курс банка отличается от курса дня, укажите именно курс банка — деньги поступили по нему. Курс фиксируется в документе и далее не меняется.',

  'payment.reverseAction': 'Сторнировать',
  'payment.reverseTitle': 'Сторнирование {docNo}',
  'payment.reverseHint':
    'Платёж НЕ удаляется — создаётся обратная (сторно) запись, и обе остаются в истории. Деньги возвращаются в кассу, остатки закрытых счетов восстанавливаются, а в учёт записывается зеркало исходной проводки.',
  'payment.reverseReason': 'Причина сторнирования',
  'payment.reverseReasonPlaceholder': 'Например: выбран не тот клиент; банковский перевод вернулся',
  'payment.reverseReasonHint':
    'Напишите, что именно пошло не так — минимум {min} символов. Через месяц ответ «ошибка» ничего не объяснит; причина остаётся в аудите.',
  'payment.reverseSubmit': 'Да, сторнировать',
  'payment.reverseDone': 'Сторнировано',
  'payment.reverseDoneHint':
    '{docNo} отменён, вместо него создана сторно-запись. Исходный документ остаётся в истории — вчерашний кассовый отчёт сегодня читается так же.',
  'payment.reverseReturned': 'Вернулось в кассу',
  'payment.reverseCashAfter': 'Остаток кассы',
  'payment.reverseRestoredCount': 'Восстановлено документов',
  'payment.reverseRestoredDoc': 'Документ',
  'payment.reverseRestoredAmount': 'Остаток восстановлен',

  'supplierPay.title': 'Оплата поставщику — кому мы должны',
  'supplierPay.description':
    'Сколько мы должны заводу и как это оплачивается. Деньги на этом экране УХОДЯТ из компании: списываются с кассы или банковского счёта и закрывают инвойсы поставщика. Нажмите на строку — откроются открытые инвойсы этого завода.',
  'supplierPay.tileOutstanding': 'Всего открытый долг',
  'supplierPay.tileOutstandingHint': 'По {count} поставщикам, в USD',
  'supplierPay.tileOverdue': 'Просрочено',
  'supplierPay.tileOverdueHint': 'Сумма, которую нужно оплатить сегодня',
  'supplierPay.tileAdvance': 'Открытые авансы',
  'supplierPay.tileAdvanceHint': 'Оплачено, но ещё не привязано к инвойсу',
  'supplierPay.tileInvoices': 'Открытые инвойсы',
  'supplierPay.tileInvoicesHint': 'На {asOf}',
  'supplierPay.filterSearch': 'Поиск',
  'supplierPay.filterSearchHint': 'Номер инвойса или название завода',
  'supplierPay.filterOverdue': 'Только просроченные',
  'supplierPay.colCode': 'Код',
  'supplierPay.colSupplier': 'Поставщик',
  'supplierPay.colOutstanding': 'Открытый долг',
  'supplierPay.colOverdue': 'Просрочено',
  'supplierPay.colAdvance': 'Аванс',
  'supplierPay.colOldestDue': 'Самый ранний срок',
  'supplierPay.colInvoiceCount': 'Инвойсы',
  'supplierPay.empty': 'Все инвойсы закрыты',
  'supplierPay.emptyHint':
    'Ни у одного поставщика нет открытого долга. Новый инвойс появится здесь, как только его примут в разделе закупок.',
  'supplierPay.emptyFiltered': 'Долгов по фильтру не найдено',
  'supplierPay.emptyFilteredHint':
    'Измените поиск или фильтр «только просроченные» — долг есть, просто он не попал в этот срез.',
  'supplierPay.noInvoices': 'Открытых инвойсов нет',
  'supplierPay.noInvoicesHint':
    'Этому заводу уже платили, а инвойс ещё не пришёл — значит деньги лежат АВАНСОМ. В импортном цикле это норма: депозит 30% платится до инвойса.',
  'supplierPay.invoices': 'Открытые инвойсы',
  'supplierPay.invoicesHint':
    'Начиная с самого раннего срока. Автоматическая привязка идёт в том же порядке — инвойсы без срока в конце.',
  'supplierPay.invDoc': 'Инвойс',
  'supplierPay.invDate': 'Дата',
  'supplierPay.invDue': 'Срок',
  'supplierPay.invTotal': 'Сумма',
  'supplierPay.invPaid': 'Оплачено',
  'supplierPay.invBalance': 'Остаток',
  'supplierPay.invBalanceBase': 'Остаток (USD)',
  'supplierPay.invOverdue': 'просрочка {days} дн.',
  'supplierPay.invNoDue': 'без срока',
  'supplierPay.pay': 'Оплатить',
  'supplierPay.formTitle': 'Оплата заводу',
  'supplierPay.formHint':
    'Документ вводится ПОСЛЕ того, как банковский перевод выполнен — поэтому черновика здесь нет. На следующем шаге показывается, с какого счёта и сколько уходит, для подтверждения.',
  'supplierPay.account': 'Касса / банковский счёт',
  'supplierPay.accountPick': 'Выберите счёт',
  'supplierPay.amount': 'Сумма',
  'supplierPay.rate': 'Курс банка',
  'supplierPay.rateHint':
    'Реальный курс банка ЗА ТОТ ДЕНЬ, а не курс дня. Деньги списываются с сумового счёта и уходят заводу в другой валюте, то есть конвертация происходит на самом деле, и на крупном переводе разница стоит сотни долларов. Курс фиксируется в документе.',
  'supplierPay.date': 'Дата платежа',
  'supplierPay.method': 'Способ',
  'supplierPay.reference': 'Платёжное поручение',
  'supplierPay.referenceHint': 'Номер SWIFT или поручения',
  'supplierPay.notes': 'Примечание',
  'supplierPay.allocTitle': 'Какие инвойсы закрыть',
  'supplierPay.allocAuto': 'Автоматически — с самого раннего срока',
  'supplierPay.allocAutoHint':
    'Самый старый долг — самый опасный: завод останавливает отгрузку. Инвойсы без срока идут последними.',
  'supplierPay.allocPick': 'Выберу сам',
  'supplierPay.allocPickHint':
    'Укажите конкретный инвойс — например, когда от него зависит выпуск контейнера.',
  'supplierPay.allocAdvance': 'Аванс — не привязывать ни к одному инвойсу',
  'supplierPay.allocAdvanceHint':
    'Случай, когда завод требует депозит до выставления инвойса. Принудительная привязка сделала бы отчёт о долге ложным.',
  'supplierPay.currencyUnsupported':
    'Этот счёт ведётся в {currency}, а такой валюты нет в списке платёжных валют системы. Выберите другой счёт.',
  'supplierPay.insufficient': 'На счёте недостаточно денег',
  'supplierPay.insufficientHint':
    'На счёте «{code}» остаток {balance}, а платёж — {amount}. Сначала пополните счёт (перевод между счетами) или исправьте сумму.',
  'supplierPay.continue': 'Продолжить',
  'supplierPay.confirmTitle': 'Деньги УЙДУТ из кассы — подтвердите',
  'supplierPay.confirmHint':
    'У этого действия нет кнопки отмены: оно сразу меняет остаток кассы, долг заводу и учёт. Проверьте три цифры ниже.',
  'supplierPay.confirmFrom': 'С какого счёта',
  'supplierPay.confirmAmount': 'Сколько уходит',
  'supplierPay.confirmRateHint': 'Фиксируется в документе',
  'supplierPay.confirmBalance': 'Остаток',
  'supplierPay.confirmBalanceHint': 'Сейчас → после платежа',
  'supplierPay.confirmAuto': 'Инвойсы закрываются автоматически, с самого раннего срока.',
  'supplierPay.confirmAdvance':
    'Платёж не привязывается ни к одному инвойсу — он остаётся авансом.',
  'supplierPay.confirmPicked': 'Закрываемые инвойсы: {docs}',
  'supplierPay.confirmSubmit': 'Подтверждаю — деньги уходят',
  'supplierPay.resultDone': 'Платёж записан',
  'supplierPay.resultPaid': 'Оплачено',
  'supplierPay.resultBase': 'Эквивалент в USD',
  'supplierPay.resultAdvance': 'Осталось авансом',
  'supplierPay.resultCash': 'Остаток «{code}»',
  'supplierPay.resultSupplierBalance': 'Остаток долга заводу',
  'supplierPay.allocInvoice': 'Инвойс',
  'supplierPay.allocClosed': 'Закрыто',
  'supplierPay.allocSpent': 'Потрачено',
  'supplierPay.allocBefore': 'Остаток — до',
  'supplierPay.allocAfter': 'Остаток — после',
  'supplierPay.allocFx': 'Курсовая разница',
  'supplierPay.allocFxHint':
    'Плюс — это ПРИБЫЛЬ: обязательства списано больше, чем потрачено денег. На платеже клиента то же равенство означает УБЫТОК.',
  'ar.title': 'Дебиторская задолженность',
  'ar.description': 'Кто сколько должен и за какими счетами-фактурами. Нажмите на строку — откроются открытые счета-фактуры клиента.',
  'ar.code': 'Код',
  'ar.customer': 'Клиент',
  'ar.total': 'Всего задолженность',
  'ar.overdue': 'Просрочено',
  'ar.notDue': 'Срок не наступил',
  'ar.d0_30': '0–30 дней',
  'ar.d31_60': '31–60 дней',
  'ar.d61_90': '61–90 дней',
  'ar.d90plus': '90+ дней',
  'ar.oldestDue': 'Самый ранний срок',
  'ar.invoiceCount': 'Счета-фактуры',
  'ar.invoiceCountShort': 'Документов: {count}',
  'ar.filterOverdue': 'Только просроченные',
  'ar.tileTotal': 'Всего задолженность',
  'ar.tileTotalHint': 'По {count} клиентам',
  'ar.tileOverdue': 'Просрочено',
  'ar.tileOverdueHint': 'Сумма, которую нужно взыскать сегодня',
  'ar.tile90': 'Свыше 90 дней',
  'ar.tile90Hint': 'Это не взыскание, а вероятность потери',
  'ar.empty': 'Клиентов с задолженностью нет',
  'ar.emptyHint': 'Все счета-фактуры закрыты либо фильтр слишком узкий.',
  'ar.blocked': 'Заблокирован',
  'ar.overLimit': 'Лимит превышен',
  'ar.balance': 'Задолженность',
  'ar.advance': 'Аванс (неразнесённый платёж)',
  'ar.net': 'Чистая позиция',
  'ar.netHint': 'Задолженность − аванс. Если значение отрицательное — должны мы клиенту.',
  'ar.creditLimit': 'Кредитный лимит',
  'ar.availableCredit': 'Доступно к отгрузке',
  'ar.overLimitHint': 'Лимит уже превышен — новый заказ требует утверждения.',
  'ar.paymentTerm': 'Срок оплаты',
  'ar.days': '{days} дн.',
  'ar.fxPolicy': 'Курсовая политика',
  'ar.fxPolicyPayment': 'Курс на день платежа',
  'ar.fxPolicySale': 'Курс на день продажи',
  'ar.fxPolicyHint': 'Определяет, по курсу какого дня измеряется задолженность — отсюда и возникает курсовая разница.',
  'ar.buckets': 'Интервалы задолженности',
  'ar.openInvoices': 'Открытые счета-фактуры',
  'ar.openInvoicesHint': 'Начиная с самого раннего срока. Платёж разносится в том же порядке.',
  'ar.noOpenInvoices': 'Открытых счетов-фактур нет',
  'supplierInvoice.title': 'Счета поставщиков',
  'supplierInvoice.description': 'Счёт-фактура, выставленный заводом. При признании обязательство «товар поступил, счёт-фактура не получен» (GRNI) переходит в задолженность перед поставщиком.',
  'supplierInvoice.new': 'Новый счёт',
  'supplierInvoice.save': 'Сохранить как черновик',
  'supplierInvoice.docNo': 'Номер счёта',
  'supplierInvoice.docNoPlaceholder': 'Например: SZ-2026-0417',
  'supplierInvoice.docNoHint': 'Номер присваивает ЗАВОД — система свой не выдаёт. Именно этот номер указывается в банковском переводе и в таможенном документе.',
  'supplierInvoice.supplier': 'Поставщик',
  'supplierInvoice.date': 'Дата счёта',
  'supplierInvoice.dateHint': 'Курс фиксируется НА ЭТУ дату и далее не меняется.',
  'supplierInvoice.dueDate': 'Срок оплаты',
  'supplierInvoice.currency': 'Валюта',
  'supplierInvoice.total': 'Итого (с НДС)',
  'supplierInvoice.totalBase': 'Итого (USD)',
  'supplierInvoice.net': 'Без налога',
  'supplierInvoice.vat': 'НДС',
  'supplierInvoice.vatRate': 'Ставка НДС, %',
  'supplierInvoice.vatRateHint': 'Налог выделяется ИЗ суммы «Итого», а не начисляется сверху. Если оставить пустым — 0%.',
  'supplierInvoice.grossHint': 'В поле «Итого» впишите сумму из нижней части счёта завода — С НДС. Банковский перевод выполняется ровно по этой же цифре.',
  'supplierInvoice.previewHint': 'Предварительный расчёт. Точные цифры документа записывает сервер.',
  'supplierInvoice.purchaseOrder': 'Заказ поставщику',
  'supplierInvoice.receipt': 'Приход',
  'supplierInvoice.receiptHint': 'ОБЯЗАТЕЛЬНО для признания: GRNI закрывается именно по приходу. Если товар ещё не поступил, оставьте документ черновиком.',
  'supplierInvoice.noLink': 'Не связан',
  'supplierInvoice.notes': 'Примечание',
  'supplier.kind': 'Тип контрагента',
  'supplier.kind.goods': 'Завод / товар',
  'supplier.kind.logistics': 'Логистика / экспедитор',
  'supplier.kind.service': 'Услуга',
  'supplier.kindAll': 'Все типы',
  'supplier.kindHint':
    'Тип разделяет отчёты и списки выбора: счёт завода закрывается по приходу, счёт логистики — по контейнеру.',
  'si.kind.factory': 'Счёт завода (по приходу)',
  'si.kind.logistics': 'Счёт логистики (по контейнеру)',
  'si.kindTitle': 'Тип документа',
  'si.kindHint':
    'Эти два вида закрывают РАЗНЫЕ счета в книге, поэтому один документ бывает только одного вида.',
  'si.shipment': 'Контейнер',
  'si.shipmentSelect': 'Выберите контейнер',
  'si.shipmentRequired': 'Для счёта логистики контейнер обязателен',
  'si.costs': 'Покрываемые расходы',
  'si.costsHint': 'Предварительные строки выбрать нельзя — сначала внесите сумму по документу',
  'si.costsEmpty': 'По этому контейнеру нет расходов, которые можно привязать',
  'si.costsSelected': 'Выбрано строк: {count} · {amount}',
  'si.costsRequired': 'Выберите хотя бы одну строку расхода',
  'si.dueFromTerms': 'Срок по договору: {days} дн.',
  'si.dueOverride': 'Другой срок для этого документа',
  'si.dueNoTerms': 'В договоре срок не указан — введите дату вручную',
  'si.error.estimateCost':
    'Предварительный расход не создаёт долг — снимите отметку «предварительный» и пересчитайте себестоимость',
  'si.error.lcNotPosted': 'Себестоимость не проведена — начисленное обязательство ещё не в книге',
  'si.error.costTaken': 'По этому расходу уже признан другой счёт',
  'si.error.shapeConflict': 'Один документ не может закрыть и приход, и контейнер',
  'si.copy': 'Копировать',
  'si.copyHint':
    'Поля копируются из этого документа, а номер и привязанные расходы остаются ПУСТЫМИ — они у каждого документа свои.',
  'si.copied': 'Копия создана — введите номер и сохраните после проверки',
  'si.docsTitle': 'Файлы документа',
  'si.docsHint':
    'Счёт экспедитора, коносамент и таможенные бумаги загружаются в карточку КОНТЕЙНЕРА — счёт привязан к этому контейнеру.',
  'si.docsOpen': 'Открыть карточку контейнера',
  'ap.logistics': 'Учёт логистики',
  'ap.kindNeedsSupplierView': 'Для разделения по типу нужно право просмотра данных контрагента.',
  'supplierInvoice.statusLabel': 'Статус',
  'supplierInvoice.status.draft': 'Черновик',
  'supplierInvoice.status.received': 'Признан',
  'supplierInvoice.status.cancelled': 'Отменён',
  'supplierInvoice.receive': 'Признать',
  'supplierInvoice.cancel': 'Отменить',
  'supplierInvoice.cancelPrompt': 'Причина отмены (минимум 3 символа):',
  'supplierInvoice.filterStatus': 'Статус',
  'supplierInvoice.filterStatusAll': 'Все',
  'supplierInvoice.empty': 'Счетов поставщиков нет',
  'supplierInvoice.emptyHint': 'Когда поступит счёт завода, введите его здесь. До признания в учёт ничего не записывается.',
  'ap.title': 'Кредиторская задолженность',
  'ap.description': 'Сколько мы должны заводам и какие авансы висят. Аванс — деньги, которые ушли, но пока не превратились в товар.',
  'ap.code': 'Код',
  'ap.supplier': 'Поставщик',
  'ap.currency': 'Валюта',
  'ap.openPoCount': 'Открытые заказы',
  'ap.ordered': 'Заказано',
  'ap.paid': 'Оплачено',
  'ap.outstanding': 'Задолженность (по заказам)',
  'ap.invoiceOpen': 'Задолженность (по счетам)',
  'ap.notDue': 'Срок не наступил',
  'ap.d0_30': '0–30 дней',
  'ap.d31_60': '31–60 дней',
  'ap.d61_90': '61–90 дней',
  'ap.d90plus': '90+ дней',
  'ap.oldestDue': 'Самый ранний срок',
  'ap.openInvoiceCount': 'Открытые счета',
  'ap.advance': 'Открытый аванс',
  'ap.advanceAge': 'Возраст аванса',
  'ap.oldestAdvance': 'Самый старый аванс',
  'ap.nearestExpected': 'Ближайшее ожидаемое поступление',
  'ap.paymentTerm': 'Условия оплаты',
  'ap.days': '{days} дн.',
  'ap.filterAdvances': 'Только с авансами',
  'ap.tileOutstanding': 'Всего задолженность',
  'ap.tileOutstandingHint': 'По {count} поставщикам',
  'ap.tileInvoiceOpen': 'Задолженность по счетам',
  'ap.tileInvoiceOpenHint': 'Неоплаченная часть счетов, выставленных заводом и признанных нами. Определение то же, что и у счёта учёта «Задолженность перед поставщиком».',
  'ap.tileOverdue': 'Просрочено',
  'ap.tileOverdueHint': 'Счета с наступившим и прошедшим сроком оплаты. Так как платёж не привязан к конкретному счёту, погашение идёт начиная с самого раннего счёта.',
  'ap.tileAdvance': 'Открытый аванс',
  'ap.tileAdvanceHint': 'Деньги оплачены, но пока не превратились в товар',
  'ap.tileStale': 'Авансы, висящие дольше {days} дн.',
  'ap.tileStaleHint': 'Импортный цикл завершён, а аванс не закрыт — требуется проверка',
  'ap.empty': 'Открытой задолженности и авансов нет',
  'ap.emptyHint': 'Все заказы поставщикам закрыты либо открытые заказы ещё не созданы.',
  'fxRates.description': 'Курс дня вводится один раз в сутки и отображается в верхней части программы. Продажа в USD, касса в сумах, закупка в юанях — если курс неверный, все документы этого дня будут посчитаны неверно.',
  'fxRates.frozenTitle': 'Изменение курса НЕ ЗАТРАГИВАЕТ старые документы',
  'fxRates.frozenBody': 'При создании документа курс записывается в него и фиксируется. Если изменить курс здесь, по новому курсу будут посчитаны только ПОСЛЕДУЮЩИЕ документы — вчерашние счета-фактуры, платежи и прибыль закрытого периода не пересчитываются.',
  'fxRates.uzsLabel': '1 USD = ? сум',
  'fxRates.cnyLabel': '1 USD = ? ¥',
  'fxRates.missing': 'Курс вообще не введён',
  'fxRates.stale': 'Не сегодняшний',
  'fxRates.locked': 'День закрыт',
  'fxRates.formTitle': 'Ввод курса',
  'fxRates.currency': 'Валюта',
  'fxRates.rate': 'Курс',
  'fxRates.uzsPlaceholder': '12900',
  'fxRates.cnyPlaceholder': '7.25',
  'fxRates.rateDate': 'На какую дату',
  'fxRates.saved': '{currency}: {rate} — сохранён на {date}',
  'fxRates.formHint': 'Каждая валюта сохраняется отдельно. Курс закрытого дня изменить нельзя. Изменение записывается в журнал аудита: кто и когда изменил, должно быть прослеживаемо.',
  'fxRates.historyTitle': 'История курса',
  'fxRates.historyCurrency': 'Выбор валюты',
  'fxRates.historySource': 'История строится ИЗ ЖУРНАЛА АУДИТА: по каждому дню показывается последний курс этого дня, а правки внутри дня — в полном журнале.',
  'fxRates.historyNoPermission': 'История курса берётся из журнала аудита и требует отдельного права доступа (просмотр журнала аудита). У вас этого права нет, поэтому история не отображается — это не означает, что истории нет.',
  'fxRates.historyEmpty': 'В журнале не найдено изменений курса по этой валюте.',
  'fxRates.chartLabel': 'Динамика курса {currency} по дням',
  'fxRates.chartHint': 'Столбцы отсчитываются от нуля — поэтому изменение в несколько процентов почти незаметно. Точная разница — в колонке «Изменение» ниже; при наведении курсора на столбец показывается курс этого дня.',
  'fxRates.change': 'Изменение',
  'fxRates.actor': 'Кто',
  'fxRates.changedAt': 'Когда',
  'fxRates.openAudit': 'Открыть полный журнал',
  'error.403': 'У вас нет права доступа на это действие',
  'error.404': 'Не найдено',
  'error.500': 'Ошибка сервера',
  'error.pageNotFound': 'Такой страницы нет',
  'error.screenFailed': 'Не удалось открыть экран',
  'error.screenFailedHint': 'Возможно, оборвалась сеть или программа была обновлена. Попробуйте ещё раз, а если не поможет — перезагрузите страницу.',
  'nav.group.accounting': 'Бухгалтерия',
  'nav.accJournals': 'Проводки',
  'nav.accPeriods': 'Периоды',
  'nav.accAccounts': 'План счетов',
  'nav.accIncomeStatement': 'Прибыли и убытки',
  'nav.accBalanceSheet': 'Баланс',
  'nav.accEquity': 'Собственный капитал',
  'acc.account.account': 'Счёт',
  'acc.account.code': 'Код',
  'acc.account.name': 'Наименование',
  'acc.account.type': 'Тип',
  'acc.account.roles': 'Роли',
  'acc.account.contra': 'контрсчёт',
  'acc.account.group': 'групповой',
  'acc.account.inactive': 'неактивный',
  'acc.account.debitSide': 'дебетовое сальдо',
  'acc.account.creditSide': 'кредитовое сальдо',
  'acc.type.asset': 'Актив',
  'acc.type.liability': 'Обязательство',
  'acc.type.equity': 'Капитал',
  'acc.type.income': 'Доход',
  'acc.type.expense': 'Расход',
  'acc.pnl.title': 'Прибыли и убытки',
  'acc.pnl.description': 'Отчёт, формируемый из учётных данных: от выручки до чистой прибыли. Каждая строка приводится с текущим периодом, ПРЕДЫДУЩИМ периодом и разницей — один период сам по себе ничего не означает.',
  'acc.pnl.line': 'Показатель',
  'acc.pnl.current': 'Текущий период',
  'acc.pnl.previous': 'Предыдущий период',
  'acc.pnl.previousShort': 'предыдущий:',
  'acc.pnl.previousValue': 'предыдущий: {value}',
  'acc.pnl.delta': 'Разница',
  'acc.pnl.trend': 'Динамика',
  'acc.pnl.vsPrevious': 'по отношению к предыдущему периоду',
  'acc.pnl.comparedWith': 'Сравниваемый период: {from} — {to}',
  'acc.pnl.expenseMix': 'Структура операционных расходов',
  'acc.pnl.revenue': 'Выручка',
  'acc.pnl.returns': 'Возвраты',
  'acc.pnl.discounts': 'Предоставленные скидки',
  'acc.pnl.netRevenue': 'Чистая выручка',
  'acc.pnl.cogs': 'Себестоимость проданных товаров',
  'acc.pnl.grossProfit': 'ВАЛОВАЯ ПРИБЫЛЬ',
  'acc.pnl.operatingExpense': 'Операционные расходы',
  'acc.pnl.operatingProfit': 'ОПЕРАЦИОННАЯ ПРИБЫЛЬ',
  'acc.pnl.fxResult': 'Курсовая разница (прибыль − убыток)',
  'acc.pnl.otherResult': 'Прочие доходы',
  'acc.pnl.netProfit': 'ЧИСТАЯ ПРИБЫЛЬ',
  'acc.pnl.checkFailed': 'Отчёт не сошёлся с учётными данными',
  'acc.pnl.checkFailedDetail': 'Чистая прибыль в отчёте {statement}, а по учёту (доходы − расходы) {ledger}. Разница: {difference}. Это означает, что какой-то счёт не попал в группу отчёта.',
  'acc.bs.title': 'Баланс',
  'acc.bs.description': 'Состояние на определённую дату: активы, обязательства и капитал. Равенство проверяется, а его результат показывается явно.',
  'acc.bs.equation': 'АКТИВЫ = ОБЯЗАТЕЛЬСТВА + КАПИТАЛ',
  'acc.bs.balanced': 'Равенство выполнено',
  'acc.bs.notBalanced': 'РАВЕНСТВО НАРУШЕНО',
  'acc.bs.differenceIs': 'Разница: {value}.',
  'acc.bs.section': 'Раздел',
  'acc.bs.amount': 'Сумма',
  'acc.bs.assets': 'АКТИВЫ',
  'acc.bs.liabilities': 'ОБЯЗАТЕЛЬСТВА',
  'acc.bs.equity': 'КАПИТАЛ',
  'acc.bs.totalAssets': 'Итого активы',
  'acc.bs.totalLiabilities': 'Итого обязательства',
  'acc.bs.totalEquity': 'Итого капитал',
  'acc.bs.unclosedResult': 'Результат текущего года (не закрыт)',
  'acc.bs.unclosedHint': 'Доходы {income} − расходы {expense}. После закрытия года эта строка обнулится, а сумма перейдёт в «Нераспределённую прибыль».',
  'acc.equity.title': 'Движение собственного капитала',
  'acc.equity.description': 'Путь от начального капитала к конечному: результат периода, вклады и изъятия.',
  'acc.equity.line': 'Показатель',
  'acc.equity.amount': 'Сумма',
  'acc.equity.opening': 'Собственный капитал на начало',
  'acc.equity.closing': 'Собственный капитал на конец',
  'acc.equity.ofAccounts': 'в том числе: счета капитала',
  'acc.equity.ofUnclosed': 'в том числе: незакрытый результат',
  'acc.equity.periodResult': 'Результат текущего периода (прибыль / убыток)',
  'acc.equity.contributions': 'Дополнительные вклады',
  'acc.equity.withdrawals': 'Изъятия',
  'acc.equity.otherEquity': 'Прочее движение по счетам капитала',
  'acc.equity.checkFailed': 'Отчёт о капитале не сошёлся',
  'acc.equity.checkFailedDetail': 'Ожидаемое конечное значение {expected}, фактическое {actual}.',
  'acc.equity.profitCheckFailed': 'Результат периода не сошёлся с отчётом «Прибыли и убытки»',
  'acc.equity.profitCheckDetail': 'Результат в отчёте о капитале {equity}, чистая прибыль в отчёте о прибылях и убытках {pnl}. Оба показателя формируются из одних и тех же проводок — если есть разница, значит ошибка в разметке.',
  'acc.accounts.title': 'План счетов',
  'acc.accounts.description': 'Дерево бухгалтерских счетов и их привязка к семантическим ролям. Код никогда не знает номер счёта — он знает только РОЛЬ, а роль привязывается к счёту здесь.',
  'acc.accounts.chart': 'Дерево счетов',
  'acc.accounts.chartHint': 'На групповой счёт проводки не пишутся — он лишь суммирует дочерние.',
  'acc.mapping.title': 'Привязка «роль → счёт»',
  'acc.mapping.hint': 'Каждая роль привязывается РОВНО к одному счёту. С непривязанной ролью проводку записать нельзя, и событие остаётся в очереди.',
  'acc.mapping.role': 'Роль',
  'acc.mapping.expectedType': 'Ожидаемый тип',
  'acc.mapping.entityScoped': 'в разрезе юридического лица',
  'acc.mapping.typeMismatch': 'фактический тип: {actual}',
  'acc.mapping.unmappedTitle': 'Непривязанных ролей: {count}',
  'acc.mapping.unmappedHint': 'События по этим ролям НЕ ПРЕВРАТЯТСЯ в проводки — они останутся в очереди, и период закрыть не удастся. Привяжите роль к счёту.',
  'acc.periods.title': 'Учётные периоды',
  'acc.periods.description': 'После закрытия месяца записать в него проводку нельзя. Перед закрытием выполняется контрольный список: непроведённые черновики, несбалансированные проводки и события в очереди.',
  'acc.periods.list': 'Периоды {year} года',
  'acc.periods.period': 'Период',
  'acc.periods.status': 'Статус',
  'acc.periods.journals': 'Проводки',
  'acc.periods.drafts': 'Черновики',
  'acc.periods.closedAt': 'Закрыт',
  'acc.periods.select': 'Выбрать',
  'acc.periods.selectHint': 'Выберите период, чтобы увидеть контрольный список.',
  'acc.periods.statusOpen': 'открыт',
  'acc.periods.statusClosed': 'закрыт',
  'acc.periods.statusLocked': 'заблокирован',
  'acc.periods.checklistTitle': '{period} — проверка перед закрытием',
  'acc.periods.checklistHint': 'Пока препятствия не устранены, период не закроется. Предупреждения оператор может осознанно пропустить.',
  'acc.periods.checklistClean': 'Ни препятствий, ни предупреждений — период можно закрывать.',
  'acc.periods.blocker': 'Препятствие',
  'acc.periods.warning': 'Предупреждение',
  'acc.periods.totals': 'Обороты периода:',
  'acc.periods.debit': 'дебет',
  'acc.periods.credit': 'кредит',
  'acc.periods.balanced': 'сходится',
  'acc.periods.notBalanced': 'НЕ СХОДИТСЯ, разница {value}',
  'acc.periods.closeAction': 'Закрыть период',
  'acc.periods.noClosePermission': 'У вас нет права закрывать период — просмотр списка доступен. Если период нужно закрыть, обратитесь к главному бухгалтеру.',
  'acc.yearClose.title': 'Закрытие {year} года',
  'acc.yearClose.description': 'Счета доходов и расходов обнуляются, результат переносится в «Нераспределённую прибыль». Действие НЕОБРАТИМО — сначала выполните пробный запуск.',
  'acc.yearClose.dryRun': 'Пробный запуск (без записи)',
  'acc.yearClose.commit': 'РЕАЛЬНОЕ закрытие — записать проводку',
  'acc.yearClose.dryRunTitle': 'Пробный запуск — ничего не записано',
  'acc.yearClose.doneTitle': 'Год закрыт — проводки записаны в учёт',
  'acc.yearClose.income': 'Итого доходы',
  'acc.yearClose.expense': 'Итого расходы',
  'acc.yearClose.profit': 'Прибыль',
  'acc.yearClose.loss': 'Убыток',
  'acc.yearClose.notBalanced': 'НЕ СХОДИТСЯ',
  'acc.journal.title': 'Проводки',
  'acc.journal.cardTitle': 'Проводка',
  'acc.journal.description': 'Каждый документ попадает в учёт дебетом и кредитом.',
  'acc.journal.about': 'Об этой странице',
  'acc.journal.aboutBody': 'Проведённая проводка не изменяется и не удаляется. При ошибке вместо неё записывается сторнирующая проводка, и обе записи остаются в учёте — поэтому отчёт можно пересобрать на любую дату. Нажмите на номер в списке, чтобы открыть строки проводки и документ-источник.',
  'acc.journal.docNo': 'Номер',
  'acc.journal.entryDate': 'Дата события',
  'acc.journal.postingDate': 'Дата проводки',
  'acc.journal.period': 'Период',
  'acc.journal.status': 'Статус',
  'acc.journal.statusAll': 'Все',
  'acc.journal.statusDraft': 'Черновик',
  'acc.journal.statusPosted': 'Проведена',
  'acc.journal.statusReversed': 'Сторнирована',
  'acc.journal.descriptionField': 'Описание',
  'acc.journal.source': 'Источник',
  'acc.journal.sourceDoc': 'Документ №{id}',
  'acc.journal.sourceUnknown': 'Другое событие',
  'acc.src.inventory.receipt': 'Приход на склад',
  'acc.src.inventory.issue': 'Расход со склада',
  'acc.src.inventory.transfer': 'Перемещение между складами',
  'acc.src.inventory.revaluation': 'Переоценка склада',
  'acc.src.inventory.count': 'Инвентаризация',
  'acc.src.inventory.giveaway': 'Образцы и витрина',
  'acc.src.inventory.return': 'Возврат товара',
  'acc.src.invoice.issued': 'Счёт-фактура',
  'acc.src.credit_note.issued': 'Кредит-нота',
  'acc.src.payment.received': 'Оплата от клиента',
  'acc.src.payment.supplier': 'Оплата поставщику',
  'acc.src.supplier_advance.applied': 'Аванс поставщику зачтён',
  'acc.src.purchase.invoice_received': 'Счёт-фактура поставщика',
  'acc.src.landed_cost.cogs_variance': 'Разница в себестоимости',
  'acc.src.fx.revaluation': 'Переоценка по курсу',
  'acc.src.expense.posted': 'Расход',
  'acc.src.bonus.accrual': 'Бонус начислен',
  'acc.src.bonus.payout': 'Бонус выплачен',
  'acc.src.charity.accrued': 'Благотворительность начислена',
  'acc.src.charity.paid': 'Благотворительность выплачена',
  'acc.src.employee.advance': 'Аванс сотруднику',
  'acc.src.employee.debt': 'Долг сотрудника',
  'acc.src.employee.debt.writeoff': 'Долг сотрудника списан',
  'acc.src.payroll.accrued': 'Зарплата начислена',
  'acc.src.payroll.paid': 'Зарплата выплачена',
  'acc.journal.eventCode': 'Код события',
  'acc.journal.manual': 'вручную',
  'acc.journal.amount': 'Сумма',
  'acc.journal.total': 'Итого',
  'acc.journal.postedAt': 'Дата проведения',
  'acc.journal.lines': 'Строки проводки',
  'acc.journal.debit': 'Дебет',
  'acc.journal.credit': 'Кредит',
  'acc.journal.docCurrency': 'Валюта документа / курс',
  'acc.journal.lineNote': 'Примечание',
  'acc.journal.filterStatus': 'По статусу:',
  'acc.journal.filterAccount': 'Счёт #{id}',
  'acc.journal.backToList': 'К списку проводок',
  'acc.journal.empty': 'Проводки не найдены',
  'acc.journal.emptyHint': 'Расширьте фильтр или выберите другой период.',
  'acc.journal.reversedTitle': 'Эта проводка сторнирована',
  'acc.journal.reversedHint': 'Запись ОСТАЁТСЯ в учёте и попадает в отчёты — сторнирующая проводка обнуляет её.',
  'nav.documentsExpiring': 'Документы с истекающим сроком',
  'doc.panel.title': 'Документы',
  'doc.panel.hint': 'Файл прикрепляется к этому объекту и ищется отсюда же. Если один и тот же файл загрузить дважды — дубликат не создаётся, возвращается существующий.',
  'doc.empty': 'Документов нет',
  'doc.emptyHint': 'Перетащите файл сюда или нажмите кнопку «Выбрать файл».',
  'doc.loadError': 'Не удалось загрузить документы',
  'doc.upload': 'Выбрать файл',
  'doc.uploading': 'Загрузка…',
  'doc.dropHere': 'Перетащите файл сюда',
  'doc.dropHint': 'Разрешённые типы: изображения (JPG, PNG, WEBP), PDF, Word, Excel, PowerPoint, CSV. Максимальный размер — 25 МБ.',
  'doc.uploaded': '«{fileName}» загружен',
  'doc.duplicateNotice': '«{fileName}» уже был здесь — дубликат не создан. Это не ошибка: один и тот же файл нередко загружают два сотрудника из двух источников.',
  'doc.kind': 'Тип',
  'doc.kind.invoice': 'Инвойс',
  'doc.kind.packing_list': 'Упаковочный лист',
  'doc.kind.customs': 'Таможенный документ',
  'doc.kind.contract': 'Договор',
  'doc.kind.certificate': 'Сертификат',
  'doc.kind.photo': 'Фото',
  'doc.kind.act': 'Акт',
  'doc.kind.other': 'Прочее',
  'doc.fileName': 'Файл',
  'doc.size': 'Размер',
  'doc.uploadedAt': 'Загружен',
  'doc.uploadedBy': 'Кем загружен',
  'doc.expiresOn': 'Срок действия',
  'doc.expiresOnHint': 'Для сертификатов и договоров. С просроченным сертификатом таможню не пройти — система напомнит заранее, когда срок будет подходить к концу.',
  'doc.titleField': 'Заголовок',
  'doc.titlePlaceholder': 'Необязательно — если пусто, показывается имя файла',
  'doc.download': 'Скачать',
  'doc.replace': 'Новая версия',
  'doc.replaceHint': 'Старая копия НЕ УДАЛЯЕТСЯ — она уходит в архив и остаётся на месте: полная себестоимость могла быть рассчитана по тем старым цифрам.',
  'doc.archive': 'В архив',
  'doc.archiveConfirm': 'Документ уйдёт в архив. Файл не удаляется, и его можно открыть из архива. Продолжить?',
  'doc.archived': 'В архиве',
  'doc.showArchived': 'Показывать и архив',
  'doc.replacesLine': 'Новая версия документа #{id}',
  'doc.preview': 'Просмотр',
  'doc.previewFailed': 'Не удалось открыть предпросмотр',
  'doc.entity.shipments': 'Контейнер',
  'doc.entity.purchase_orders': 'Заказ поставщику',
  'doc.entity.goods_receipts': 'Приход товара',
  'doc.entity.sales_returns': 'Возврат',
  'doc.entity.sales_return_lines': 'Строка возврата',
  'doc.entity.sales_orders': 'Заказ покупателя',
  'doc.entity.invoices': 'Счёт-фактура',
  'doc.entity.payments': 'Платёж',
  'doc.entity.customers': 'Клиент',
  'doc.entity.suppliers': 'Поставщик',
  'doc.entity.products': 'Товар',
  'doc.entity.users': 'Сотрудник',
  'doc.entity.stock_counts': 'Инвентаризация',
  'doc.entity.deliveries': 'Доставка',
  'doc.expiring.title': 'Документы с истекающим сроком',
  'doc.expiring.description': 'Сертификаты и договоры по сроку действия. С просроченным сертификатом таможню не пройти, и контейнер встанет в порту — демередж считается посуточно.',
  'doc.expiring.window': 'Окно',
  'doc.expiring.windowDays': '{days} дн.',
  'doc.expiring.daysLeft': 'Осталось',
  'doc.expiring.left': '{days} дн.',
  'doc.expiring.today': 'Истекает сегодня',
  'doc.expiring.overdue': 'Истёк {days} дн. назад',
  'doc.expiring.entity': 'Относится к',
  'doc.expiring.empty': 'Документов с истекающим сроком нет',
  'doc.expiring.emptyHint': 'Расширьте окно или укажите в документах срок действия — документ без срока в этот список не попадает.',
  'nav.approvals': 'Моя очередь',
  'nav.approvalRules': 'Правила утверждения',
  'nav.delegations': 'Делегирование',
  'appr.queueDescription': 'Документы, ожидающие вашей подписи. В список попадают только подписи, назначенные вам или вашей роли либо делегированные вам, — чужая очередь здесь не видна.',
  'appr.loadError': 'Не удалось получить данные по утверждениям',
  'appr.empty': 'Подписей от вас не ожидается',
  'appr.metric.pending': 'Ожидает',
  'appr.metric.pendingHint': 'документов ждут вашей подписи',
  'appr.metric.overdue': 'Просрочено',
  'appr.metric.overdueHint': 'срок эскалации истёк',
  'appr.metric.oldest': 'Дольше всех ждёт',
  'appr.metric.oldestHint': 'с начала этапа',
  'appr.metric.topAmount': 'Наибольшая сумма',
  'appr.metric.topAmountHint': 'самый дорогой документ в очереди',
  'appr.col.document': 'Документ',
  'appr.col.amount': 'Сумма',
  'appr.col.waitingOn': 'От кого ждём',
  'appr.col.waitingTime': 'Сколько ждёт',
  'appr.col.stage': 'Этап',
  'appr.hours': '{hours} ч',
  'appr.stageOf': '{stage} / {total}',
  'appr.stageShort': 'Этап {stage}',
  'appr.roleTarget': '{role} (роль)',
  'appr.onBehalfOf': 'От имени {name}',
  'appr.escalated': 'Эскалация',
  'appr.discountOf': 'скидка {pct}%',
  'appr.waiting': 'ожидает',
  'appr.notYet': 'очередь не наступила',
  'appr.approve': 'Утвердить',
  'appr.reject': 'Отклонить',
  'appr.rejectConfirm': 'Подтвердите отклонение',
  'appr.rejectReason': 'Причина отклонения',
  'appr.rejectReasonHint': 'Напишите, что нужно исправить — причина уйдёт автору документа',
  'appr.raceLost': 'Эту подпись уже поставил кто-то раньше вас. Список обновлён — проверьте ещё раз.',
  'appr.docType.purchaseOrder': 'Заказ поставщику',
  'appr.docType.salesDiscount': 'Скидка по продаже',
  'appr.state.pending': 'Ожидает подписи',
  'appr.state.approved': 'Утверждён',
  'appr.state.rejected': 'Отклонён',
  'appr.state.notRequired': 'Утверждение не требуется',
  'appr.panelTitle': 'Утверждение',
  'appr.panelSubtitle': '{amount} · автор документа: {author}',
  'appr.historyTitle': 'История подписей',
  'appr.act.approved': 'Утвердил',
  'appr.act.rejected': 'Отклонил',
  'appr.rulesDescription': 'Чья подпись и при каком условии нужна для каждого документа. Если правил нет, утверждение не требуется и документы проходят как сейчас.',
  'appr.rule.code': 'Код',
  'appr.rule.name': 'Название',
  'appr.rule.docType': 'Тип документа',
  'appr.rule.condition': 'Условие',
  'appr.rule.steps': 'Этапы',
  'appr.rule.fourEyes': 'Четыре глаза',
  'appr.rule.status': 'Статус',
  'appr.rule.active': 'Активно',
  'appr.rule.inactive': 'Отключено',
  'appr.rule.enable': 'Включить',
  'appr.rule.disable': 'Отключить',
  'appr.rule.enabled': 'Правило «{code}» включено',
  'appr.rule.disabled': 'Правило «{code}» отключено',
  'appr.rule.empty': 'Правил нет — утверждение сейчас не требуется, и документы проходят в обычном порядке.',
  'appr.rule.new': 'Новое правило',
  'appr.rule.editTitle': 'Редактирование правила «{code}»',
  'appr.rule.saved': 'Правило «{code}» сохранено',
  'appr.rule.create': 'Создать правило',
  'appr.rule.created': 'Правило «{code}» создано',
  'appr.rule.minAmount': 'Сумма (от, USD)',
  'appr.rule.maxAmount': 'Сумма (до, USD)',
  'appr.rule.minDiscount': 'Скидка (от, %)',
  'appr.rule.fromAmount': 'от {amount}',
  'appr.rule.toAmount': 'до {amount}',
  'appr.rule.fromDiscount': 'скидка от {pct}%',
  'appr.rule.noCondition': 'без условий — на все документы',
  'appr.rule.rangeHint': 'Диапазон: нижняя граница ВКЛЮЧАЕТСЯ, верхняя — НЕТ. То есть при диапазонах 0–10 000 и 10 000–∞ сумма $10 000 попадёт только во второй. Пустое поле — условие не задано.',
  'appr.rule.fourEyesLabel': 'Автор документа не может утвердить его сам',
  'appr.rule.fourEyesHint': 'Если подходит несколько правил и ХОТЯ БЫ ОДНО из них ставит это требование, оно применяется — обойти его, добавив более мягкое правило, нельзя.',
  'appr.rule.unionHint': 'Если одному документу соответствует несколько правил — применяются ВСЕ, а не одно из них. Редактирование правила не затрагивает открытую очередь: план фиксируется в момент создания запроса.',
  'appr.rule.addStep': 'Добавить этап',
  'appr.rule.seq': 'Порядок',
  'appr.rule.approver': 'Кто подписывает',
  'appr.rule.escHours': 'Эскалация (часы)',
  'appr.rule.escTarget': 'Эскалация кому',
  'appr.rule.escalateAfter': 'через {hours} ч — {target}',
  'appr.rule.seqHint': 'Одинаковый порядковый номер — параллельно (подписывают оба), разный — последовательно. Если задан срок эскалации, обязательно указать и кому она уходит.',
  'appr.deleg.description': 'Временная передача права подписи другому сотруднику на время отпуска или командировки. Делегирование не отбирает право — оно только добавляет.',
  'appr.deleg.from': 'От чьего имени',
  'appr.deleg.to': 'Кому',
  'appr.deleg.self': 'Я сам',
  'appr.deleg.docType': 'Тип документа',
  'appr.deleg.allDocTypes': 'Все',
  'appr.deleg.period': 'Срок',
  'appr.deleg.validFrom': 'Начало',
  'appr.deleg.validTo': 'Окончание',
  'appr.deleg.reasonHint': 'Отпуск, командировка…',
  'appr.deleg.new': 'Новое делегирование',
  'appr.deleg.create': 'Делегировать',
  'appr.deleg.created': 'Делегирование записано',
  'appr.deleg.empty': 'Делегирований нет',
  'appr.deleg.revoke': 'Отменить',
  'appr.deleg.inclusiveHint': 'Обе границы срока включаются: «до 25 августа» означает, что 25 августа подписать ещё можно.',
  'appr.deleg.noChainHint': 'Цепочка не работает: A → B → C. Делегировать может только исходный владелец права — иначе на вопрос «кто утвердил?» ответить было бы невозможно.',
  'appr.deleg.needUserView': 'Чтобы оформить делегирование, нужно право на просмотр списка сотрудников. Обратитесь к администратору — он может оформить делегирование от вашего имени.',
  'nav.group.pos': 'Касса',
  'nav.directSale': 'Продажа',
  'nav.myCash': 'Моя касса',
  'pos.title': 'Продажа',
  'pos.subtitle': 'Товар → клиент → платёж. Всё на одном экране.',
  'pos.scan.label': 'Код или наименование',
  'pos.scan.placeholder': 'Введите или отсканируйте SKU/штрихкод, ищите по наименованию…',
  'pos.scan.hint': 'При точном совпадении кода строка добавляется СРАЗУ (так работает сканер). По наименованию — выберите из списка.',
  'pos.scan.notFound': 'Такой код не найден',
  'pos.scan.qty': 'Количество',
  'pos.scan.add': 'Добавить',
  'pos.lines.title': 'Строки продажи',
  'pos.lines.product': 'Товар',
  'pos.lines.qty': 'Количество',
  'pos.lines.price': 'Цена',
  'pos.lines.amount': 'Сумма',
  'pos.lines.remove': 'Удалить',
  'pos.lines.empty': 'Строк нет — введите или отсканируйте код товара',
  'pos.lines.priceList':
    'Цена — из прайс-листа компании. При выборе клиента применяются согласованная цена и договорная скидка.',
  'pos.total.title': 'Итог',
  'pos.total.subtotal': 'Всего',
  'pos.total.discount': 'Скидка',
  'pos.total.vat': 'НДС',
  'pos.total.payable': 'К ОПЛАТЕ',
  'pos.total.preview': 'Это ПРЕДВАРИТЕЛЬНЫЙ расчёт. Итоговую сумму считает сервер — цена и НДС фиксируются при проведении документа.',
  'pos.debt.current': 'Долг клиента',
  'pos.debt.overdue': 'Просрочено',
  'pos.debt.blocked': 'Клиент ЗАБЛОКИРОВАН — продажа не пройдёт',
  'pos.debt.loadError': 'Не удалось загрузить долг',
  'pos.customer.title': 'Клиент',
  'pos.customer.required': 'Выберите клиента',
  'pos.customer.new': 'Новый клиент',
  'pos.customer.newTitle': 'Быстрый клиент',
  'pos.customer.name': 'Наименование',
  'pos.customer.phone': 'Телефон',
  'pos.customer.code': 'Код',
  'pos.customer.codeHint': 'Код предложен по номеру телефона — при необходимости измените. Вторая карточка с тем же кодом не создастся.',
  'pos.customer.create': 'Создать',
  'pos.customer.created': 'Клиент создан',
  'pos.pay.title': 'Платёж',
  'pos.pay.cash': 'Наличные',
  'pos.pay.card': 'Карта',
  'pos.pay.transfer': 'Перевод',
  'pos.pay.amount': 'Сумма',
  'pos.pay.full': 'Полностью',
  'pos.pay.fullHint': 'Оставьте пустым — сервер сам посчитает полную сумму (в валюте кассы, по курсу документа).',
  'pos.pay.partialWarning': 'Введена сумма: остаток останется ДОЛГОМ КЛИЕНТА и должен пройти проверку кредитного лимита.',
  'pos.pay.reference': 'Номер чека / документа',
  'pos.pay.noneWarning': 'Платёж не выбран — вся сумма запишется как ДОЛГ и попадёт в кредитный лимит.',
  'pos.sell': 'ПРОДАТЬ',
  'pos.selling': 'Продажа…',
  'pos.reset': 'Очистить',
  'pos.keyboardHint': 'Клавиатура: поле кода всегда в фокусе · Enter — добавить строку · Alt+S — продать · Alt+N — новая продажа',
  'pos.done.title': 'Продажа проведена',
  'pos.done.duplicate': 'Эта продажа уже записана — повторное нажатие не создало новый документ',
  'pos.done.order': 'Заказ',
  'pos.done.delivery': 'Накладная',
  'pos.done.invoice': 'Счёт-фактура',
  'pos.done.paid': 'Оплачено',
  'pos.done.debt': 'ОСТАЛСЯ ДОЛГ',
  'pos.done.newSale': 'Новая продажа',
  'pos.err.accountMissing': 'Касса не настроена. Эту настройку задаёт администратор — покажите ему сообщение ниже.',
  'pos.err.stock': 'Товара на складе недостаточно — продажа не проведена',
  'pos.err.credit': 'Кредитный лимит: неоплаченная часть превысила лимит',
  'pos.err.price': 'Цена не найдена — товара нет в прайс-листе',
  'pos.err.noLines': 'Нужна хотя бы одна строка',
  'cash.title': 'Моя касса',
  'cash.subtitle': 'Сколько и чем собрано за сегодня',
  'cash.date': 'Дата',
  'cash.total': 'Всего',
  'cash.saleCount': '{count} продаж',
  'cash.noSales': 'Сегодня продаж пока нет',
  'cash.method': 'Способ',
  'cash.amount': 'Сумма',
  'cash.count': 'Количество',
  'cash.salesTitle': 'Продажи за сегодня',
  'cash.time': 'Время',
  'cash.doc': 'Документ',
  'cash.customer': 'Клиент',
  'cash.invoice': 'Счёт-фактура',
  'cash.debt': 'Долг',
  'cash.baseHint': 'Общий итог в USD: способы оплаты могут быть в разных валютах (наличные — сум, перевод — доллар), и складывать их напрямую нельзя.',
  'cash.notShift': 'Это НЕ отчёт по смене — смен у нас нет, единица — ДЕНЬ. Закрытие дня и инкассация — отдельные документы в разделе «Касса филиала».',
  'nav.procurementWorkspace': 'Рабочее место снабжения',
  'proc.ws.title': 'Отдел снабжения',
  'proc.ws.subtitle': 'Один экран, который открывают в начале дня: что срочно, где заказы, когда и сколько платить.',
  'proc.ws.asOf': 'Данные на: {date}',
  'proc.ws.recalculated': 'Пересчитано сроков оплаты: {count} — базовая дата (отгрузка или готовность) сдвинулась.',
  'proc.ws.loadError': 'Не удалось загрузить рабочее место',
  'proc.ws.forbidden': 'Этот экран — для отделов снабжения и финансов: на нём показаны цены поставщиков и условия оплаты.',
  'proc.ws.attention': 'Требует внимания',
  'proc.ws.attention.clear': 'Срочных дел на сегодня нет',
  'proc.ws.attention.clearHint': 'Нет просроченных платежей, задержек производства и опаздывающих контейнеров. Пустой список — это и есть ответ.',
  'proc.ws.kind.payment_overdue': 'Просроченные платежи',
  'proc.ws.kind.payment_due_soon': 'К оплате в ближайшие 3 дня',
  'proc.ws.kind.production_late': 'Дата готовности прошла, товар не готов',
  'proc.ws.kind.arrival_late': 'ETA прошла, контейнер не прибыл',
  'proc.ws.countUnit': '{count} шт.',
  'proc.ws.pipeline': 'Статус заказов',
  'proc.ws.pipelineHint': 'Цепочка от Китая до склада. Сумма — эквивалент в USD по курсу документа.',
  'proc.ws.calendar': 'Календарь платежей',
  'proc.ws.calendarHint': 'Ближайшие {days} дн. Группировка по дате × поставщику: один перевод уходит на один завод.',
  'proc.ws.calendarEmpty': 'На ближайшие {days} дн. платежей не запланировано',
  'proc.ws.calendarTotal': 'Итого: {amount}',
  'proc.ws.dueDate': 'Срок',
  'proc.ws.supplier': 'Поставщик',
  'proc.ws.terms': 'Этап',
  'proc.ws.amount': 'Сумма (USD)',
  'proc.ws.overdue': 'Просроченные платежи',
  'proc.ws.overdueDays': '{days} дн.',
  'proc.ws.doc': 'Документ',
  'proc.ws.reliability': 'Показатель поставщика',
  'proc.ws.reliabilityHint': 'Разница между датой, названной заводом (план), и фактической датой готовности. Задержка судна СЮДА НЕ ВХОДИТ — она измеряется отдельно.',
  'proc.ws.reliabilityEmpty': 'Измерений пока нет: в заказах не заполнены даты готовности (план и факт).',
  'proc.ws.measured': 'Измерено',
  'proc.ws.avgDelay': 'Средняя задержка',
  'proc.ws.worstDelay': 'Худший случай',
  'proc.ws.lateNow': 'Опаздывают сейчас',
  'proc.ws.days': '{days} дн.',
  'proc.ws.reorder': 'Повторный заказ — 10 самых срочных',
  'proc.ws.reorderHint': 'Цикл поставки 120–150 дней: решение принимается за четыре месяца до того, как товар закончится.',
  'proc.ws.reorderEmpty': 'Срочных заказов пока не требуется',
  'proc.ws.reorderError': 'Не удалось загрузить анализ повторных заказов',
  'proc.ws.sku': 'Код',
  'proc.ws.product': 'Товар',
  'proc.ws.onHand': 'Остаток',
  'proc.ws.daysOfCover': 'Хватит (дней)',
  'proc.ws.suggested': 'Рекомендация',
  'poTerms.title': 'График платежей',
  'poTerms.hint': 'Импорт оплачивается по этапам. Срок привязан не к ДАТЕ, а к СОБЫТИЮ: условие «за 5 дней до отгрузки» СДВИНЕТСЯ САМО, если сдвинется дата отгрузки.',
  'poTerms.empty': 'График платежей не заполнен',
  'poTerms.emptyHint': 'Без графика заказ не попадает в календарь платежей, и предупреждения о задолженности тоже не появятся.',
  'poTerms.loadError': 'Не удалось загрузить график платежей',
  'poTerms.seq': '№',
  'poTerms.label': 'Этап',
  'poTerms.share': 'Доля',
  'poTerms.amountBase': 'USD',
  'poTerms.basis': 'Основание',
  'poTerms.offset': 'Сдвиг',
  'poTerms.dueDate': 'Срок',
  'poTerms.status': 'Статус',
  'poTerms.percentTotal': 'Итого доля: {percent}',
  'poTerms.percentIncomplete': 'Сумма долей меньше 100% — график неполный, и остаток суммы в календарь не попадёт.',
  'poTerms.undated': 'Этапов без срока: {count} — базовая дата пока неизвестна (нет контейнера или не указана дата готовности). Дата НЕ ПРЕДПОЛАГАЕТСЯ.',
  'poTerms.recalculated': 'Базовая дата сдвинулась — пересчитано сроков: {count}.',
  'poTerms.overdue': 'Просрочено на {days} дн.',
  'poTerms.noDate': 'Срок пока неизвестен',
  'poTerms.edit': 'Изменить график',
  'poTerms.add': 'Добавить этап',
  'poTerms.remove': 'Удалить',
  'poTerms.save': 'Сохранить график',
  'poTerms.saved': 'График платежей сохранён',
  'poTerms.saveError': 'Не удалось сохранить график',
  'poTerms.cancelEdit': 'Отменить',
  'poTerms.percentPlaceholder': '30.00',
  'poTerms.labelPlaceholder': 'Аванс 30%',
  'poTerms.offsetHint': 'Отрицательное число — ДО СОБЫТИЯ (например −5)',
  'poTerms.preset': 'Шаблон: 30% аванс / 70% до отгрузки',
  'poTerms.basis.order': 'Дата заказа',
  'poTerms.basis.ready': 'Дата готовности',
  'poTerms.basis.shipment': 'Отгрузка',
  'poTerms.basis.arrival': 'Прибытие',
  'poTerms.source.order_date': 'дата заказа',
  'poTerms.source.ready_date': 'ПЛАН готовности',
  'poTerms.source.actual_ready_date': 'ФАКТИЧЕСКАЯ дата готовности',
  'poTerms.source.shipment_etd': 'плановая отгрузка (ETD)',
  'poTerms.source.shipment_atd': 'ФАКТИЧЕСКАЯ отгрузка (ATD)',
  'poTerms.source.shipment_eta': 'плановое прибытие (ETA)',
  'poTerms.source.shipment_ata': 'ФАКТИЧЕСКОЕ прибытие (ATA)',
  'poTerms.status.planned': 'В плане',
  'poTerms.status.due': 'Срок наступил',
  'poTerms.status.paid': 'Оплачено',
  'poTerms.status.cancelled': 'Отменён',
  'poTerms.notLedger': 'Отметка «Оплачено» — это статус ПЛАНА, она не создаёт проводку. Реальное движение денег фиксируется в финансовом отделе.',
  'poReady.title': 'Дата готовности на заводе',
  'poReady.hint': 'Это НЕ дата прибытия. Завод изготавливает за 40 дней, а контейнер идёт ещё 90–110 дней. Если не вести их отдельно, ПРИЧИНА задержки теряется.',
  'poReady.plan': 'План',
  'poReady.actual': 'Факт',
  'poReady.delayLabel': 'Разница плана и факта',
  'poReady.delay': 'Разница: {days} дн.',
  'poReady.early': 'Готово раньше срока: {days} дн.',
  'poReady.onTime': 'Готово в срок',
  'poReady.pending': 'Ещё не готово',
  'poReady.late': 'Дата готовности прошла {days} дн. назад',
  'poReady.save': 'Сохранить даты',
  'poReady.saved': 'Даты сохранены',
  'poReady.saveError': 'Не удалось сохранить даты',
  'poReady.notSet': 'Не указано',
  'nav.group.branchCash': 'Касса филиала',
  'nav.dayClosing': 'Закрытие дня',
  'nav.expenses': 'Расходы филиала',
  'closing.account': 'Касса',
  'closing.accountPick': 'Выберите кассу…',
  'closing.date': 'Рабочий день',
  'closing.opening': 'Баланс на начало дня',
  'closing.cashIn': 'Приход за день',
  'closing.cashOut': 'Расход за день',
  'closing.expected': 'Ожидаемый баланс',
  'closing.counted': 'Пересчитано (факт)',
  'closing.countedPlaceholder': 'Пересчитайте вручную',
  'closing.countedHint': 'Систему намеренно не заставили подставлять пересчитанную сумму: если скопировать ожидаемое число, закрытие превращается в формальность и недостача никогда не находится.',
  'closing.difference': 'Разница',
  'closing.kind.match': 'Разницы нет',
  'closing.kind.shortage': 'НЕДОСТАЧА — денег в кассе меньше',
  'closing.kind.surplus': 'ИЗЛИШЕК — денег в кассе больше',
  'closing.reason': 'Причина разницы',
  'closing.reasonPlaceholder': 'Почему возникла разница?',
  'closing.reasonHint': 'Минимум 5 символов. Разница без причины превращается в ответ «округлили», и через несколько месяцев никто не скажет, что было в тот день.',
  'closing.notes': 'Примечание',
  'closing.countTitle': 'Пересчитайте деньги',
  'closing.closeAction': 'Закрыть день',
  'closing.noClosePerm': 'У вас нет права закрывать день — только просмотр.',
  'closing.closedTitle': 'День закрыт',
  'closing.reopenAction': 'Открыть заново',
  'closing.reopenReason': 'Причина повторного открытия',
  'closing.reopenHint': 'Открывать заново могут только руководитель и финансист. Открытие идёт с конца цепочки: открытие дня в середине тихо изменило бы начальный баланс последующих дней.',
  'closing.previous': 'Предыдущее закрытие',
  'closing.previousDiff': 'Непокрытая разница: {diff}',
  'closing.breakdown': 'Движения за день',
  'closing.direction': 'Направление',
  'closing.item': 'Статья ДДС',
  'closing.count': 'Количество',
  'closing.amount': 'Сумма',
  'closing.in': 'Приход',
  'closing.out': 'Расход',
  'closing.noMovements': 'В этот день движений по кассе не было.',
  'closing.status': 'Статус',
  'closing.status.open': 'Открыт',
  'closing.status.closed': 'Закрыт',
  'closing.status.reopened': 'Открыт заново',
  'closing.history': 'Последние закрытия',
  'closing.historyEmpty': 'Ни один день ещё не закрыт.',
  'closing.noAccounts': 'К вам не привязана касса филиала',
  'closing.noAccountsHint': 'Закрытие дня выполняется для кассы, ПРИВЯЗАННОЙ к филиалу. Нужно привязать кассу к филиалу (Настройки → Касса и банк) либо выдать вам область этого филиала.',
  'closing.genericError': 'Не удалось выполнить действие',
  'closing.notTransferHint': 'Закрытие дня — это НЕ ПЕРЕМЕЩЕНИЕ ДЕНЕГ, а сверка. После закрытия деньги остаются в кассе того же филиала. Сдача в центр (инкассация) — отдельный документ: Финансы → Перевод между счетами.',
  'closing.moneyStaysHint': 'Деньги НЕ ушли в центр автоматически — они остались в этой кассе. Когда сдадите их в центр, оформите перевод между счетами.',
  'closing.driftTitle': 'Цепочка разорвана',
  'closing.driftHint': 'Ожидаемый баланс не сходится с итогом по кассовой книге (разница {drift}). Обычно так бывает, когда в закрытый день задним числом попала запись. Обратитесь к финансисту — причину нужно найти до закрытия.',
  'expense.intro': 'Расходы, оплаченные филиалом из собственной кассы. Черновик не двигает деньги — деньги уходят из кассы только при проведении.',
  'expense.new': 'Новый расход',
  'expense.saveDraft': 'Сохранить черновик',
  'expense.draftHint': 'После сохранения деньги ещё не уходят: документ нужно провести.',
  'expense.docNo': 'Документ',
  'expense.date': 'Дата',
  'expense.branch': 'Филиал',
  'expense.account': 'Касса',
  'expense.accountPick': 'Выберите кассу…',
  'expense.item': 'Вид расхода (ДДС)',
  'expense.itemPick': 'Выберите статью…',
  'expense.amount': 'Сумма',
  'expense.payee': 'Кому оплачено',
  'expense.documentRef': 'Чек/квитанция',
  'expense.description': 'Примечание',
  'expense.descriptionPlaceholder': 'Например: аренда магазина за август',
  'expense.descriptionHint': 'Минимум 5 символов. Статья ДДС даёт категорию («Аренда»), а примечание — конкретный факт: запись «расход 500 000» в конце месяца ничего не объясняет.',
  'expense.status': 'Статус',
  'expense.statusAll': 'Все',
  'expense.status.draft': 'Черновик',
  'expense.status.posted': 'Проведён',
  'expense.status.cancelled': 'Отменён',
  'expense.post': 'Провести',
  'expense.awaitingPost': 'Ожидает проведения',
  'expense.cancelAction': 'Отменить',
  'expense.cancelReason': 'Причина отмены',
  'expense.confirm': 'Подтвердить',
  'expense.actions': 'Действия',
  'expense.empty': 'Расходы не найдены.',
  'expense.noAccounts': 'К вам не привязана касса филиала. Расход оформляется только из кассы ФИЛИАЛА.',
  'expense.noItems': 'Статьи расходов не найдены. Финансист должен настроить расходные статьи в дереве ДДС (Финансы → Статьи движения денежных средств).',
  'expense.genericError': 'Не удалось выполнить действие',
  'nav.fxRevaluation': 'Переоценка (курсовые разницы)',
  'fxreval.intro': 'В конце периода остатки в валюте (касса, банк, долг покупателей, долг поставщикам) пересчитываются по курсу закрытия. Сначала РАССЧИТАЙТЕ и проверьте строки — запись в учёт это отдельный шаг.',
  'fxreval.legalEntity': 'Юридическое лицо',
  'fxreval.pickEntity': 'Выберите юридическое лицо.',
  'fxreval.currency': 'Валюта',
  'fxreval.currencyHint': '{base} нет в списке: это базовая валюта, и пересчёт её в саму себя всегда даёт нулевую разницу.',
  'fxreval.date': 'Дата',
  'fxreval.dateHint': 'Обычно последний день месяца. Берётся курс закрытия на эту дату.',
  'fxreval.previewAction': 'Рассчитать (просмотр)',
  'fxreval.staleHint': 'Выбор изменился — цифры ниже УСТАРЕЛИ. Нажмите «Рассчитать» ещё раз.',
  'fxreval.closingRate': 'Курс закрытия',
  'fxreval.gain': 'Курсовая прибыль',
  'fxreval.loss': 'Курсовой убыток',
  'fxreval.net': 'Итог',
  'fxreval.netGain': 'ПРИБЫЛЬ — остаток подорожал в базовой валюте',
  'fxreval.netLoss': 'УБЫТОК — остаток подешевел в базовой валюте',
  'fxreval.netZero': 'Разницы нет',
  'fxreval.warningsTitle': 'Эти остатки не переоценены',
  'fxreval.existingTitle': 'На эту дату переоценка УЖЕ есть',
  'fxreval.existingHint': 'На {date} запись уже существует (статус: {status}, итог: {net}). Прежде чем делать новую, сторнируйте старую — иначе одна и та же курсовая разница попадёт в учёт дважды.',
  'fxreval.linesTitle': 'Остатки к переоценке',
  'fxreval.role': 'Вид',
  'fxreval.role.cash': 'Касса',
  'fxreval.role.bank': 'Банк',
  'fxreval.role.ar': 'Долг покупателей',
  'fxreval.role.ap': 'Долг поставщикам',
  'fxreval.account': 'Счёт',
  'fxreval.subject': 'Что переоценено',
  'fxreval.foreignAmount': 'Остаток в валюте',
  'fxreval.previousBase': 'Прежняя база',
  'fxreval.newBase': 'Новая база',
  'fxreval.differenceBase': 'РАЗНИЦА',
  'fxreval.noLines': 'Остатков в этой валюте не найдено — не будет ни разницы, ни проводки.',
  'fxreval.postTitle': 'Записать в учёт',
  'fxreval.postHint': 'После записи сумма попадёт в отчёт о прибылях и убытках этого месяца. Ошибку нельзя удалить — её можно только сторнировать с указанием причины.',
  'fxreval.postAction': 'Записать в учёт',
  'fxreval.postAgainAction': 'На эту дату запись есть — записать всё равно',
  'fxreval.notes': 'Примечание',
  'fxreval.notesPlaceholder': 'Например: закрытие августа',
  'fxreval.noRunPerm': 'У вас нет права записи в учёт — только просмотр.',
  'fxreval.resultTitle': 'Записано',
  'fxreval.journal': 'Проводка',
  'fxreval.journalWritten': 'Проводка записана в учёт',
  'fxreval.journalLine': 'Документ {docNo}, статус: {status}',
  'fxreval.journalPendingTitle': 'Переоценка сохранена, проводка в очереди',
  'fxreval.journalPendingHint': 'Это НЕ ошибка. Проводку система пишет через очередь, обычно это занимает несколько секунд. Не нажимайте кнопку повторно — обновите страницу, и номер документа появится в истории.',
  'fxreval.journalPendingShort': 'В очереди',
  'fxreval.status': 'Статус',
  'fxreval.status.draft': 'Черновик',
  'fxreval.status.posted': 'Записана',
  'fxreval.status.reversed': 'Сторнирована',
  'fxreval.actions': 'Действия',
  'fxreval.history': 'Предыдущие переоценки',
  'fxreval.historyEmpty': 'Ни одной переоценки ещё не было.',
  'fxreval.reverseAction': 'Сторнировать',
  'fxreval.reverseReason': 'Причина сторнирования',
  'fxreval.reverseReasonPlaceholder': 'Почему сторнируется?',
  'fxreval.reverseHint': 'Минимум 3 символа. Сторнирование меняет цифру закрытого периода и часто нажимается под давлением «отчёт получился некрасивый» — напишите причину, которая будет понятна и через несколько месяцев.',
  'fxreval.genericError': 'Не удалось выполнить действие',

  // Компактный чип курса в верхней панели.
  'fx.missingShort': 'Нет курса',
  'fx.chipTitle': 'Курс дня: 1 USD = {rate} сум ({date})',
  'fx.cnyHint':
    '¥ нужен только для закупки — когда приходит контейнер из Китая. Это не ежедневный курс, поэтому в верхней панели он не показывается.',

  // --- Главная: приветственный блок и плитки показателей -------------------
  'dashboard.hero.morning': 'Доброе утро, {name}',
  'dashboard.hero.day': 'Добрый день, {name}',
  'dashboard.hero.evening': 'Добрый вечер, {name}',
  'dashboard.hero.night': 'Доброй ночи, {name}',

  // Без имени — когда у учётной записи нет настоящего имени.
  'dashboard.hero.morningPlain': 'Доброе утро',
  'dashboard.hero.dayPlain': 'Добрый день',
  'dashboard.hero.eveningPlain': 'Добрый вечер',
  'dashboard.hero.nightPlain': 'Доброй ночи',

  'dashboard.hero.weekday.sun': 'Воскресенье',
  'dashboard.hero.weekday.mon': 'Понедельник',
  'dashboard.hero.weekday.tue': 'Вторник',
  'dashboard.hero.weekday.wed': 'Среда',
  'dashboard.hero.weekday.thu': 'Четверг',
  'dashboard.hero.weekday.fri': 'Пятница',
  'dashboard.hero.weekday.sat': 'Суббота',

  // Сумма убрана из фразы: она стоит рядом, в показателе «Сегодня».
  'dashboard.hero.sales': 'Сегодня {lines} строк продаж.',
  'dashboard.hero.noSalesYet': 'Продаж сегодня пока нет — день только начинается.',
  'dashboard.hero.trendUp': 'Этот месяц идёт выше прошлого на ту же дату.',
  'dashboard.hero.trendDown': 'Этот месяц идёт ниже прошлого на ту же дату.',
  'dashboard.hero.trendFlat': 'Этот месяц вровень с прошлым на ту же дату.',
  'dashboard.hero.tasks': 'Вашего внимания ждут {count} дел.',
  'dashboard.hero.allClear': 'Ничего срочного — всё в порядке.',
  'dashboard.hero.plain': 'Продуктивного рабочего дня.',
  'dashboard.hero.dataError': 'Часть показателей не загрузилась — причина показана в разделах ниже.',
  'dashboard.hero.today': 'Сегодня',
  'dashboard.hero.thisMonth': 'Этот месяц',

  'dashboard.kpi.salesToday': 'Продажи за сегодня',
  'dashboard.kpi.salesTodayHint': 'Строк продаж: {count}',
  'dashboard.kpi.revenueMonth': 'Выручка за месяц',
  'dashboard.kpi.overdue': 'Просроченный долг',
  'dashboard.kpi.overdueHint': 'Всего долга: {amount}',
  'dashboard.kpi.cashHint': 'Приход {in} · расход {out}',
  'dashboard.kpi.tasksHint': 'Перемещения {transfers} · инвентаризации {counts}',
  'dashboard.kpi.tasksNone': 'Незакрытых дел нет',

  'dashboard.attention.allClearTitle': 'Всё в порядке',
  'dashboard.attention.allClearBody':
    'Ни просроченного долга, ни непринятых документов. Сегодня можно работать спокойно.',

  'dashboard.section.ranking': 'Кто и что приносит деньги',
  'dashboard.section.rankingHint': 'По выручке этого месяца, первая пятёрка',
  'dashboard.section.ar': 'Контроль долга',
  'dashboard.section.arHint': 'Клиенты с просроченным долгом, от крупного',
  'dashboard.section.stock': 'Стоимость склада',
  'dashboard.section.stockHint': 'По каждому складу, по landed cost',

  'dashboard.arRowHint': 'Всего долга: {amount}',
  'dashboard.arNoOverdue': 'Просроченного долга нет',
  'dashboard.arNoOverdueHint':
    'Все счета в пределах срока. Звонить по долгам сегодня не нужно.',
  'dashboard.stockEmpty': 'Стоимость склада не рассчитана',
  'dashboard.stockEmptyHint':
    'Здесь появляются склады с остатком. Пустой список означает, что ни одна приёмка ещё не проведена.',
  'dashboard.emptySales': 'В этом месяце продаж пока нет',
  'dashboard.emptySalesHint':
    'Цифры появляются, когда отгрузка ПРОВЕДЕНА — сам заказ в отчёт не попадает.',

  // --- Сторнирование расхода ---
  'expense.reverseAction': 'Сторнировать',
  'expense.reverseTitle': 'Сторнирование {docNo}',
  'expense.reverseHint':
    'Расход НЕ УДАЛЯЕТСЯ — создаётся обратный (сторно) документ, и оба остаются в списке. {amount} ВЕРНЁТСЯ в кассу «{account}», то есть ожидаемый остаток дня вырастет на эту сумму. Исходный документ перейдёт в статус «отменён».',
  'expense.reverseReason': 'Причина сторнирования',
  'expense.reverseReasonPlaceholder':
    'Например: аренда записана дважды; сумма была 50 000, а не 500 000',
  'expense.reverseReasonHint':
    'Напишите, что именно было неверно — минимум {min} символов. Сторно ВОЗВРАЩАЕТ деньги в кассу и поднимает ожидаемый остаток: без причины такая запись становится способом тихо прикрыть излишек в кассе. Причина остаётся в аудите.',
  'expense.reverseSubmit': 'Да, сторнировать',
  'expense.reverseDone': 'Сторнировано',
  'expense.reverseDoneHint':
    '{docNo} отменён, вместо него создан документ сторно. Исходный документ остаётся в истории — кассовый отчёт, распечатанный вчера, сегодня читается так же.',
  'expense.reverseReturned': 'Вернулось в кассу',
  'expense.reverseReturnedHint': 'На счёт «{account}», приходным движением',
  'expense.reverseCashAfter': 'Остаток кассы',
  'expense.reverseCashBefore': 'До сторно: {amount}',
  'expense.reverseOriginal': 'Отменённый документ',
  'expense.reverseOriginalHint': 'Остаётся в списке, не удаляется',
  'expense.reversalRow': 'Сторно',
  'expense.reversedRow': 'Сторнирован',

  // --- Сторнирование выплаты бонуса ---
  'bnl.actions': 'Действия',
  'bnl.reverseAction': 'Сторнировать',
  'bnl.reverseTitle': 'Сторнирование {docNo}',
  'bnl.reverseHint':
    'Выплата НЕ УДАЛЯЕТСЯ — в книгу добавляется обратная (сторно) строка, и обе остаются видимыми. {amount} ВЕРНЁТСЯ в кассу, а остаток бонуса восстановится до состояния перед выплатой.',
  'bnl.reverseHintInstaller':
    'Выплата НЕ УДАЛЯЕТСЯ — в книгу добавляется обратная (сторно) строка, и обе остаются видимыми. Возвращаются ДВЕ вещи: {amount} в кассу и {points} баллов на счёт мастера. После возврата баллов мастер может снова обналичить их или обменять на подарок — поэтому это не «отмена» бонуса, а возврат его в состояние НЕВЫПЛАЧЕННОГО.',
  'bnl.reverseReason': 'Причина сторнирования',
  'bnl.reverseReasonPlaceholder':
    'Например: выбран не тот мастер; количество баллов введено неверно',
  'bnl.reverseReasonHint':
    'Напишите, что именно было неверно — минимум {min} символов. Сторно ВОЗВРАЩАЕТ деньги в кассу и поднимает ожидаемый остаток: без причины такая запись становится способом тихо прикрыть излишек в кассе. Причина остаётся в аудите.',
  'bnl.reverseSubmit': 'Да, сторнировать',
  'bnl.reverseDone': 'Сторнировано',
  'bnl.reverseDoneHint':
    '{docNo} сторнирован, вместо него записана строка сторно. Исходная строка остаётся в книге — отчёт, распечатанный вчера, сегодня читается так же.',
  'bnl.reverseReturned': 'Вернулось в кассу',
  'bnl.reverseReturnedHint': 'Приходным движением, датой исходной выплаты',
  'bnl.reverseCashAfter': 'Остаток кассы',
  'bnl.reverseCashBefore': 'До сторно: {amount}',
  'bnl.reversePoints': 'Баллы вернулись мастеру',
  'bnl.reversePointsHint': 'Баланс восстановлен — баллы можно использовать снова',
  'bnl.reverseOriginal': 'Сторнированный документ',
  'bnl.reverseOriginalHint': 'Остаётся в книге, не удаляется',

  'branchFilter.active': 'Филиал: {branch}',
  'branchFilter.clear': 'Убрать фильтр',
  'branchFilter.hint': 'Список сужен по филиалу, выбранному в верхней панели.',
  'branchFilter.cleared': 'Показаны все филиалы.',
  'branchFilter.restore': 'Показать только «{branch}»',

  'rebate.column': 'Ребейт',
  'rebate.toggle': 'Ступени',
  'rebate.toggleClose': 'Закрыть',
  'rebate.title': '{dealer} — годовые ступени ребейта',
  'rebate.what':
    'Процент, который возвращается дилеру по итогам года, берётся из этой лестницы: применяется та ступень, сумму которой годовой оборот достиг или превысил.',
  'rebate.year': 'Год',
  'rebate.loadError': 'Не удалось загрузить ступени',
  'rebate.emptyTitle': 'На {year} год ступени не заданы',
  'rebate.emptyBody':
    'Лестница ступеней — это договорное правило «больше берёшь — больше возвращается»: например 1% от 0, 3% от 1 000, 5% от 50 000. Без лестницы бонус не считается — сервер не находит подходящую ступень и отказывает. Задайте первую ступень в форме ниже.',
  'rebate.rungFrom': 'начиная с этой суммы',
  'rebate.rungUntil': 'следующая ступень:',
  'rebate.rungTop': 'верхней границы нет — высшая ступень',
  'rebate.inactive': 'Отключена',
  'rebate.noZeroTitle': 'Лестница не начинается с нуля',
  'rebate.noZeroBody':
    'Нижняя ступень начинается с {amount}. Дилер, чей годовой оборот меньше, не попадает НИ В ОДНУ ступень, и начисление будет отклонено. Если так задумано — делать ничего не нужно; иначе добавьте ступень от 0.',
  'rebate.turnoverUnknown':
    'Текущий оборот дилера здесь не показывается: сервер считает его по счетам во время начисления бонуса и отдельно не отдаёт. Лестница — это ДОГОВОРЁННОСТЬ, оборот — ФАКТ по итогам года.',
  'rebate.addTitle': 'Добавить ступень или изменить её процент',
  'rebate.upsertHint':
    'Если ввести уже существующую сумму — процент этой ступени ОБНОВИТСЯ, дубликат не появится.',
  'rebate.fromAmount': 'С какой суммы',
  'rebate.fromAmountHint':
    'В базовой валюте ({currency}). Граница включается: ровно эта сумма уже относится к данной ступени.',
  'rebate.pct': 'Процент ребейта',
  'rebate.pctHint': 'От 0 до 100, до 2 знаков после запятой. Ноль допустим — «на этой ступени бонуса нет».',
  'rebate.fromAmountInvalid': 'Сумма — неотрицательное число, до 4 знаков после запятой',
  'rebate.pctInvalid': 'Процент от 0 до 100, до 2 знаков после запятой',
  'rebate.save': 'Сохранить ступень',
  'rebate.saved': 'Сохранено: {pct} начиная с {amount}',
  'rebate.frozenHint':
    'Изменение ступени НЕ затрагивает уже начисленные бонусы — процент в книге заморожен, прошлые начисления не переписываются.',
  'rebate.noManage':
    'У вас нет права изменять ступени ретро-бонуса — оно есть у финансиста и администратора. Просмотр открыт всем.',

  'customer.contract.title': 'Условие договора',
  'customer.contract.discount': 'Договорная скидка',
  'customer.contract.discountHint': 'От 0 до 100, до 2 знаков. Оставьте пустым — поле не изменится.',
  'customer.contract.no': 'Номер договора',
  'customer.contract.noHint': 'Должен в точности совпадать с номером на бумаге.',
  'customer.contract.from': 'Действует с',
  'customer.contract.to': 'Действует по',
  'customer.contract.toHint': 'После этой даты скидка не применяется.',
  'customer.contract.period': 'Срок действия',
  'customer.contract.status': 'Состояние',
  'customer.contract.statusNone': 'Срок не указан',
  'customer.contract.statusOpen': 'Срок наполовину открыт',
  'customer.contract.statusActive': 'Действует',
  'customer.contract.statusExpired': 'Срок истёк',
  'customer.contract.statusFuture': 'Ещё не вступил в силу',
  'customer.contract.noDiscount': 'Скидки нет',
  'customer.contract.noDiscountHint': 'Цена считается по общему прайс-листу.',
  'customer.contract.appliedHint': 'Предлагается как скидка по умолчанию в каждой строке.',
  'customer.contract.notApplied': 'НЕ ПРИМЕНЯЕТСЯ — срок договора истёк',
  'customer.contract.expiredTitle': 'Срок договора истёк — скидка не действует',
  'customer.contract.expiredBody':
    'Срок закончился {date}. Процент ниже показан как ИСТОРИЯ, и ставить его в коммерческое предложение нельзя: клиент запишет названную цену, а дальше либо скидку дадут себе в убыток, либо сделка сорвётся. Если договор продлён — введите новые даты.',
  'customer.contract.futureTitle': 'Договор ещё не вступил в силу',
  'customer.contract.futureBody':
    'Скидка применяется с {date}. К сегодняшним продажам она не относится.',
  'customer.contract.openTitle': 'Срок договора наполовину открыт',
  'customer.contract.openBody':
    'Одна из двух дат не указана, то есть скидка действует бессрочно. Это должно быть осознанным решением — иначе заполните обе даты.',
  'customer.contract.pendingTitle': 'Поля договора пока недоступны',
  'customer.contract.pendingBody':
    'Скидка, номер договора и срок на этом экране пока недоступны. Когда они будут готовы, раздел заполнится сам и появится форма редактирования — на экране больше ничего не изменится.',
  'customer.contract.edit': 'Изменить условие договора',
  'customer.contract.editHint':
    'Скидка — это условие договора, а не настроение: она попадает в каждую строку продажи и за год превращается в заметную сумму. Скидка без даты окончания не заканчивается никогда.',
  'customer.contract.saved': 'Условие договора сохранено',
  'customer.contract.noChanges': 'Ничего не изменилось',
  'customer.contract.pctInvalid': 'Скидка от 0 до 100, до 2 знаков после запятой',
  'customer.contract.dateInvalid': 'Дата должна быть в виде 2026-08-13',
  'customer.contract.rangeInvalid': 'Дата окончания не может быть раньше даты начала',
  'customer.contract.noPermission':
    'У вас нет права изменять кредитные условия клиента. При необходимости обратитесь к руководителю.',
  'nav.employees': 'Сотрудники',
  'hr.employees.title': 'Сотрудники',
  'hr.employees.total': 'Всего сотрудников',
  'hr.employees.active': 'Работают',
  'hr.employees.expiredContracts': 'Истёкшие договоры',
  'hr.employees.expiredHint': 'Сотрудник формально не защищён',
  'hr.employees.searchHint': 'Имя, табельный номер или должность',
  'hr.employees.emptyTitle': 'Нет сотрудников',
  'hr.employees.emptyBody': 'Очистите фильтр или добавьте сотрудника.',
  'hr.employees.no': 'Табель',
  'hr.employees.name': 'ФИО',
  'hr.employees.position': 'Должность',
  'hr.employees.branch': 'Филиал',
  'hr.employees.contract': 'Договор',
  'hr.employees.salary': 'Оклад',
  'hr.employees.salaryHint': 'сумма по договору',
  'hr.employees.central': 'Центральный',
  'hr.employees.card': 'Карточка',
  'hr.employees.new': 'Новый сотрудник',
  'hr.employees.hiredAt': 'Дата приёма',
  'hr.employees.statusCol': 'Статус',
  'hr.employees.all': 'Все',
  'hr.status.active': 'Работает',
  'hr.status.suspended': 'Приостановлен',
  'hr.status.fired': 'Уволен',
  'hr.contract.none': 'Нет',
  'hr.contract.open': 'Бессрочный',
  'hr.contract.active': 'Действует',
  'hr.contract.future': 'Ещё не начался',
  'hr.contract.expired': 'Истёк',
  'hr.contract.expiredTitle': 'Срок договора истёк',
  'hr.contract.expiredBody': 'Сотрудник работает без договора. Дата окончания:',
  'hr.duties.duties': 'Обязанности',
  'hr.duties.dutiesHint': 'Что делает ежедневно — становится KPI',
  'hr.duties.obligations': 'Обязательства по договору',
  'hr.duties.obligationsHint': 'Что подписал — доказательство в споре',
  'hr.duties.empty': 'Пока не внесено',
  'hr.duties.add': 'Добавить обязанность',
  'hr.duties.kind': 'Тип',
  'hr.duties.titleField': 'Название',
  'hr.duties.titleHint': 'например: ежедневно закрывать кассу',
  'hr.duties.kpiLinked': 'Привязано к плану KPI:',
  'hr.fire.title': 'Увольнение',
  'hr.fire.hint': 'Дата — основа расчёта зарплаты; без неё сотрудник продолжит начисляться незаметно.',
  'hr.fire.date': 'Дата увольнения',
  'hr.fire.reason': 'Причина',
  'hr.fire.reasonShort': 'Минимум 5 символов',
  'hr.fire.submit': 'Уволить',
  'nav.payroll': 'Зарплата и авансы',
  'hr.payroll.title': 'Зарплата, авансы и долги',
  'hr.payroll.runs': 'Расчёты зарплаты',
  'hr.payroll.run': 'Рассчитать зарплату',
  'hr.payroll.runHint': 'Начисляет расход; деньги не уходят — выплата отдельно.',
  'hr.payroll.period': 'Период',
  'hr.payroll.year': 'Год',
  'hr.payroll.month': 'Месяц',
  'hr.payroll.gross': 'Начислено',
  'hr.payroll.advance': 'Аванс',
  'hr.payroll.deduction': 'Удержано',
  'hr.payroll.net': 'К выдаче',
  'hr.payroll.pay': 'Выплатить',
  'hr.payroll.payConfirm': 'Подтверждаю — выдать',
  'hr.payroll.chooseAccount': 'Выберите кассу',
  'hr.payroll.account': 'Касса',
  'hr.payroll.amount': 'Сумма',
  'hr.payroll.noRuns': 'Зарплата ещё не рассчитана',
  'hr.payroll.noRunsBody': 'Выберите период и нажмите «Рассчитать зарплату».',
  'hr.payroll.advances': 'Авансы',
  'hr.payroll.advancesHint': 'Выдано в середине месяца — закрывается в зарплате',
  'hr.payroll.noAdvances': 'Авансов нет',
  'hr.payroll.giveAdvance': 'Выдать аванс',
  'hr.payroll.openAdvances': 'Незакрытые авансы',
  'hr.payroll.openAdvancesHint': 'удержится в следующей зарплате',
  'hr.payroll.debts': 'Долги сотрудников',
  'hr.payroll.debtsHint': 'Недостача, порча, заём',
  'hr.payroll.noDebts': 'Долгов нет',
  'hr.payroll.addDebt': 'Записать долг',
  'hr.payroll.openDebts': 'Открытые долги',
  'hr.payroll.openDebtsHint': 'удержится из зарплаты',
  'hr.payroll.doc': 'Документ',
  'hr.payroll.source': 'Источник',
  'hr.payroll.sourceHint': 'определяет и проводку',
  'hr.payroll.balance': 'Остаток',
  'hr.payroll.advance.posted': 'Открыт',
  'hr.payroll.advance.settled': 'Закрыт',
  'hr.payroll.advance.reversed': 'Сторнирован',
  'hr.debt.shortfall': 'Недостача кассы',
  'hr.debt.damage': 'Порча товара',
  'hr.debt.loan': 'Заём',
  'hr.debt.other': 'Прочее',
  'hr.debt.status.open': 'Открыт',
  'hr.debt.status.settled': 'Погашен',
  'hr.debt.status.written_off': 'Списан',
  'nav.charity': 'Фонд благотворительности',
  'charity.title': 'Фонд благотворительности',
  'charity.accrued': 'Начислено',
  'charity.paid': 'Выдано',
  'charity.available': 'Остаток в фонде',
  'charity.availableHint': 'обязательство — не входит в капитал',
  'charity.accrue': 'Отчислить из прибыли',
  'charity.accrueHint': 'Доля чистой прибыли. В убыточный месяц отчисления нет.',
  'charity.pct': 'Процент',
  'charity.baseProfit': 'База прибыли',
  'charity.amount': 'Отчисление',
  'charity.give': 'Оказать помощь',
  'charity.recipient': 'Получатель',
  'charity.recipientHint': 'человек или организация — деньги должны оставить след',
  'charity.purpose': 'Назначение',
  'charity.appropriations': 'Отчисления',
  'charity.payouts': 'Оказанная помощь',
  'charity.noAppropriations': 'Отчислений пока нет',
  'charity.noPayouts': 'Помощь пока не оказывалась',
  'nav.control': 'Отдел контроля',
  'hr.control.title': 'Отдел контроля',
  'hr.control.subtitle': 'Договоры, обязанности, авансы, долги и зарплата в одном списке. Экран ничего не меняет.',
  'hr.control.includeLeft': 'Включая уволенных',
  'hr.control.employees': 'Сотрудники',
  'hr.control.critical': 'Критично',
  'hr.control.criticalHint': 'хотя бы один серьёзный сигнал',
  'hr.control.openAdvance': 'Незакрытые авансы',
  'hr.control.openAdvanceHint': 'деньги выданы, ещё не удержаны',
  'hr.control.openDebt': 'Открытые долги',
  'hr.control.openDebtHint': 'удержится из зарплаты',
  'hr.control.board': 'Таблица контроля',
  'hr.control.employee': 'Сотрудник',
  'hr.control.signals': 'Сигналы',
  'hr.control.money': 'Аванс / долг',
  'hr.control.noSignals': 'Проблем нет',
  'hr.control.clean': 'Нечего отмечать',
  'hr.control.cleanBody': 'Все договоры действуют, незакрытых авансов и долгов нет.',
  'hr.control.left': 'уволен',
  'hr.control.lastPayroll': 'Последняя зарплата',
  'hr.control.neverPaid': 'Зарплата не начислялась',
  'hr.control.ai': 'Сводка ИИ',
  'hr.control.aiPending': 'ИИ думает...',
  'hr.control.aiTitle': 'Сводка ИИ-помощника',
  'hr.control.aiConfidence': 'уверенность',
  'hr.control.signal.contract_missing': 'Работает без договора',
  'hr.control.signal.contract_expired': 'Срок договора истёк',
  'hr.control.signal.contract_expiring': 'Договор истекает (дней)',
  'hr.control.signal.contract_future': 'Договор ещё не начался',
  'hr.control.signal.no_duties': 'Обязанности не записаны',
  'hr.control.signal.no_obligations': 'Обязательства не записаны',
  'hr.control.signal.advance_open': 'Незакрытый аванс',
  'hr.control.signal.advance_stale': 'Аванс просрочен (дней)',
  'hr.control.signal.advance_after_leave': 'Уволен, аванс не возвращён',
  'hr.control.signal.debt_open': 'Открытый долг',
  'hr.control.signal.debt_heavy': 'Крупный долг',
  'hr.control.signal.debt_after_leave': 'Уволен, долг остался',
  'hr.control.signal.payroll_missing': 'Зарплата не начислена',
  'hr.control.signal.salary_zero': 'Оклад нулевой',
  'hr.control.signal.no_kpi': 'Нет плана KPI',
  'hr.payroll.reverse': 'Сторнировать',
  'hr.payroll.reverseTitle': 'Вернуть аванс',
  'hr.payroll.reverseHint': 'Деньги ВЕРНУТСЯ в кассу. Причина записывается навсегда.',
  'hr.payroll.writeOff': 'Списать',
  'hr.payroll.writeOffTitle': 'Простить долг',
  'hr.payroll.writeOffHint': 'Это убыток компании — от взыскания отказываются.',
  'hr.payroll.reasonPlaceholder': 'Причина (не менее 5 символов)',
  'hr.payroll.reverseRunTitle': 'Отменить расчёт зарплаты',
  'hr.payroll.reverseRunHint': 'Если выплачено — деньги вернутся; авансы и долги восстановятся.',
  'hr.control.signal.no_branch': 'Нет филиала — деньги не попадают в учёт',
  'charity.reverse': 'Сторнировать',
  'charity.reverseTitle': 'Отменить помощь',
  'charity.reverseHint': 'Деньги вернутся, остаток фонда восстановится.',
  'charity.reasonPlaceholder': 'Причина (не менее 5 символов)',
  'nav.discounts': 'Скидки',
  'reports.discounts.title': 'Скидки по клиентам',
  'reports.discounts.subtitle': 'Кому сколько дали: скидка в счёте и накапливаемая годовая.',
  'reports.discounts.byCustomer': 'По клиентам',
  'reports.discounts.customer': 'Клиент',
  'reports.discounts.list': 'Сумма по прайсу',
  'reports.discounts.instant': 'Скидка в счёте',
  'reports.discounts.instantHint': 'дана в счёте — клиент заплатил меньше',
  'reports.discounts.annual': 'Годовая скидка',
  'reports.discounts.annualHint': 'обязательство — ещё не выплачено, накапливается',
  'reports.discounts.total': 'Всего скидок',
  'reports.discounts.pct': 'Процент',
  'reports.discounts.pctHint': 'к сумме по прайсу',
  'reports.discounts.invoices': 'счётов',
  'reports.discounts.noInvoices': 'В этом периоде продаж не было',
  'reports.discounts.empty': 'Скидок не было',
  'reports.discounts.emptyBody': 'В этом периоде скидки никому не начислялись.',
  'reports.discounts.pnlNote': '«Скидка в счёте» здесь НЕ равна строке «Предоставленные скидки» в отчёте о прибылях — и это правильно: скидка в счёте удерживается сразу, выручка уже записана меньшей. Строка в отчёте показывает бонусы, выплаченные позже. Годовая скидка совпадает в обоих местах.',
  'dashboard.attention.control': 'Критично в отделе контроля',
  'nav.creditNotes': 'Кредит-ноты',
  'creditNote.title': 'Кредит-ноты',
  'creditNote.subtitle': 'Документ, уменьшающий долг клиента при возврате товара.',
  'creditNote.list': 'Список',
  'creditNote.docNo': 'Документ',
  'creditNote.customer': 'Клиент',
  'creditNote.amount': 'Сумма',
  'creditNote.balance': 'Остаток',
  'creditNote.statusCol': 'Статус',
  'creditNote.allStatuses': 'Все статусы',
  'creditNote.issue': 'Признать',
  'creditNote.cancel': 'Отменить',
  'creditNote.cancelTitle': 'Отменить черновик',
  'creditNote.cancelHint': 'Отменить можно только черновик — признанная нота остаётся в учёте.',
  'creditNote.empty': 'Кредит-нот нет',
  'creditNote.emptyBody': 'Кредит-нота выпускается из карточки возврата.',
  'creditNote.status.draft': 'Черновик',
  'creditNote.status.issued': 'Признана',
  'creditNote.status.applied': 'Применена',
  'creditNote.status.cancelled': 'Отменена',
  'creditNote.issueDate': 'Дата',
  'creditNote.reason': 'Причина',
  'creditNote.reason.return': 'Возврат товара',
  'creditNote.reason.price_correction': 'Корректировка цены',
  'creditNote.reason.discount': 'Скидка',
  'creditNote.reason.write_off': 'Списание',
  'creditNote.applied': 'Применено',
  'creditNote.fromReturnDoc': 'Документ возврата',
  'creditNote.notes': 'Примечание',
  'creditNote.lines': 'Строки',
  'creditNote.lineName': 'Наименование',
  'creditNote.lineQty': 'Количество',
  'creditNote.linePrice': 'Цена',
  'creditNote.lineAmount': 'Сумма',
  'creditNote.allocations': 'К каким счетам применено',
  'creditNote.allocInvoice': 'Счёт',
  'creditNote.allocDate': 'Дата',
  'creditNote.fromReturn': 'Выпустить кредит-ноту',
  'creditNote.fromReturnHint': 'Строки копируются из возврата — вручную ничего не вводится.',
  'creditNote.created': 'Черновик кредит-ноты создан',
  'nav.treasury': 'Казначейство',
  'treasury.title': 'Казначейство',
  'treasury.subtitle': 'Где деньги, сколько их и когда закончатся.',
  'treasury.gapTitle': 'Денег не хватит',
  'treasury.gapBody': '{date} ({days} дн.) не хватит {amount}.',
  'treasury.driftTitle': 'Остаток кассы не сходится с учётом',
  'treasury.total': 'Всего денег',
  'treasury.totalHint': 'все кассы и банковские счета',
  'treasury.expectedIn': 'Ожидаемый приход',
  'treasury.expectedOut': 'Ожидаемый расход',
  'treasury.horizonHint': 'за 90 дней',
  'treasury.lowest': 'Минимум',
  'treasury.byCurrency': 'По валютам',
  'treasury.currency': 'Валюта',
  'treasury.balance': 'Остаток',
  'treasury.inBase': 'В базовой',
  'treasury.accounts': 'счетов',
  'treasury.calendar': 'Платёжный календарь',
  'treasury.calendarHint': 'Что придёт и уйдёт в ближайшие дни',
  'treasury.calendarEmpty': 'Ожидаемых платежей нет.',
  'treasury.date': 'Дата',
  'treasury.in': 'Приход',
  'treasury.out': 'Расход',
  'treasury.net': 'Итого',
  'treasury.workingCapital': 'Оборотный капитал',
  'treasury.netWorkingCapital': 'Чистый оборотный капитал',
  'treasury.days': 'дн.',
  'treasury.dso': 'дней на сбор дебиторки',
  'treasury.dio': 'дней товар лежит на складе',
  'treasury.dpo': 'дней на оплату поставщикам',
  'treasury.ccc': 'цикл оборота денег',
  'nav.mySettings': 'Мои настройки',
  'mySettings.title': 'Мои настройки',
  'mySettings.telegram': 'Подключить Telegram',
  'mySettings.telegramHint': 'Уведомления приходят в этот чат: просроченные долги, товар на исходе, запросы на согласование.',
  'mySettings.notLinked': 'Telegram ещё не подключён — уведомления не приходят.',
  'mySettings.connect': 'Получить код',
  'mySettings.unlink': 'Отвязать',
  'mySettings.linkedAt': 'Подключено',
  'mySettings.codeTitle': 'Код подключения',
  'mySettings.codeExpires': 'Код действует {minutes} мин.',
  'mySettings.quietHours': 'Тихие часы',
  'mySettings.quietHoursHint': 'В этот промежуток сообщения не отправляются — придут утром.',
  'mySettings.quietEnabled': 'Включено',
  'mySettings.from': 'С',
  'mySettings.to': 'До',
  'mySettings.timezone': 'Часовой пояс',
  'treasury.transfer': 'Перевести деньги',
  'treasury.transferDo': 'Перевести',
  'treasury.fromAccount': 'Откуда',
  'treasury.toAccount': 'Куда',
  'treasury.amount': 'Сумма',
  'treasury.converts': '{from} → {to}: сумма конвертируется по дневному курсу.',
  'notif.title': 'Уведомления',
  'notif.readAll': 'Отметить все',
  'notif.empty': 'Новых сообщений нет',
  'dashboard.myKpi': 'Мои результаты',
  'dashboard.myKpiHint': 'Ваш план на месяц и его выполнение',
  'nav.dealerControl': 'Контроль дилеров',
  'dealerControl.title': 'Контроль дилеров',
  'dealerControl.subtitle': 'Дилер должен нам. Эти деньги ещё на его складе, в долгах его клиентов — или уже потеряны?',
  'dealerControl.gapTitle': 'Непокрытый риск',
  'dealerControl.gapBody': 'У {count} дилеров долг не покрыт. Всего: {amount}.',
  'dealerControl.owedToUs': 'Долг перед нами',
  'dealerControl.owedToUsHint': 'открытые счета',
  'dealerControl.customerDebt': 'Долг их клиентов',
  'dealerControl.customerDebtHint': 'дилер продал, деньги ещё не собраны',
  'dealerControl.stock': 'Товар на складе дилера',
  'dealerControl.stockHint': 'наш товар, ещё не продан',
  'dealerControl.atRisk': 'Дилеры в зоне риска',
  'dealerControl.atRiskHint': 'покрытия не хватает или есть сигнал',
  'dealerControl.board': 'Дилеры',
  'dealerControl.dealer': 'Дилер',
  'dealerControl.coverage': 'Покрытие',
  'dealerControl.gap': 'Разница',
  'dealerControl.signals': 'Статус',
  'dealerControl.open': 'Открыть',
  'dealerControl.lastSale': 'последняя продажа',
  'dealerControl.noSales': 'продаж нет',
  'dealerControl.empty': 'Дилеров нет',
  'dealerControl.emptyBody': 'После создания карточки дилера здесь появится его состояние.',
  'dealerControl.risk.ok': 'Норма',
  'dealerControl.risk.watch': 'Наблюдение',
  'dealerControl.risk.high': 'Риск',
  'dealerControl.signal.coverage_gap': 'Долг не покрыт',
  'dealerControl.signal.coverage_thin': 'Покрытие тонкое',
  'dealerControl.signal.overdue_heavy': 'Много просрочки',
  'dealerControl.signal.stock_idle': 'Товар не продаётся',
  'dealerControl.signal.no_customers': 'Нет клиентов',
  'dealerControl.customers': 'Клиенты дилера',
  'dealerControl.customersHint': 'Кто сколько должен — деньги здесь',
  'dealerControl.customer': 'Клиент',
  'dealerControl.debt': 'Долг',
  'dealerControl.overdue': 'Просрочено',
  'dealerControl.blocked': 'заблокирован',
  'dealerControl.noCustomers': 'Клиенты не внесены',
  'dealerControl.stockCard': 'Склад дилера',
  'dealerControl.stockCardHint': 'Наш товар — ещё не проданная часть',
  'dealerControl.noStock': 'Склад пуст или не внесён',
  'dealerControl.product': 'Товар',
  'dealerControl.qty': 'Кол-во',
  'dealerControl.value': 'Стоимость',

  // --- Статьи ДДС ---
  'nav.cashFlowItems': 'Статьи ДДС',
  'cfi.description':
    'Каждое движение денег привязывается к статье — отчёт ДДС строится именно на этой связи.',
  'cfi.code': 'Код',
  'cfi.codeHint': 'Заглавные буквы, цифры и дефис. Код потом не меняется.',
  'cfi.name': 'Название',
  'cfi.flowType': 'Раздел',
  'cfi.direction': 'Направление',
  'cfi.parent': 'Родительская статья',
  'cfi.parentNone': 'Корень (без родителя)',
  'cfi.transactions': 'Движения',
  'cfi.status': 'Статус',
  'cfi.system': 'Системная',
  'cfi.active': 'Активна',
  'cfi.archived.badge': 'В архиве',
  'cfi.new': 'Новая статья',
  'cfi.create': 'Добавить',
  'cfi.created': '{code} добавлена.',
  'cfi.saved': 'Изменения сохранены.',
  'cfi.archive': 'В архив',
  'cfi.archived': 'Статья отправлена в архив.',
  'cfi.empty': 'Статей нет',
  'cfi.loadError': 'Не удалось загрузить статьи',
  'cfi.flow.operating': 'Операционный',
  'cfi.flow.investing': 'Инвестиционный',
  'cfi.flow.financing': 'Финансовый',
  'cfi.flow.internal': 'Внутренний перевод',
  'cfi.dir.in': 'Приход',
  'cfi.dir.out': 'Расход',
  'cfi.dir.both': 'Оба',
  'cfi.dir.any': 'Не задано',
  'cfi.unclassifiedTitle': 'Есть движения без статьи',
  'cfi.unclassifiedBody':
    '{count} движений денег не привязаны к статье — в отчёте ДДС они попадают в строку «Без статьи».',
  'cfi.reclassify': 'Привязать',
  'cfi.reclassified': 'Привязано движений: {linked}.',
  'cfi.reclassifiedPartial':
    'Привязано {linked}, для {left} подходящая статья не найдена — их нужно привязать вручную.',
  'cfi.allClassified': 'Все движения денег привязаны к статьям.',
  'invoice.credits': 'Кредит-ноты',
  'invoice.creditsHint':
    'Эти документы уменьшают остаток счёта без оплаты: возврат товара, корректировка цены, скидка или списание долга.',
  // --- Спросить Alight ---
  'nav.aiAsk': 'Спросить Alight',
  'ai.description':
    'Задайте вопрос обычным языком. Откуда пришёл ответ — из базы или от модели — показано над ответом.',
  'ai.askTitle': 'Вопрос',
  'ai.question': 'Ваш вопрос',
  'ai.questionPlaceholder': 'Например: кто крупнейшие должники?',
  'ai.skill': 'Навык',
  'ai.skillAuto': 'Выбрать автоматически',
  'ai.skillHint':
    'Если выбрать навык, уровень ответа только ПОВЫШАЕТСЯ — качество растёт, цена тоже.',
  'ai.ask': 'Спросить',
  'ai.answer': 'Ответ',
  'ai.confidence': 'Уверенность',
  'ai.cost': 'Стоимость',
  'ai.model': 'Модель',
  'ai.tokens': 'Объём текста (вопрос / ответ)',
  'ai.usedTools': 'Использованные источники:',
  'ai.tier': 'Уровень',
  'ai.calls': 'Запросы',
  'ai.latency': 'Время',
  'ai.freeShare': 'Бесплатные ответы',
  'ai.monthBudget': 'Месячный бюджет',
  'ai.usageTitle': 'Мой расход',
  'ai.usagePeriod': '{from} — {to}',
  'ai.toolsTitle': 'Доступные мне источники',
  'ai.toolsHint':
    'AI читает только из этих источников, и они подобраны по вашим правам доступа.',
  'ai.notConfiguredTitle': 'Ключ AI не настроен',
  'ai.notConfiguredBody':
    'Вопросы всё равно работают: ответ берётся напрямую из базы (уровень L0). Для ответов модели нужен ключ.',
  'ai.budgetOutTitle': 'Бюджет исчерпан',
  'ai.budgetOutBody': 'Дневной или месячный лимит достигнут — ответы выдаются на уровне L0.',
  // --- Режим диалога ---
  'ai.chatPlaceholder': 'Напишите вопрос — например «как дела в бизнесе сегодня?»',
  'ai.send': 'Отправить',
  'ai.newChat': 'Новый диалог',
  'ai.thinking': 'Думает…',
  'ai.you': 'Вы',
  'ai.evo': 'Alight',
  'ai.sendHint': 'Enter — отправить, Shift+Enter — новая строка',
  'ai.starters': 'С чего начнём?',
  'ai.starter.today': 'Как дела в бизнесе сегодня?',
  'ai.starter.debts': 'Кто больше всех должен?',
  'ai.starter.stock': 'Какой товар заканчивается?',
  'ai.starter.profit': 'Сколько прибыли в этом месяце?',
  'ai.contextHint':
    'Диалог живёт только в этом окне — при обновлении страницы он исчезает и на сервере не хранится.',
  'ai.details': 'Подробности',
  'ai.sources': 'Источники',
  'ai.micStart': '🎤 Говорить',
  'ai.micStop': '⏹ Остановить',
  'ai.micListening': 'Слушаю… говорите, затем нажмите «Остановить».',
  'ai.micDenied':
    'Доступ к микрофону не разрешён. Нажмите на замок в адресной строке браузера и включите микрофон.',
  'ai.micError': 'Не удалось распознать речь. Попробуйте ещё раз или напишите вопрос.',
  'ai.speak': '🔊 Прослушать',
  'ai.speakPreparing': 'Готовится озвучка…',
  'ai.speakTruncated':
    'Ответ длинный — озвучено только начало, полный текст на экране.',
  'ai.speakStop': '⏹ Остановить',
  'ai.agents': 'Агенты — каждый даёт сводку по своей области',
  'ai.agentSources': 'источников: {count}',
  'ai.briefing': 'Сводка за день',
  'ai.briefingHint':
    'Деньги, долги, продажи, склад и риски — в одной короткой сводке. Готовится по одному нажатию.',
  // --- Шаблоны печати ---
  'nav.printTemplates': 'Шаблоны печати',
  'printTpl.description':
    'Бланки для клиента: счёт-фактура, накладная, кассовый ордер. Текст и реквизиты меняются здесь.',
  'printTpl.code': 'Код',
  'printTpl.name': 'Название',
  'printTpl.locale': 'Язык',
  'printTpl.paper': 'Бумага',
  'printTpl.size': 'Размер',
  'printTpl.updated': 'Изменён',
  'printTpl.default': 'Основной',
  'printTpl.body': 'Текст шаблона (HTML)',
  'printTpl.bodyHint':
    'Значения пишутся в {{скобках}}. Грамматика проверяется на сервере при сохранении — сломанный шаблон не принимается.',
  'printTpl.saved': 'Шаблон сохранён.',
  'printTpl.reset': 'Отменить несохранённые изменения',
  'printTpl.empty': 'Шаблонов нет',
  'printTpl.loadError': 'Не удалось загрузить шаблоны',
  // --- Оборотно-сальдовая ведомость и сверка ---
  'nav.accTrialBalance': 'Оборотно-сальдовая',
  'nav.accReconciliation': 'Сверка',
  'tb.title': 'Оборотно-сальдовая ведомость',
  'tb.description':
    'Начальное сальдо, обороты за период и конечное сальдо по каждому счёту. Итог по дебету должен равняться итогу по кредиту.',
  'tb.from': 'С даты',
  'tb.to': 'По дату',
  'tb.hideEmpty': 'Скрыть счета без движения',
  'tb.account': 'Счёт',
  'tb.accountCode': 'Код счёта',
  'tb.accountName': 'Наименование счёта',
  'tb.openingDebit': 'Нач. дебет',
  'tb.openingCredit': 'Нач. кредит',
  'tb.turnoverDebit': 'Оборот дебет',
  'tb.turnoverCredit': 'Оборот кредит',
  'tb.closingDebit': 'Кон. дебет',
  'tb.closingCredit': 'Кон. кредит',
  'tb.total': 'ИТОГО',
  'tb.empty': 'За этот период проводок нет',
  'tb.balanced': 'Дебет равен кредиту — ведомость сходится.',
  'tb.unbalancedTitle': 'Дебет НЕ равен кредиту',
  'tb.unbalancedBody':
    'Разница: {difference}. В таком состоянии ни одной цифре в таблице ниже доверять нельзя — сначала откройте сверку.',
  'recon.description':
    'Сходится ли учёт с операционной стороной. Это не отчёт, а диагностика: он отвечает на вопрос «можно ли доверять цифрам».',
  'recon.checks': 'Проверки',
  'recon.check': 'Проверка',
  'recon.ledger': 'В учёте',
  'recon.source': 'В операциях',
  'recon.difference': 'Разница',
  'recon.status': 'Статус',
  'recon.ok': 'Сходится',
  'recon.gap': 'Есть разница',
  'recon.allOk': 'Учёт полностью сходится с операционной стороной.',
  'recon.gapTitle': 'Есть разница между учётом и операциями',
  'recon.gapBody':
    'Очередь пуста, значит причина не в задержке. Посмотрите в таблице ниже, какая проверка не прошла.',
  'recon.pendingTitle': 'В очереди есть необработанные события',
  'recon.pendingBody':
    '{count} событий ещё не записаны в учёт — разница ЕСТЕСТВЕННА. Сначала разберите очередь.',
  'recon.drain': 'Разобрать очередь',
  'recon.drained': 'Записано в учёт: {posted}. Осталось в очереди: {remaining}.',
  'recon.cashTitle': 'Сверка кассы и банка',
  'recon.cashHint':
    'Каждый счёт сверяется в СВОЕЙ валюте: записанный остаток должен равняться сумме движений. Разница означает, что деньги двигались мимо ДДС.',
  'recon.account': 'Счёт',
  'recon.stored': 'Записанный остаток',
  'recon.computed': 'По движениям',
  // --- Корректировка склада ---
  'adj.new': 'Корректировка',
  'adj.create': 'Создать корректировку',
  'adj.created': '{docNo} создан — остаток изменится после утверждения.',
  'adj.reason': 'Причина',
  'adj.direction': 'Направление',
  'adj.increase': 'Найдены излишки (+)',
  'adj.decrease': 'Списание (−)',
  'adj.hint':
    'Корректировка — для одного конкретного случая: коробка разбита, товар найден, украден. Для пересчёта всего склада используйте инвентаризацию.',
  // --- Казначейство: сценарии и ожидаемые потоки ---
  'treasury.scenarios': 'Сценарии',
  'treasury.scenariosHint':
    'Один прогноз обещает «будет так» — и это всегда неправда. Три сценария ставят вопрос правильно: что будет, если клиенты задержат оплату?',
  'treasury.scenario': 'Сценарий',
  'treasury.scenario.base': 'Базовый',
  'treasury.scenario.conservative': 'Консервативный',
  'treasury.scenario.aggressive': 'Оптимистичный',
  'treasury.lowestDate': 'День минимума',
  'treasury.shortfall': 'Не хватит',
  'treasury.noGap': 'Хватает',
  'treasury.expectedInList': 'Ожидаемые поступления',
  'treasury.expectedInHint': 'По каким документам и сколько денег ждём в ближайшие 90 дней',
  'treasury.expectedOutList': 'Ожидаемые платежи',
  'treasury.expectedOutHint': 'По каким документам и сколько нужно заплатить в ближайшие 90 дней',
  'treasury.expectedTotal': 'Всего ожидается',
  'treasury.overdue': 'Просрочено',
  'treasury.expectedEmpty': 'В ближайшие 90 дней движений не ожидается',
  'treasury.doc': 'Документ',
  'treasury.party': 'Контрагент',
  'treasury.expectedDate': 'Ожидаемая дата',
  'mySettings.templates': 'Какие уведомления приходят',
  'mySettings.templatesHint':
    'Список только для информации: текст шаблона — системная настройка и действует на всех одинаково.',
  'mySettings.everyTime': 'приходит каждый раз',
  'mySettings.cooldown': 'повторно раз в {value}',
  'mySettings.days': '{n} дн.',
  'mySettings.hours': '{n} ч.',
  'mySettings.urgent': 'Срочное',
  'customer.telegram': 'Уведомления в Telegram',
  'customer.telegramHint':
    'Подтверждение оплаты уходит в Telegram клиента. Чтобы подключить чат, передайте клиенту код ниже — он отправит его боту.',
  'customer.telegramCode': 'Получить код',
  'customer.telegramExpires': 'Код действует {minutes} мин.',
  'fxRates.cbuImport': 'Загрузить из ЦБ',
  'fxRates.cbu.created': 'записан',
  'fxRates.cbu.updated': 'обновлён',
  'fxRates.cbu.unchanged': 'без изменений',
  'fxRates.cbu.kept': 'не тронут — задан вручную',
  'fxRates.cbu.locked': 'день закрыт',

  // --- Входящий груз ---
  'incoming.title': 'Входящий груз',
  'incoming.description':
    'Когда поставщик выписывает счёт, груз попадает в этот список. После прибытия товара вы его принимаете — только тогда он добавляется к остатку вашего склада.',
  'incoming.docNo': 'Документ',
  'incoming.issuedDate': 'Дата выписки',
  'incoming.statusCol': 'Статус',
  'incoming.total': 'Итого',
  'incoming.receivedAt': 'Принято',
  'incoming.lineCount': 'Строк',
  'incoming.status.pending': 'Ожидается',
  'incoming.status.received': 'Принято',
  'incoming.status.cancelled': 'Отменено',
  'incoming.filterStatus': 'Статус',
  'incoming.searchPlaceholder': 'Номер документа…',
  'incoming.loadError': 'Не удалось загрузить список входящих грузов',
  'incoming.empty': 'Пока нет ожидаемых грузов',
  'incoming.emptyHint':
    'Как только поставщик выпишет счёт, груз появится здесь сам — ничего запрашивать или создавать не нужно. Ранее пришедшие грузы смотрите в истории.',
  'incoming.emptyHistory': 'В этом статусе документов нет',
  'incoming.emptyHistoryHint':
    'Список показывает только документы выбранного статуса. Вернитесь к ожидаемым грузам, чтобы увидеть, что идёт сейчас.',
  'incoming.emptySearch': 'Документ не найден',
  'incoming.emptySearchHint':
    'Поиск работает по номеру документа. Проверьте номер или очистите поиск, чтобы увидеть весь список.',
  'incoming.showHistory': 'Посмотреть принятые',
  'incoming.showPending': 'Вернуться к ожидаемым',
  'incoming.lines': 'Состав груза',
  'incoming.linesHint':
    'Цена приходит из документа поставщика, и приход делается именно по ней — изменить её здесь нельзя.',
  'incoming.lineSku': 'Код',
  'incoming.lineName': 'Товар',
  'incoming.lineQty': 'Количество',
  'incoming.lineCost': 'Цена',
  'incoming.lineAmount': 'Сумма',
  'incoming.receiveTitle': 'Принять груз',
  'incoming.receiveHint':
    'Если товар прибыл, выберите, на какой из ваших складов он поступил. Количество и цена остаются как в документе.',
  'incoming.warehouse': 'Склад',
  'incoming.notes': 'Примечание',
  'incoming.notesHint':
    'Необязательно. Если оставить пустым, в складской записи будет указан номер документа.',
  'incoming.receiveSubmit': 'Принять',
  'incoming.receiveWarning':
    'После приёмки остаток и себестоимость меняются сразу; исправить это можно только обратным документом.',
  'incoming.received': '«{docNo}» принят — товар поступил на ваш склад.',
  'incoming.alreadyReceived':
    'Этот груз уже принят: товар на вашем складе и учтён в остатке.',
  'incoming.cancelledHint':
    'Документ отменён — принять его нельзя. Если товар пришёл, запросите у поставщика новый документ.',

  // --- Партнёрские организации ---
  'nav.partnerOrgs': 'Партнёрские организации',
  'porg.title': 'Партнёрские организации',
  'porg.description':
    'Партнёрская организация — клиент или дилер, который САМ торгует в этой программе: свой склад, свои цены, своя прибыль. Мы решаем только то, какие разделы ей открыты.',
  'porg.isolation':
    'Наши склады и отчёты им не видны: каждая организация видит только свои данные.',
  'porg.code': 'Код',
  'porg.name': 'Название',
  'porg.moduleCount': 'Разделы',
  'porg.userCount': 'Пользователи',
  'porg.status': 'Статус',
  'porg.active': 'Активна',
  'porg.inactive': 'Остановлена',
  'porg.createdAt': 'Дата открытия',
  'porg.empty': 'Партнёрских организаций нет',
  'porg.emptyHint':
    'Первую организацию откроете прямо здесь — код, администратор и пакет задаются в одной форме.',
  'porg.loadError': 'Не удалось загрузить организации',
  'porg.rowHint': 'Нажмите на строку — откроется пакет этой организации.',
  'porg.new': 'Новая организация',
  'porg.create': 'Открыть организацию',
  'porg.codeHint': 'Должен быть уникальным во всей базе и позже не меняется.',
  'porg.customerSection': 'Карточка клиента',
  'porg.customer': 'Клиент',
  'porg.customerHint':
    'Показывает, каким нашим клиентом является эта организация: долг и расчёты ведутся на той карточке, а выписанный нами счёт приходит к ним как уведомление о приходе на склад.',
  'porg.customerMissing': 'Не привязана',
  'porg.customerMissingWarning':
    'Карточка клиента не выбрана. Организация откроется и будет работать, но когда мы выпишем ей счёт, товар не попадёт на ИХ склад — ошибки при этом не будет, просто ничего не произойдёт. Карточку можно привязать позже.',
  'porg.supplyRequired':
    'В пакете организации, привязанной к карточке клиента, ОБЯЗАТЕЛЕН раздел «supply». При наличии привязки по каждому нашему счёту им пишется уведомление о поставке; если раздел закрыт, они его не увидят — груз пришёл, а экран пустой.',
  'porg.adminSection': 'Администратор',
  'porg.adminHint':
    'Первый пользователь организации. Остальных сотрудников он заводит сам — мы не вмешиваемся.',
  'porg.adminFullName': 'ФИО',
  'porg.adminEmail': 'Email',
  'porg.packageSection': 'Начальный пакет',
  'porg.created.title': 'Организация «{code}» открыта',
  'porg.password': 'Временный пароль',
  'porg.passwordWarning':
    'Этот пароль показывается здесь только ОДИН РАЗ — он нигде не сохраняется. После закрытия страницы получить его снова нельзя. Скопируйте сейчас и передайте администратору надёжным способом (лично или по телефону); не отправляйте письмом или в общий чат.',
  'porg.passwordLogin': 'Email для входа: {email}',
  'porg.openModules': 'Открыть пакет',

  'porg.modules.title': 'Пакет — какие разделы открыты',
  'porg.modules.note':
    'Этот список решает, какие разделы ВООБЩЕ существуют в той организации. А кто внутри раздела что видит — решают ИХ собственные роли; одно не заменяет другое.',
  'porg.modules.hint':
    'Коды разделов приходят из серверного каталога: они выводятся из списка прав, а не пишутся вручную.',
  'porg.modules.selected': 'Выбрано разделов: {count}',
  'porg.modules.permissions': 'прав: {count}',
  'porg.modules.emptyWarning':
    'Не выбран ни один раздел. Если сохранить так, организация войдёт в систему и не увидит ни одного раздела — останется пустой экран.',
  'porg.modules.save': 'Сохранить пакет',
  'porg.modules.saved': 'Пакет сохранён: открыто разделов — {count}.',
  'porg.modules.empty': 'Каталог пуст',
  'porg.modules.loadError': 'Не удалось загрузить каталог модулей',
  'porg.notFound': 'Организация не найдена',

  // --- Вход в организацию партнёра для просмотра ---
  'partnerView.enter': 'Войти и посмотреть',
  'partnerView.enterHint':
    'Данные организации открываются ТОЛЬКО ДЛЯ ЧТЕНИЯ, а сам визит записывается и в журнал этой организации.',
  'partnerView.enterFailed': 'Не удалось войти в организацию',
  'partnerView.banner.title': 'РЕЖИМ ПРОСМОТРА ПАРТНЁРСКОЙ ОРГАНИЗАЦИИ',
  'partnerView.banner.org': '{code} — {name}',
  'partnerView.banner.notYours': 'Данные на экране НЕ ВАШИ — они принадлежат этой организации.',
  'partnerView.banner.readOnly':
    'Только чтение: ничего нельзя записать, изменить или провести.',
  'partnerView.banner.audited': 'Этот визит записан в собственный журнал той организации.',
  'partnerView.banner.window': 'Окно просмотра: {window}. По истечении нужно войти заново.',
  'partnerView.exit': 'Выйти',
  'partnerView.expired':
    'Окно просмотра закончилось — вы вернулись в свою организацию. При необходимости войдите заново.',
};
